/* ARTMIE IT rewriter v1 (loop-safe) — generated 2026-05-14T19:21:33.106Z */
/*
   Translates SK→IT UI strings client-side for the Italia market.
   Activates when EITHER:
     - the URL path starts with /it-it/ (pre-cutover staging via subfolder), OR
     - the hostname matches artmie.it (post-DNS-cutover dedicated domain), OR
     - window.ArtmieIT === true (manual override for testing).

   Loop guard: pairs whose replacement contains the source are filtered out at runtime
   so we never recurse on a partial match.
*/
(function () {
  var __path = (window.location.pathname || '');
  var __host = (window.location.hostname || '');
  var pathMode = /^\/(it-it)(\/|$)/.test(__path);
  var hostMode = /(^|\.)artmie\.it$/i.test(__host);
  if (!pathMode && !hostMode && window.ArtmieIT !== true) return;

  document.documentElement.classList.add('it-market');
  document.documentElement.setAttribute('data-it-market', '1');

  /* FORCE_MARKET — ensure Shopify market context = IT when on subfolder.
     Skipped when on the dedicated domain since Shopify resolves the market by host. */
  function ensureMarket() {
    if (!pathMode) return;
    try {
      if (sessionStorage.getItem('artmie_it_market_set') === '1') return;
      var formData = new FormData();
      formData.append('form_type', 'localization');
      formData.append('_method', 'PUT');
      formData.append('country_code', 'IT');
      formData.append('language_code', 'it');
      formData.append('return_to', window.location.pathname);
      fetch('/localization', { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function () { sessionStorage.setItem('artmie_it_market_set', '1'); })
        .catch(function () {});
    } catch (e) {}
  }
  ensureMarket();

  /* CSS injection — hide app-store links sitewide (no IT app). */
  function injectCss() {
    if (document.getElementById('artmie-it-injected-css')) return;
    var s = document.createElement('style');
    s.id = 'artmie-it-injected-css';
    s.textContent = [
      'a[href*="apps.apple.com"]{display:none !important;}',
      'a[href*="itunes.apple.com"]{display:none !important;}',
      'a[href*="play.google.com"]{display:none !important;}',
      'a[href*="app.appsflyer.com"]{display:none !important;}',
      '.artmie-app-link-separator{display:none !important;}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }
  injectCss();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectCss);

  /* DOM hider — climb from any app-store link to a row container and hide it. */
  function hideAppBlocks() {
    var appLinks = document.querySelectorAll('a[href*="apps.apple.com"],a[href*="itunes.apple.com"],a[href*="play.google.com"],a[href*="app.appsflyer.com"]');
    for (var i = 0; i < appLinks.length; i++) {
      var el = appLinks[i];
      for (var j = 0; j < 6 && el && el.parentElement; j++) {
        el = el.parentElement;
        var tag = el.tagName && el.tagName.toLowerCase();
        var cls = (el.className && el.className.baseVal !== undefined) ? el.className.baseVal : (el.className || '');
        cls = String(cls);
        if (tag === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(cls)) {
          el.style.display = 'none';
          break;
        }
      }
    }
    var phrases = ["Stiahni si ARTMiE appku","Stiahni si ARTMIE appku","S aplikáciou doprava zdarma"];
    for (var k = 0; k < phrases.length; k++) {
      var p = phrases[k];
      var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue && t.nodeValue.indexOf(p) !== -1) {
          var node = t.parentElement;
          for (var m = 0; m < 6 && node && node.parentElement; m++) {
            var nc = node.className || '';
            nc = String(nc.baseVal !== undefined ? nc.baseVal : nc);
            var nt = node.tagName && node.tagName.toLowerCase();
            if (nt === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(nc)) {
              node.style.display = 'none';
              break;
            }
            node = node.parentElement;
          }
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideAppBlocks);
  else hideAppBlocks();
  setTimeout(hideAppBlocks, 500);
  setTimeout(hideAppBlocks, 1500);
  setTimeout(hideAppBlocks, 3000);

  /* URL prefix fix — only needed when on the subfolder (pre-cutover staging).
     On the dedicated domain (artmie.it) all internal /xxx links resolve correctly. */
  var MARKET_PREFIX = pathMode ? '/it-it' : '';
  var MARKET_PREFIX_RX = /^\/(it-it|sl-si|sk-si|de-de|de-at)(?:\/|$|\?|#)/;
  var SK_HOST_RX = /^https?:\/\/(www\.)?(app\.artmie\.sk|artmie\.sk|czartmie\.myshopify\.com)/i;
  var SKIP_PATH_RX = /^\/(cart|checkout|localization|account\/login|account\/register|account\/logout|password|wpm@|tools\/|s\/files\/|recommendations\/|search\/suggest|apps\/|api\/|services\/|admin)(\/|\?|$)/;
  function normaliseHref(h) {
    if (!h) return null;
    if (/^(mailto:|tel:|sms:|javascript:|#)/i.test(h)) return null;
    if (!pathMode) return null; /* on dedicated domain — no prefix rewriting needed */
    if (SK_HOST_RX.test(h)) {
      h = h.replace(SK_HOST_RX, '');
      if (h === '' || h === '/') h = '/';
    } else if (/^https?:/i.test(h)) {
      return null;
    }
    if (h.charAt(0) !== '/') return null;
    if (MARKET_PREFIX_RX.test(h)) return null;
    /* Fix accidental concat like '/it-itpages/...' */
    var fixedConcat = h.match(new RegExp('^\\/it-it([a-z])'));
    if (fixedConcat) return '/it-it/' + h.slice(6);
    if (SKIP_PATH_RX.test(h)) return null;
    if (h === '/') return MARKET_PREFIX + '/';
    var stripped = h.replace(/^\/(sk|it)(\/|$)/, '/');
    return MARKET_PREFIX + stripped;
  }
  function fixHrefPrefix() {
    if (!pathMode) return;
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var h = a.getAttribute('href');
      var newH = normaliseHref(h);
      if (newH && newH !== h) a.setAttribute('href', newH);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHrefPrefix);
  else fixHrefPrefix();
  setTimeout(fixHrefPrefix, 500);
  setTimeout(fixHrefPrefix, 1500);
  setTimeout(fixHrefPrefix, 3000);

  /* SK → IT text rewrites */
  var TEXT_REWRITES = {
  "Stolové, ateliérové, poľné": "Da tavolo, da studio, da campagna",
  "Späť na ": "Torna a ",
  "Späť do obchodu": "Torna al negozio",
  "Najnovšie články": "Ultimi articoli",
  "Zobraziť všetky": "Mostra tutti",
  "min čítania": "min di lettura",
  "Čítať článok": "Leggi l'articolo",
  "Čítať viac": "Leggi di più",
  "min. čítania": "min. di lettura",
  "čítania": "di lettura",
  "Všetko": "Tutto",
  "Hodnotenia zákazníkov": "Valutazioni dei clienti",
  "hodnoteni": "valutazioni",
  "hodnotení": "valutazioni",
  "Recenzie": "Recensioni",
  "recenzia": "recensione",
  "recenzií": "recensioni",
  "Napísať recenziu": "Scrivi una recensione",
  "Overená recenzia": "Recensione verificata",
  "Overena recenzia": "Recensione verificata",
  "Ďakujeme za tvoju recenziu": "Grazie per la tua recensione",
  "Tvoje hodnotenie": "La tua valutazione",
  "Podeľ sa o svoju skúsenosť": "Condividi la tua esperienza",
  "Pridať recenziu": "Aggiungi recensione",
  "Pridať do košíka": "Aggiungi al carrello",
  "Do košíka": "Al carrello",
  "DO KOŠÍKA": "AGGIUNGI AL CARRELLO",
  "Pridané do košíka": "Aggiunto al carrello",
  "Pridať všetky do košíka": "Aggiungi tutti al carrello",
  "Košík je prázdny": "Il carrello è vuoto",
  "Nákupný košík": "Carrello acquisti",
  "Košík": "Carrello",
  "v košíku": "nel carrello",
  "Zatvoriť": "Chiudi",
  "Zavrieť": "Chiudi",
  "Otvoriť": "Apri",
  "Zobraziť": "Mostra",
  "Zobraziť všetko": "Mostra tutto",
  "Zobraziť viac": "Mostra di più",
  "Zobraziť menej": "Mostra di meno",
  "Skryť": "Nascondi",
  "Späť": "Indietro",
  "Pokračovať": "Continua",
  "Pokračovať v nákupe": "Continua gli acquisti",
  "Pokračovať na pokladňu": "Procedi alla cassa",
  "Hľadať": "Cerca",
  "Vyhľadať": "Cerca",
  "Vyhľadávanie": "Ricerca",
  "Vymazať": "Cancella",
  "Vymazať všetko": "Cancella tutto",
  "Triediť": "Ordina",
  "Zoradiť": "Ordina",
  "Načítavanie": "Caricamento",
  "Načítavam": "Caricamento in corso",
  "Načítava sa": "Caricamento in corso",
  "Načítať viac": "Carica altro",
  "Popis": "Descrizione",
  "Vyberte": "Seleziona",
  "Vyberte si": "Seleziona",
  "Veľkosť": "Dimensione",
  "Farba": "Colore",
  "Materiál": "Materiale",
  "Značka": "Marca",
  "Skladom": "Disponibile",
  "Vypredané": "Esaurito",
  "Nedostupné": "Non disponibile",
  "Posledné kusy": "Ultimi pezzi",
  "Cena": "Prezzo",
  "Bežná cena": "Prezzo originale",
  "Vaša cena": "Il tuo prezzo",
  "Zľava": "Sconto",
  "Zľavnené": "Scontato",
  "Stiahni si aplikáciu": "Scarica l'app",
  "Prihlásenie": "Accesso",
  "Prihlásiť sa": "Accedi",
  "Odhlásiť sa": "Disconnetti",
  "Registrácia": "Registrazione",
  "Nová registrácia": "Nuova registrazione",
  "Registrovať sa": "Registrati",
  "Môj účet": "Il mio account",
  "Objednávky": "Ordini",
  "Nemáte účet": "Non hai un account",
  "Zoznam želaní": "Lista dei desideri",
  "Pokladňa": "Cassa",
  "Doručenie": "Consegna",
  "Súhrn objednávky": "Riepilogo ordine",
  "Medzisúčet": "Subtotale",
  "Prihlásiť sa na odber": "Iscriviti alla newsletter",
  "Odoberať novinky": "Iscriviti alle novità",
  "Najnovšie zľavy a inšpirácie": "Ultimi sconti e ispirazioni",
  "Súhlasím so spracovaním osobných údajov": "Acconsento al trattamento dei dati personali",
  "Nenechajte si ujsť": "Non lasciartelo sfuggire",
  "NENECHAJTE SI UJSŤ": "NON LASCIARTELO SFUGGIRE",
  "Pomoc a informácie": "Aiuto e informazioni",
  "O nás": "Chi siamo",
  "Kontaktujte nás": "Contattaci",
  "Sledujte nás": "Seguici",
  "SLEDUJTE NÁS": "SEGUICI",
  "Sme tu pre vás": "Siamo qui per te",
  "Odoslať": "Invia",
  "Poslať": "Invia",
  "Uložiť": "Salva",
  "Upraviť": "Modifica",
  "Pridať": "Aggiungi",
  "Odstrániť": "Rimuovi",
  "Zmazať": "Elimina",
  "Potvrdiť": "Conferma",
  "Zrušiť": "Annulla",
  "Áno": "Sì",
  "voliteľné": "opzionale",
  "povinné": "obbligatorio",
  "nepovinné": "non obbligatorio",
  "súbor": "file",
  "súbory": "file",
  "obrázok": "immagine",
  "telefón": "telefono",
  "správa": "messaggio",
  "odpovedať": "rispondi",
  "Tvoje meno": "Il tuo nome",
  "Tvoj email": "La tua email",
  "Fotka alebo video": "Foto o video",
  "Pri preprave bohužiaľ došlo": "Purtroppo si è verificato un problema durante il trasporto",
  "Ohodnoť tento produkt": "Valuta questo prodotto",
  "Stránkovanie": "Paginazione",
  "stránka": "pagina",
  "výsledkov": "risultati",
  "výsledok": "risultato",
  "Hodnotenia zakaznikov": "Recensioni dei clienti",
  "Hodnotenia zakazníkov": "Recensioni dei clienti",
  "Hodnotenia": "Recensioni",
  "Na základe": "Basato su",
  "Na zaklade": "Basato su",
  "zákazníkov": "clienti",
  "zákazník": "cliente",
  "pridať": "aggiungi",
  "Pridáva sa": "Aggiunta in corso",
  "pridáva sa": "aggiunta in corso",
  "kúpiť teraz": "acquista ora",
  "Kúpiť teraz": "Acquista ora",
  "KÚPIŤ TERAZ": "ACQUISTA ORA",
  "Nakup teraz": "Acquista ora",
  "na sklade": "disponibile",
  "Na sklade": "Disponibile",
  "NA SKLADE": "DISPONIBILE",
  "Nie je na sklade": "Non disponibile",
  "nie je na sklade": "non disponibile",
  "doručenie": "consegna",
  "doručenia": "della consegna",
  "pracovných dní": "giorni lavorativi",
  "pracovný deň": "giorno lavorativo",
  "Zákazník": "Cliente",
  "Zákaznícky servis": "Servizio clienti",
  "ZÁKAZNÍCKY SERVIS": "SERVIZIO CLIENTI",
  "Alternatívne Produkty": "Prodotti alternativi",
  "Alternatívne produkty": "Prodotti alternativi",
  "ALTERNATÍVNE PRODUKTY": "PRODOTTI ALTERNATIVI",
  "Alternatívny produkt": "Prodotto alternativo",
  "alternatívne": "alternativi",
  "zákaznícky servis": "servizio clienti",
  "Farby a médiá": "Colori e medium",
  "Plátna a papiere": "Tele e carta",
  "Štetce a pomôcky": "Pennelli e accessori",
  "Kreatívne potreby": "Articoli creativi",
  "Značky": "Marche",
  "Akryl, olej, akvarel": "Acrilico, olio, acquerello",
  "Na ráme, rolky, bloky": "Intelaiate, rotoli, blocchi",
  "Stolové, ateliérové, poľné": "Da tavolo, da studio, da campagna",
  "Zľavy až -80%": "Sconti fino al -80%",
  "Zľavy až": "Sconti fino a",
  "Akrylové, olejové, akvarelové": "Acrilici, a olio, acquerellabili",
  "Kreslenie a ilustrácia": "Disegno e illustrazione",
  "Sady, guľaté, ploché": "Set, tondi, piatti",
  "Živica, dekupáž, šperky": "Resina, decoupage, gioielli",
  "O tejto kategórii": "Informazioni su questa categoria",
  "O TEJTO KATEGÓRII": "INFORMAZIONI SU QUESTA CATEGORIA",
  "O kategórii": "Informazioni sulla categoria",
  "Doručenie do 1–2 pracovných dní": "Consegna in 2-3 giorni lavorativi",
  "Doručenie do 1-2 pracovných dní": "Consegna in 2-3 giorni lavorativi",
  "Doručenie do 1–2 dní": "Consegna in 2-3 giorni lavorativi",
  "Doručenie do 1-2 dní": "Consegna in 2-3 giorni lavorativi",
  "S Packeta od 2,10 € · Zdarma nad 49 €": "Con GLS da 6,99 € · Gratis sopra 75 €",
  "S Packeta od 2,10 €": "Con GLS da 6,99 €",
  "S Packeta od": "Con GLS da",
  "Zdarma nad 49 €": "Gratis sopra 75 €",
  "S aplikáciou doprava zdarma už od 45 €": "Spedizione gratuita sopra 75 €",
  "S aplikáciou doprava zdarma": "Spedizione gratuita",
  "100-dňové vrátenie bez udania dôvodu": "Reso entro 100 giorni senza indicarne il motivo",
  "100-dňové vrátenie": "Reso entro 100 giorni",
  "bez udania dôvodu": "senza indicarne il motivo",
  "Jednoducho a bez starostí": "Semplice e senza pensieri",
  "Dnes Doprava ZADARMO Od 49€": "Oggi spedizione GRATIS da 75 €",
  "Doprava ZADARMO Od 49€": "Spedizione GRATIS da 75 €",
  "Doprava ZADARMO Od 49 €": "Spedizione GRATIS da 75 €",
  "Doprava ZADARMO od 49€": "Spedizione GRATIS da 75 €",
  "Doprava ZADARMO od 49 €": "Spedizione GRATIS da 75 €",
  "doprava zadarmo od 49€": "spedizione gratis da 75 €",
  "Doprava ZADARMO": "Spedizione GRATIS",
  "DOPRAVA ZADARMO": "SPEDIZIONE GRATIS",
  "doprava zadarmo": "spedizione gratis",
  "Od 49€": "da 75 €",
  "od 49€": "da 75 €",
  "od 49 €": "da 75 €",
  "už od 49€": "da 75 €",
  "už od 49 €": "da 75 €",
  "ARTMIE Slovenija": "ARTMIE Italia",
  "ARTMiE.SK": "ARTMIE",
  "ARTMIE.SK": "ARTMIE",
  "info@artmie.sk": "info@artmie.it",
  "INFO@ARTMIE.SK": "INFO@ARTMIE.IT",
  "info@artmie.com": "info@artmie.it",
  "INFO@ARTMIE.COM": "INFO@ARTMIE.IT",
  "reklamacie@artmie.sk": "info@artmie.it",
  "reklamacie@artmie.com": "info@artmie.it",
  "artmie.sk": "artmie.it",

  /* phase-68 button rewrites */
  "Späť na menu": "Torna al menu",
  "Prejsť na obsah": "Vai al contenuto",
  "Prejsť na zoznam výsledkov": "Vai alla lista dei risultati",
  "Prejsť na ": "Vai a ",
  "Profil": "Profilo",
  "Ďalšie možnosti prihlásenia": "Altre opzioni di accesso",
  "Sociálne prihlásenie": "Accesso social",
  "Filtrovať podľa": "Filtra per",
  "Filtrovať": "Filtra",
  "položky": "articoli",
  "položiek": "articoli",
  "položka": "articolo",
  "Kúpiť": "Acquista",
  "Pokračujte v nákupe": "Continua lo shopping",
  "Pridať do zoznamu želaní": "Aggiungi alla lista dei desideri",
  "Pridať na zoznam želaní": "Aggiungi alla lista dei desideri",
  "Pokračovať k pokladni": "Procedi al pagamento",
  "Prejsť k pokladni": "Vai al pagamento",
  "Odhlásiť": "Esci",
  "Zaregistrovať": "Registrati",
  "Zaregistrovať sa": "Registrati",
  "Hľadať produkty": "Cerca prodotti",
  "Vypredan": "Esauri",
  "Množstvo": "Quantità",
  "Mnoz": "Quan",
  "Váš košík": "Il tuo carrello",
  "Váš košík je prázdny": "Il tuo carrello è vuoto",
  "Pokračovať do pokladne": "Procedi al pagamento",
  "Triediť podľa": "Ordina per",
  "Zoradiť podľa": "Ordina per",
  "Akcia": "Offerta",
  "Špeciálna cena": "Prezzo speciale",
  "Recenzia": "Recensione",
  "Prihlásiť sa na odber noviniek": "Iscriviti alla newsletter",
  "Zobraziť produkty": "Mostra prodotti",


  /* PHASE_109B_PATCHED — filter UI strings (moved inside object literal) */
  "FILTRE:": "FILTRI:",
  "FILTRE": "FILTRI",
  "Filtre:": "Filtri:",
  "Filtre": "Filtri",
  "filtre:": "filtri:",
  "filtre": "filtri",
  "Všetky": "Tutti",
  "všetky": "tutti",
  "VŠETKY": "TUTTI",
  "VYMAZAŤ VŠETKO": "CANCELLA TUTTO",
  "VYMAZAŤ": "CANCELLA",
  "vymazať všetko": "cancella tutto",
  "vymazať": "cancella",
  "TRIEDIŤ": "ORDINA",
  "ZORADIŤ": "ORDINA",
  "CENA": "PREZZO",
  "CENOVÉ ROZPÄTIE": "FASCIA DI PREZZO",
  "Cenové rozpätie": "Fascia di prezzo",
  "FARBA": "COLORE",
  "POUŽITIE": "UTILIZZO",
  "Použitie": "Utilizzo",
  "PRE KOHO": "PER CHI",
  "Pre koho": "Per chi",
  "ZNAČKA": "MARCA",
  "KRAJINA PÔVODU": "PAESE DI ORIGINE",
  "Krajina pôvodu": "Paese di origine",
  "BALENIE": "CONFEZIONE",
  "Balenie": "Confezione",
  "OBJEM": "VOLUME",
  "Objem": "Volume",
  "OBJEM/VÁHA": "VOLUME/PESO",
  "Objem/Váha": "Volume/Peso",
  "TYP": "TIPO",
  "Typ": "Tipo",
  "TVAR": "FORMA",
  "Tvar": "Forma",
  "VEĽKOSŤ": "DIMENSIONE",
  "MATERIÁL": "MATERIALE",
  "TECHNIKY": "TECNICHE",
  "Techniky": "Tecniche",
  "PRÍLEŽITOSŤ": "OCCASIONE",
  "Príležitosť": "Occasione",
  "DOSTUPNOSŤ": "DISPONIBILITÀ",
  "Dostupnosť": "Disponibilità",
  "ZĽAVA": "SCONTO",
  "AKCIA": "OFFERTA",
  "Mostra meno": "Mostra meno",
  "produktov": "prodotti",
  "kategórie": "categorie",
  "Kategórie": "Categorie",
  "KATEGÓRIE": "CATEGORIE",
  "Domov": "Home",
  "Bez ceny": "Senza prezzo",
  "Žiadne výsledky": "Nessun risultato",
  "Načítava sa…": "Caricamento…",
  "Načítava sa...": "Caricamento...",
};

  /* Loop guard: filter out pairs whose replacement contains the source */
  var TEXT_KEYS = Object.keys(TEXT_REWRITES)
    .filter(function (k) { return TEXT_REWRITES[k].indexOf(k) === -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function rewriteTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var t = node.nodeValue;
    if (!t || !/\S/.test(t)) return;
    var changed = false;
    for (var i = 0; i < TEXT_KEYS.length; i++) {
      var k = TEXT_KEYS[i];
      if (t.indexOf(k) === -1) continue;
      var rep = TEXT_REWRITES[k];
      var rx = new RegExp(k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
      var newT = t.replace(rx, rep);
      if (newT !== t) { t = newT; changed = true; }
    }
    if (changed) node.nodeValue = t;
  }

  function walkAndRewrite(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n; while ((n = w.nextNode())) rewriteTextNode(n);
    var ATTR_SELECTORS = ['[placeholder]', '[alt]', '[title]', '[aria-label]', 'input[type="submit"]', 'input[type="button"]', 'button'];
    var atrs = root.querySelectorAll ? root.querySelectorAll(ATTR_SELECTORS.join(',')) : [];
    for (var i = 0; i < atrs.length; i++) {
      var el = atrs[i];
      ['placeholder', 'alt', 'title', 'aria-label', 'value'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v) return;
        var nv = v;
        for (var j = 0; j < TEXT_KEYS.length; j++) {
          var k = TEXT_KEYS[j];
          if (nv.indexOf(k) === -1) continue;
          var rx = new RegExp(k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
          nv = nv.replace(rx, TEXT_REWRITES[k]);
        }
        if (nv !== v) el.setAttribute(a, nv);
      });
    }
  }

  function initialPass() {
    walkAndRewrite(document.body);
    /* PERF 2026-05-19: collapsed from 3 passes to 1 — most content is server-translated;
       the MutationObserver below picks up AJAX swaps. */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialPass);
  else initialPass();

  /* PERF FIX 2026-05-21: process only the nodes each mutation actually added, instead
     of re-walking the whole document.body. The old debouncedPass ran
     walkAndRewrite(document.body) — O(all text nodes x ~400 keys) — on every AJAX /
     web-component update, which froze big collections and many-variant product pages. */
  var pending = null;
  var rwQueue = [];
  function flushQueue() {
    pending = null;
    var nodes = rwQueue; rwQueue = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 1) {
        if (node.isConnected) walkAndRewrite(node);
      } else if (node.nodeType === 3) {
        rewriteTextNode(node);
      }
    }
    fixHrefPrefix();
  }
  function debouncedPass(mutations) {
    for (var mi = 0; mi < mutations.length; mi++) {
      var added = mutations[mi].addedNodes;
      for (var ai = 0; ai < added.length; ai++) {
        var n = added[ai];
        if (n.nodeType === 1 || n.nodeType === 3) rwQueue.push(n);
      }
    }
    if (rwQueue.length && !pending) pending = setTimeout(flushQueue, 300);
  }
  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 100); return; }
    try {
      var mo = new MutationObserver(debouncedPass);
      mo.observe(document.body, { childList: true, subtree: true /* PERF 2026-05-19: dropped characterData+attributes */ });
    } catch (e) {}
  }
  startObserver();

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href');
    var newH = normaliseHref(h);
    if (newH && newH !== h) a.setAttribute('href', newH);
  }, true);


  /* === phase-67-start === HANDLE LOCALIZATION === */
  var PAGE_HANDLES_IT = {
  "contact": "contatto",
  "zoznam-zelan": "lista-dei-desideri",
  "o-nas": "chi-siamo",
  "doprava-a-platba": "spedizione-e-pagamento",
  "casto-kladene-otazky-faq": "domande-frequenti-faq",
  "vseobecne-obchodne-podmienky": "termini-e-condizioni-generali",
  "pridaj-sa-do-timu-artmie": "unisciti-al-team-artmie",
  "kontakt": "contatto-1",
  "nase-zaruky": "le-nostre-garanzie",
  "kvalita-sluzieb-a-reklamacie": "qualita-del-servizio-e-reclami",
  "sposob-platby-a-dodanie": "metodi-di-pagamento-e-spedizione",
  "vymena-a-vratenie-tovaru": "cambio-e-reso-della-merce",
  "ako-vyplnit-reklamacny-formular": "come-compilare-il-modulo-di-reclamo",
  "spolupraca-a-velkoodber": "collaborazioni-e-vendite-allingrosso",
  "stan-sa-reziserom-svojho-umenia": "diventa-il-regista-della-tua-arte",
  "pravidla-artmie-bazarika": "regolamento-del-mercatino-artmie",
  "artmie-social-login-tos": "termini-di-servizio-del-login-social-artmie",
  "artmie-social-login-privacy-policy": "informativa-sulla-privacy-del-login-social-artmie",
  "gdpr-podmienky-ochrany-osobnych-udajov": "gdpr-informativa-sulla-protezione-dei-dati-personali",
  "zoznam-zelani": "lista-dei-desideri-1",
  "wishlist": "la-mia-lista-dei-desideri",
  "kontakt-de": "contatti",
  "wunschliste-de": "lista-dei-desideri-2",
  "ueber-uns-de": "chi-siamo-1",
  "versand-und-zahlung-de": "spedizione-e-pagamento-1",
  "haeufige-fragen-faq-de": "domande-frequenti-faq-1",
  "agb-de": "condizioni-generali-di-vendita",
  "karriere-de": "entra-a-far-parte-del-team-artmie",
  "unsere-garantien-de": "le-nostre-garanzie-1",
  "impressum-de": "note-legali",
  "service-und-reklamationen-de": "qualita-del-servizio-e-reclami-1",
  "zahlungs-und-lieferbedingungen-de": "condizioni-di-pagamento-e-consegna",
  "umtausch-und-ruecksendung-de": "cambio-e-reso",
  "reklamationsformular-hilfe-de": "come-compilare-il-modulo-di-reclamo-1",
  "kooperation-grosshandel-de": "cooperazione-e-vendita-allingrosso",
  "werde-zum-regisseur-deiner-kunst-de": "diventa-il-regista-della-tua-arte-1",
  "artmie-basar-regeln-de": "regolamento-del-bazar-artmie",
  "social-login-nutzungsbedingungen-de": "termini-e-condizioni-di-utilizzo-del-social-login-artmie",
  "social-login-datenschutz-de": "informativa-sulla-privacy-del-social-login-artmie",
  "datenschutz-de": "gdpr-normativa-sulla-protezione-dei-dati",
  "flits-wunschliste-de": "lista-dei-desideri-flits",
  "blog-de": "blog-4",
  "meine-wunschliste-de": "la-mia-lista-dei-desideri-1",
  "llms-txt": "llmstxt",
  "kontakt-at": "contatti-2",
  "wunschliste-at": "lista-dei-desideri-3",
  "ueber-uns-at": "chi-siamo-2",
  "versand-und-zahlung-at": "spedizione-e-pagamento-2",
  "haeufige-fragen-faq-at": "domande-frequenti-faq-2",
  "agb-at": "condizioni-generali-di-vendita-2",
  "karriere-at": "entra-a-far-parte-del-team-artmie-2",
  "unsere-garantien-at": "le-nostre-garanzie-2",
  "impressum-at": "note-legali-2",
  "service-und-reklamationen-at": "qualita-del-servizio-e-reclami-2",
  "zahlungs-und-lieferbedingungen-at": "condizioni-di-pagamento-e-consegna-2",
  "umtausch-und-ruecksendung-at": "cambio-e-reso-2",
  "reklamationsformular-hilfe-at": "come-compilare-il-modulo-di-reclamo-2",
  "kooperation-grosshandel-at": "collaborazione-e-vendita-allingrosso",
  "werde-zum-regisseur-deiner-kunst-at": "diventa-il-regista-della-tua-arte-2",
  "artmie-basar-regeln-at": "regole-per-il-mercatino-artmie",
  "social-login-nutzungsbedingungen-at": "condizioni-duso-del-social-login-artmie",
  "social-login-datenschutz-at": "informativa-sulla-privacy-del-social-login-artmie-2",
  "datenschutz-at": "protezione-dei-dati",
  "flits-wunschliste-at": "lista-dei-desideri-flits-2",
  "blog-at": "blog-5",
  "meine-wunschliste-at": "la-mia-lista-dei-desideri-2",
  "vsetky-blogy": "tutti-i-blog"
};
  var BLOG_HANDLES_IT = {
  "nase-znacky": "i-nostri-marchi",
  "artmie-nase-znacky": "artmie",
  "techniky-malby": "tecniche-pittoriche",
  "kreslenie-a-ilustracia": "disegno-e-illustrazione",
  "sprievodca-potrebami": "guida-ai-materiali-artistici",
  "diy-kreativne-projekty": "diy-e-progetti-creativi",
  "svet-umenia": "mondo-dellarte-e-ispirazione",
  "tvorenie-s-detmi": "creare-con-i-bambini",
  "novinky-a-komunita": "novita-e-community",
  "unsere-marken-de": "i-nostri-marchi-2",
  "artmie-marken-de": "mondo-dei-marchi-artmie",
  "maltechniken-de": "tecniche-pittoriche-2",
  "zeichnen-illustration-de": "disegno-e-illustrazione-2",
  "kuenstlerbedarf-ratgeber-de": "guida-ai-materiali-artistici-2",
  "diy-kreativprojekte-de": "diy-e-progetti-creativi-2",
  "kunstwelt-inspiration-de": "mondo-dellarte-e-ispirazione-2",
  "basteln-mit-kindern-de": "creare-con-i-bambini-2",
  "neuigkeiten-community-de": "novita-e-community-2",
  "neuigkeiten-community-at": "novita-e-community-3",
  "unsere-marken-at": "i-nostri-marchi-3",
  "artmie-marken-at": "mondo-dei-marchi-artmie-2",
  "maltechniken-at": "tecniche-pittoriche-3",
  "zeichnen-illustration-at": "disegno-e-illustrazione-3",
  "kuenstlerbedarf-ratgeber-at": "guida-ai-materiali-artistici-3",
  "diy-kreativprojekte-at": "diy-e-progetti-creativi-3",
  "kunstwelt-inspiration-at": "mondo-dellarte-e-ispirazione-3",
  "basteln-mit-kindern-at": "creare-con-i-bambini-3"
};
  var ARTICLE_HANDLES_IT = {
  "assemblage-vs-kolaz-aky-je-rozdiel-a-ako-tieto-techniky-kreativne-spojit": "assemblage-vs-collage-qual-e-la-differenza-e-come-combinare",
  "ako-malovat-na-sklo-akrylovymi-farbami-premena-sklenenych-predmetov-krok-za-krokom": "come-dipingere-sul-vetro-con-i-colori-acrilici-trasformazion",
  "tiitle-oilako-pouzivat-olejove-farby-media-impasto-techniky": "fondamenti-della-pittura-a-olio-come-usare-oli-e-medium-per",
  "ako-vytvorit-geometricke-umenie-s-texturou": "passo-dopo-passo-con-martin-horecny-come-creare-arte-geometr",
  "zatisie-a-perspektiva-objavuj-s-kazdym-tahom": "natura-morta-e-prospettiva-scopri-con-ogni-pennellata",
  "folk-kraslice-2": "guida-rapida-alle-uova-pasquali-folk-o-quando-sei-di-fretta",
  "ako-si-vybrat-stojan-1": "5-consigli-su-come-scegliere-il-cavalletto-giusto",
  "objav-novu-artmie-aplikaciu-tvoj-umelecky-pomocnik-vo-vrecku": "scopri-la-nuova-app-artmie-il-tuo-assistente-artistico-in-ta",
  "bezpecne-farebne-a-zabavne-preco-su-netoxicke-prstove-farby-mucki-idealne-pre-deti": "sicuri-colorati-e-divertenti-perche-i-colori-a-dita-atossici",
  "objav-sensory-art-so-sadami-okto": "scopri-la-sensory-art-con-i-set-okto",
  "detska-izba-snov-ako-vytvorit-detom-miesto-na-hranie-a-tvorivu-zabavu": "la-cameretta-dei-sogni-come-creare-uno-spazio-per-il-gioco-e",
  "tipy-na-tvorive-darceky-pre-deti": "consigli-per-regali-creativi-per-bambini",
  "malovanie-na-kamene-s-detmi-zabav-pocas-leta": "dipingiamo-con-i-bambini-sassi-allegri-e-colorati",
  "malovanie-s-detmi-kamene-ako-velkonocne-vajicka": "dipingere-con-i-bambini-sassi-come-uova-di-pasqua",
  "zabavte-sa-s-detmi-s-tekutymi-farbami-na-chodnik": "goditi-lestate-con-i-bambini-usando-i-gessetti-colorati-per",
  "stetce-pocity-nasleduj-svoju-ruku-a-svoje-srdce": "pennelli-emozioni-segui-la-tua-mano-e-il-tuo-cuore",
  "ako-si-vybrat-spravne-maliarske-platno-porovnanie-eko-bavlnenych-a-lanovych-platien": "come-scegliere-la-tela-giusta-confronto-tra-tela-eco-di-coto",
  "ako-pouzit-butter-paste-na-vytvorenie-uzasnej-textury-jednoduche-tipy-a-techniky": "come-usare-la-butter-pasta-per-creare-una-texture-sorprenden",
  "kuzlenie-s-farbami-jednoduchy-sposob-ako-vdychnut-strukturovacej-paste-zivot": "magia-con-i-colori-un-modo-semplice-per-dare-vita-alla-pasta",
  "jednoduchy-diy-navod-na-zivicove-privesky-vyrob-si-trblietave-darceky-doma": "guida-diy-semplice-per-ciondoli-in-resina-crea-regali-scinti",
  "ako-na-jemne-akvarelove-prechody-jednoduchy-trik-na-snove-pozadia": "come-ottenere-delicate-sfumature-ad-acquerello-un-trucco-sem",
  "ako-vytvorit-elegantne-reliefne-umenie-z-penovej-dosky-na-platne-navod-krok-za-krokom": "come-creare-unelegante-arte-in-rilievo-su-tela-con-pannelli",
  "pridaj-hlbku-vytvor-ocarujuce-3d-efekty-pomocou-sablonovej-farby-na-skle": "crea-incantevoli-effetti-3d-usando-il-colore-per-stencil-su",
  "letna-magia-akvarelu-malovanie-vonku-ako-nova-zaluba": "magia-estiva-dellacquerello-dipingere-allaperto-come-nuovo-h",
  "zmiesanie-praskajucej-pasty-s-akrylovou-farbou-co-sa-stane-ked-zlato-stretne-bielu": "mescolare-la-pasta-screpolante-con-il-colore-acrilico-cosa-s",
  "ako-si-doma-vyrobit-batikovanu-tasku-jednoduchy-navod-pre-kazdeho": "come-realizzare-una-borsa-batik-a-casa-una-guida-semplice-pe",
  "ako-spravne-drzat-maliarsku-paletu-jednoduchy-navod-pre-pohodlne-malovanie": "come-tenere-correttamente-la-tavolozza-da-pittore-guida-semp",
  "ako-ziskat-sytu-nepriehladnost-s-gvasom-prakticky-sprievodca-pre-kreativne-duse": "come-ottenere-una-coprenza-intensa-con-la-tempera-una-guida",
  "ako-blendovat-farby-stetcovymi-fixkami-jednoduche-ombre-efekty": "come-sfumare-i-colori-con-i-pennarelli-a-pennello-semplici-e",
  "ako-vytvorit-impasto-efekty-pomocou-farieb-gouache": "come-creare-effetti-impasto-con-i-colori-a-guazzo",
  "farebne-akordy-v-umeni-hra-s-harmoniou-na-tvojej-palete": "accordi-cromatici-nellarte-giocare-con-larmonia-sulla-tua-ta",
  "objavovanie-umeleckych-textur-maslova-pasta-vs-reliefna-pasta": "alla-scoperta-delle-texture-artistiche-con-martin-horecny-pa",
  "6-klucovych-veci-ktore-by-mal-kazdy-umelec-vediet-o-akrylovych-farbach": "sblocca-la-magia-6-cose-fondamentali-che-ogni-artista-dovreb",
  "sprievodca-pridanim-metalickych-akcentov-do-tvojho-umenia": "sblocca-la-lucentezza-guida-allaggiunta-di-accenti-metallici",
  "co-keby-si-si-zacala-pisat-dennik-prave-teraz": "e-se-iniziassi-a-scrivere-un-diario-proprio-ora",
  "artmiesk-je-vitazom-shoproku-2024-dakujeme-ze-ste-pri-nas": "abbiamo-vinto-shoproku-2024-ed-e-anche-merito-vostro",
  "objav-kuzlo-textury-so-strukturovacou-pastou": "scopri-la-magia-della-texture-con-la-pasta-strutturante",
  "vytvor-kreativny-odkaz-pre-svoje-buduce-ja": "crea-un-messaggio-creativo-per-il-tuo-io-futuro",
  "miesanie-akvarelovych-farieb": "mescola-gli-acquerelli-come-un-professionista-oltre-la-teori",
  "4-tekute-techniky-kreul-triton-liquid": "giocare-con-i-colori-acrilici-4-consigli-per-unire-in-modo-a",
  "valentinska-inspiracia-pre-kazdeho-tvorivca": "ispirazione-di-san-valentino-per-ogni-creativo",
  "vianocne-dekoracie-vyrobene-doma-5-tipov-na-originalne-vianocne-dekoracie": "5-consigli-per-decorazioni-natalizie-originali",
  "vianocne-ozdoby-z-papiera-kreativne-a-ekologicke-sviatocne-dekoracie": "decorazioni-natalizie-di-carta-decorazioni-festive-creative",
  "7-tvorivych-aktivit-na-dlhe-vecery": "buio-fuori-dalla-finestra-queste-7-attivita-renderanno-le-tu",
  "5-tipov-na-jesenne-tvorenie": "5-consigli-per-creazioni-autunnali",
  "vyhodnotenie-artmie-contest-2024": "valutazione-dellartmie-contest-2024-unesplosione-di-creativi",
  "servitkova-technika-co-je-dekupaz-a-ako-sa-robi": "tecnica-del-tovagliolo-cose-il-decoupage-e-come-si-fa",
  "miesanie-farieb-ukazeme-ti-ako-na-to": "mescolare-i-colori-ti-mostriamo-come-fare",
  "skicar-hahnemuhle-dennik-profesionalneho-umelca": "album-da-disegno-hahnemuhle-il-diario-di-un-artista-professi",
  "galeria-umelcov-rozhovor-s-barborou-sebes": "intervista-con-lartista-e-medico-barbora-sebes",
  "artmie-contest-2024-1": "artmie-contest-concorso-artistico-per-studenti-delle-scuole",
  "tvorime-s-metalickou-pastou-artmie-midas": "nuove-possibilita-con-la-pasta-metallica-liquida-artmie-mida",
  "zazi-euforiu-pri-tvorbe-svojho-diela": "prova-leuforia-mentre-crei-la-tua-opera",
  "daj-dielu-hlbku-artmie-butter-pastou": "dai-profondita-alla-tua-opera-con-la-pasta-artmie-butter",
  "artmie-novinky-2024": "il-2024-e-pieno-di-novita-artmie-quali-accoglieremo-per-prim",
  "kaligrafia-a-hand-lettering-preco-to-skusit": "calligrafia-e-hand-lettering-perche-provarci",
  "utajeny-sef-vali-to-prestrelil-doslova-ako-si-poradil-s-pracou-v-artmie": "il-capo-sotto-copertura-vali-ha-esagerato-letteralmente-come",
  "vieme-co-darovat-na-vianoce": "8-idee-regalo-per-un-artista",
  "malovana-kabelka-krok-za-krokom": "borsa-dipinta-passo-dopo-passo",
  "vymaluj-si-tekvicu-1": "come-dipingere-una-zucca-con-la-tecnica-zentangle",
  "ako-sme-premenili-stetec-na-maliarske-platno": "come-dipingere-un-ritratto-su-un-pennello-consigli-su-superf",
  "artmieskblogsprievodca_olejovymi_pastelmi": "introduzione-al-mondo-dei-pastelli-a-olio-guida-completa-per",
  "11-praktickych-rad-pri-tvorbe-plaster-art-so-strukturnou-pastou": "11-consigli-pratici-per-creare-plaster-art-con-pasta-struttu",
  "kreslenie-ceruzkou-prva-cast": "disegno-a-matita-consigli-per-principianti-ed-esperti",
  "plaster-art-v-artmie-horuci-trend-sme-vyskusali-na-vlastnej-kozi": "plaster-art-da-artmie-abbiamo-provato-in-prima-persona-quest",
  "ako-na-akrylove-farby": "come-usare-i-colori-acrilici-vantaggi-consigli-e-suggeriment",
  "od-skicovania-k-malovaniu-akrylove-fixy-kreul-triton-s-tebou-udrzia-tempo": "dallo-schizzo-alla-pittura-i-pennarelli-acrilici-kreul-trito",
  "nakresli-si-s-nami-snezienky-artmie": "disegna-con-noi-dei-bucaneve-artmie",
  "ako-nakreslit-nadherneho-motyla": "come-disegnare-una-bellissima-farfalla",
  "nauc-sa-malovat-gvasovymi-farbami": "come-dipingere-con-la-tempera-super-consigli-da-artmie",
  "vytvor-obraz-technikou-pouring": "la-tua-guida-alla-tecnica-pouring-art",
  "ako-si-vytvorit-moderne-nausnice-s-polymerovej-hmoty": "come-creare-orecchini-moderni-con-pasta-polimerica",
  "tajny-jazyk-malby": "il-linguaggio-segreto-della-pittura-come-leggere-unopera-dar",
  "ako-pozlatit-ci-patinovat-dielo": "come-dorare-o-patinare-unopera",
  "ako-na-umenie-kaligrafie-ci-ako-si-zlepsit-krasopis": "come-approcciarsi-allarte-della-calligrafia-o-come-migliorar",
  "10-dovodov-preco-by-ste-mali-zacat-s-mixed-media-technikou": "10-motivi-per-cui-dovresti-iniziare-con-la-tecnica-mixed-med",
  "ako-malovat-gvasovymi-farbami": "come-dipingere-con-i-colori-a-tempera",
  "ako-malovat-atramentmi": "come-dipingere-con-gli-inchiostri",
  "objav-najlepsie-farebne-komba-v-malovani": "scopri-le-migliori-combinazioni-di-colori-nella-pittura",
  "shoproku2022": "e-arrivato-il-concorso-shoproku-meritiamo-di-vincere-anche-q",
  "pexeso-z-platna": "cosa-fare-con-una-tela-strappata-memory-game-creativo",
  "inktober-artmie-2022": "partecipa-allinktober-con-artmie",
  "handmade-dekorativne-sviecky-vyrob-si": "fai-da-te-candele-decorative-con-piante",
  "v-kreul-tovarni-na-farby": "dai-unocchiata-insieme-a-noi-alla-fabbrica-kreul",
  "ako-nakreslit-postavu-navod": "come-disegnare-una-figura-guida",
  "malujeme-izbove-rastliny-akvarelovymi-farbami-van-gogh": "magie-con-gli-acquerelli-van-gogh-piante-da-appartamento",
  "podlahni-scrapbookingu-1": "scopri-i-segreti-dello-scrapbooking-come-creare-opere-darte",
  "voskove-obrusky-na-potraviny-vyrob-si": "fai-da-te-tovaglioli-di-cera-per-alimenti",
  "ako-pouzit-washi-pasky-artmie": "8-modi-per-usare-il-nastro-washi-artmie",
  "relaxacne-omalovanky-pre-dospelych-sablony-vo-vnutri": "libri-da-colorare-rilassanti-per-adulti-basta-stampare-e-col",
  "domace-vonave-mydlo-vyrob-si": "fai-da-te-sapone-profumato-fatto-in-casa",
  "makrame-dekoracia-zo-spagatu-vyrob-si": "fai-da-te-decorazione-in-macrame-con-spago",
  "tvor-kvalitne-pomocou-lanoveho-platna-museal": "crea-con-qualita-come-i-vecchi-maestri-usando-la-tela-di-lin",
  "obraz-z-klicekov-a-bavlnky-drevena-dekoracia": "quadro-con-chiodi-e-filo-crea-una-decorazione-originale",
  "vyrob-si-kvety-z-krepoveho-papiera": "fai-da-te-fiori-di-carta-crespa",
  "ako-zacat-so-scrapbookingom": "come-iniziare-con-lo-scrapbooking",
  "kliny-na-platno-ako-ich-pouzit-a-kedy": "cunei-per-tela-come-usarli-e-quando",
  "farba-mesiaca-maj-svetloruzova": "colore-del-mese-di-maggio-rosa-chiaro",
  "linoryt-pre-zaciatocnikov-ako-si-vyrobit-peciatku": "linoleografia-per-principianti-come-realizzare-un-timbro",
  "farba-mesiaca-april-voskova-zlta": "colore-del-mese-di-aprile-giallo-cera-2022",
  "vyrob-si-velkonocne-vajicko-zdobene-zlatom-2022": "fai-da-te-uovo-di-pasqua-decorato-con-oro-2022",
  "vyrob-si-velkonocne-vajicka-s-trblietkami": "fai-da-te-uova-di-pasqua-con-glitter",
  "vyrob-si-velkonocne-vajicka-zdobene-susenymi-kvetmi": "fai-da-te-uova-di-pasqua-decorate-con-fiori-secchi",
  "vyrob-si-velkonocne-vajicko-s-prekvapenim": "fai-da-te-uovo-di-pasqua-con-sorpresa",
  "vyrob-si-hackovane-velkonocne-vajicka": "fai-da-te-uova-di-pasqua-alluncinetto",
  "3-napady-na-velkonocne-tvorenie-2022": "3-idee-per-creazioni-pasquali-2022",
  "vyrob-si-budka-pre-vtaciky": "fai-da-te-casetta-per-uccellini",
  "kviz-o-akvarelovych-farbach": "quiz-sugli-acquerelli",
  "handmade-taska-z-umelej-koze": "fai-da-te-borsa-fatta-a-mano-in-ecopelle",
  "farba-mesiaca-marec-oranzova": "colore-del-mese-di-marzo-arancione",
  "ako-pouzivat-spachtle-malujeme-jarnu-luku": "come-usare-le-spatole-dipingiamo-un-prato-primaverile",
  "5-sposobov-ako-namalovat-macku": "5-modi-per-dipingere-un-gatto",
  "ako-zacat-s-akrylovymi-farbami": "come-iniziare-con-i-colori-acrilici",
  "farba-mesiaca-februar-ladova-matova": "colore-del-mese-di-febbraio-verde-menta-ghiacciato",
  "co-na-valentina-5-filmov-s-umeleckym-nadychom": "cosa-regalare-a-san-valentino-5-film-dal-tocco-artistico-che",
  "vyrob-si-ekologicka-nakupna-taska": "fai-da-te-borsa-della-spesa-ecologica",
  "farba-mesiaca-januar-indigo": "colore-del-mese-di-gennaio-indaco",
  "pozname-farbu-na-rok-2022": "conosciamo-il-colore-dellanno-2022",
  "ako-dopadol-artmie-inktober-2021": "come-andato-lartmie-inktober-2021",
  "ako-vytvorit-dekoracie-na-halloween": "come-creare-decorazioni-per-halloween",
  "posledny-tyzden-artmie-inktobra-pred-nami": "lultima-settimana-dellartmie-inktober-e-davanti-a-noi",
  "vytvorme-si-krasnu-dekoraciu-na-halloween": "crea-una-bellissima-decorazione-per-halloween",
  "artmie-inktober-temy-pocas-stvrteho-tyzdna": "artmie-inktober-temi-della-quarta-settimana",
  "artmie-inktober-co-prinesie-treti-tyzden": "artmie-inktober-cosa-portera-la-terza-settimana",
  "artmie-inktober-temy-v-druhom-tyzdni": "artmie-inktober-temi-della-seconda-settimana",
  "artmie-inktober-inspirujeme-vas-aj-seba": "artmie-inktober-ispiriamo-voi-e-noi-stessi",
  "inktober-vyzva-ktora-spaja-umelcov-po-celom-svete": "inktober-la-sfida-che-unisce-gli-artisti-di-tutto-il-mondo",
  "ako-zaramovat-papier-aby-sa-nevlnil": "come-evitare-che-la-carta-si-imbarchi-nella-cornice",
  "terminy-z-umeleckeho-sveta-ktore-ti-rozsiria-obzory": "termini-del-mondo-dellarte-che-amplieranno-i-tuoi-orizzonti",
  "10-filmov-o-umelcoch-ktore-musis-vidiet": "10-film-sugli-artisti-che-devi-assolutamente-vedere",
  "bodka-za-letom-oceanova-modra": "un-punto-sullestate-blu-oceano",
  "ako-si-vytvorit-sviecku-so-stojanom": "come-creare-una-candela-con-supporto",
  "malba-v-pleneri-podme-spolu-objavit-krasy-prirody": "pittura-en-plein-air-scopriamo-insieme-le-bellezze-della-nat",
  "sutaz-pre-umelcov-eaa-je-tento-rok-plna-pozitivnej-energie": "il-concorso-per-artisti-eaa-questanno-e-pieno-di-energia-pos",
  "farba-mesiaca-zlata": "colore-del-mese-di-luglio-oro",
  "v-sulade-s-prirodou-umenie-ekologicky-a-tvorivo": "in-armonia-con-la-natura-arte-in-modo-ecologico-e-creativo",
  "farby-na-rok-2021-sk": "colori-per-lanno-2021",
  "tipy-na-mesta-ktore-v-tebe-prebudia-kreativitu": "non-sai-cosa-dipingere-queste-citta-risveglieranno-la-tua-cr",
  "stante-sa-hviezdou-halloweenskeho-vecierka-s-farbami-snazaroo": "risplendi-alla-festa-di-halloween-con-i-colori-per-il-viso-s",
  "podte-sa-s-nami-pozriet-na-vyrobu-stetcov-priamo-do-dielne-da-vinci": "quando-parliamo-dei-prodotti-da-vinci-parliamo-sempre-di-pro",
  "spoznajte-caro-prace-s-olejovymi-farbami": "scopri-il-fascino-di-lavorare-con-i-colori-a-olio",
  "malovanie-podla-cisel-je-zabava": "prova-il-successo-di-questanno-dipingere-con-i-numeri",
  "eaa-2020-v-znameni-prirody": "il-concorso-internazionale-eaa-e-gia-iniziato-iscrivi-anche",
  "olejove-farby-vlastnosti-a-zakladne-pigmenty": "colori-a-olio-caratteristiche-e-pigmenti-di-base",
  "ako-zacat-s-olejovymi-farbami": "orientati-nel-mondo-dei-colori-a-olio-con-noi",
  "ako-malovat-krajinku-navod": "come-dipingere-un-paesaggio-guida",
  "co-vsetko-dokazu-artmie-spachtle": "crea-magie-sulla-tela-cosa-possono-fare-le-varie-spatole-art",
  "ako-na-originalny-kuchynsky-riad": "come-realizzare-stoviglie-originali",
  "ako-opravit-maliarske-platno": "come-riparare-una-tela-da-pittura-ammaccata",
  "ako-namalovat-kvet-akvarelom": "come-dipingere-fiori-con-lacquerello",
  "vytvor-si-velkonocne-dekoracie": "come-realizzare-decorazioni-pasquali-semplici-ma-deffetto",
  "co-tvorit-pocas-karanteny": "cosa-fare-a-casa-durante-la-quarantena-abbiamo-consigli-per",
  "ako-zvladnut-karantenu-s-detmi-5-tipov": "5-consigli-per-gestire-la-quarantena-a-casa-con-i-bambini",
  "poraz-nudu-tvorenim": "creare-elimina-lo-stress-metti-a-tuo-agio-te-stesso-e-la-tua",
  "artmie-vitaz-shoproku2019": "abbiamo-vinto-il-premio-shoproku-2019",
  "deti-doma-kvoli-karantene-kreativne-ich-zabavte": "bambini-a-casa-per-il-coronavirus-sappiamo-come-tenerli-occu",
  "ako-jednoducho-namalovat-ruzu": "come-dipingere-una-rosa-in-modo-semplice",
  "aky-vsestranny-je-akryl-solo-goya-triton": "quanto-e-versatile-lacrilico-solo-goya-triton",
  "ako-zlepsit-svoje-umelecke-zrucnosti-10-tipov": "come-migliorare-le-proprie-abilita-artistiche-10-consigli",
  "ako-miesat-akrylove-faby": "come-mescolare-i-colori-acrilici",
  "malovanie-na-textil-ta-uchvati": "la-pittura-su-tessuto-ti-conquistera",
  "ako-pracovat-s-akrylom": "come-lavorare-con-lacrilico",
  "ako-si-vybrat-akrylove-farby-podla-viskozity": "come-scegliere-i-colori-acrilici-in-base-alla-viscosita",
  "ako-si-vybrat-spravnu-velkost-stetca": "come-scegliere-la-giusta-dimensione-del-pennello",
  "ako-na-vianocny-obraz": "come-creare-un-quadro-natalizio-originale",
  "s-cim-maluje-gerhard-richter": "i-colori-a-olio-e-il-segreto-del-successo-di-gerhard-richter",
  "napinacie-listy-ram": "crea-un-telaio-per-seta-con-i-listelli-tenditori",
  "ako-na-sketchbook-zosit": "come-iniziare-uno-sketchbook",
  "malovanie-podla-cisel-trend": "da-dove-nasce-la-pittura-con-i-numeri",
  "farby-svietiace-v-tme-1": "10-consigli-su-come-dipingere-con-colori-che-si-illuminano-a",
  "preco-malovat-akrylom": "5-motivi-per-dipingere-con-lacrilico-invece-che-con-i-colori",
  "ako-malovat-s-farbami-na-textil": "come-dipingere-su-tessuto",
  "spravne-platno-pre-mna": "come-scegliere-una-tela",
  "tvorenie-s-pouring-mediom": "colata-di-colori-acrilici-armonia-nel-flusso",
  "co-darovat-zene-na-mdz": "cosa-regalare-a-una-donna-per-la-festa-della-donna",
  "farba-roka-2019-ako-ju-kombinovat": "colore-dellanno-2019-sulla-tela-e-sulle-scarpe-da-ginnastica",
  "ako-malovat-na-sklenenu-vazu": "come-dipingere-un-vaso-di-vetro",
  "dovody-preco-randit-s-umelcom": "6-motivi-per-uscire-con-un-artista",
  "techniky-malovania-do-vrecka": "quali-tecniche-pittoriche-dovresti-avere-nel-sangue",
  "akrylove-fixky-amsterdam": "perche-i-pennarelli-amsterdam-sono-i-migliori",
  "malovanie-na-sklo-vianoce": "tendenze-magiche-per-dipingere-su-vetro",
  "malovanie-s-detmi": "dipingere-con-i-bambini-un-natale-creativo",
  "vianocne-tipy-na-darcek-pre-umelca": "il-natale-si-avvicina-cosa-regalare-a-un-artista",
  "co-je-freska": "cose-laffresco",
  "tipy-pre-umelecky-atelier": "6-consigli-per-uno-studio-pieno-di-armonia-e-liberta",
  "oranzova-farba-akrylova-akvarelova-olejova": "arancione-un-colore-da-non-sottovalutare",
  "urban-skicovanie-do-ulic-s-perom-a-stetcom": "urban-sketching-in-strada-con-penna-e-pennello",
  "exterierove-farby-streetart": "ci-ha-colpito-la-pop-art-svelata-dopo-30-anni",
  "kreslit-s-copic-markermi": "crea-manga-e-fumetti-con-i-marker-copic",
  "spachtlova-technika-impasto": "prova-la-tecnica-a-spatola",
  "sietotlac-a-andy-warhol": "i-segreti-creativi-di-andy-warhol",
  "ako-vyrobit-keramicke-hrnceky-modelarska-hlina-mramorovanie": "fai-da-te-tazze-in-ceramica-con-una-colata-arcobaleno",
  "prve-dojmy-akvarelove-farby-white-nights-landscape-set": "non-temere-lacquerello-prime-impressioni-sugli-acquerelli-wh",
  "kreslenie-ceruzkou-od-teorie-k-praxi": "disegno-a-matita-dalla-teoria-alla-pratica",
  "kreslime-ceruzkou-nauc-sa-techniky-kreslenia": "disegniamo-a-matita-impara-le-tecniche-di-disegno",
  "rasto-ekkert-ako-zacat": "rasto-ekkert-gli-inizi-sono-difficili-ma-trovare-la-propria",
  "jarny-vidiecky-veniec": "fai-da-te-corona-primaverile-in-stile-country",
  "co-je-to-grafika": "che-cose-la-grafica",
  "malovanie-na-hodvab": "dipingere-su-seta-fa-miracoli-scoprilo-con-noi",
  "umelecka-mapa": "mappa-artistica-delleuropa-sai-quale-artista-rappresenta-la",
  "ako-si-vybrat-spravny-akvarelovy-papier": "come-scegliere-la-carta-per-acquerello-giusta",
  "ako-sa-odhaluje-zahadna-dama-v-cervenom": "il-fascino-del-restauro",
  "prekrasne-sklenene-plastiky-v-kmenoch-stromov": "splendide-sculture-in-vetro-nei-tronchi-dalbero",
  "plnime-farebne-umelecke-sny": "realizziamo-sogni-artistici-a-colori",
  "ked-stromy-hovoria-navod-na-malovane-dekoracie-z-dreva": "quando-gli-alberi-parlano-guida-alle-decorazioni-dipinte-su",
  "svetlostalost": "come-migliorare-la-resistenza-alla-luce-dei-dipinti",
  "batikovanie": "come-il-batik-ha-cambiato-il-mio-mondo-in-bianco-e-nero",
  "uhadni-cim-kreslim": "indovina-con-cosa-sto-disegnando",
  "vedci-vynasli-novy-odtien-modrej-vies-ako-sa-vola": "gli-scienziati-hanno-inventato-una-nuova-tonalita-di-blu-sai",
  "unikatna-snimka-olejomalby-z-filmu-loving-vincent": "uno-scatto-unico-di-un-dipinto-a-olio-dal-film-loving-vincen",
  "duhove-glazury-na-keramike-umelecka-dielna-briana-giniewskiho": "smalti-arcobaleno-sulla-ceramica-il-laboratorio-artistico-di",
  "ktore-platno-je-lepsie-bavlnene-alebo-lanove": "quale-tela-e-migliore-per-voi-cotone-o-lino",
  "ako-natiahnut-platno-na-ram": "se-volete-tendere-la-tela-su-un-telaio-cosa-dovete-sapere",
  "efekt-hrdze-kreativna-tvorba": "m-effetto-ruggine-un-tempo-elemento-indesiderato-oggi-benven",
  "kolko-vies-o-anatomii-malovacich-stetcov": "quanto-ne-sapete-sullanatomia-dei-pennelli",
  "6-veci-ktere-pomaly-nicia-vase-stetce": "6-cose-che-stanno-lentamente-distruggendo-i-vostri-pennelli",
  "vedeli-ste-uz-o-olejovych-farbach-rieditelnych-vodou": "sapevate-gia-degli-oli-diluibili-in-acqua",
  "najznamensite-diela-pabla-picassa": "le-opere-piu-famose-di-pablo-picasso",
  "co-je-to-operacia-nocna-hliadka-a-preco-je-dolezita": "cose-loperazione-ronda-di-notte-e-perche-e-importante",
  "kreativna-nezvycajna-kombinacia-tus-a-olejove-pastely": "una-combinazione-creativa-e-insolita-inchiostro-e-pastelli-a",
  "viete-naozaj-vsetko-o-polynernej-hmote": "sai-davvero-tutto-sulla-pasta-polimerica",
  "efekt-hrdze-kedysi-neziaduci-teraz-vitany": "effetto-ruggine-un-tempo-indesiderato-ora-un-effetto-ricerca",
  "skusili-ste-uz-roztok-na-express-transfer": "hai-gia-provato-la-soluzione-per-il-trasferimento-express",
  "hura-do-skoly-maliarske-potreby-pre-malych-aj-velkych": "tutti-a-scuola-articoli-per-belle-arti-per-piccoli-e-grandi",
  "co-je-pre-vas-lepsie-bavlnene-alebo-lanove-platno": "cosa-e-meglio-per-te-tela-di-cotone-o-di-lino",
  "scrapbooking-napady-a-priklady": "scrapbooking-idee-ed-esempi",
  "diy-drevena-dekoracia-navod-na-tvorenie-s-klincami": "decorazione-in-legno-fai-da-te-guida-alla-creazione-con-i-ch",
  "co-vies-o-anatomii-stetcov-na-malovanie": "cosa-sai-sullanatomia-dei-pennelli",
  "farby-na-olej-riedene-vodou": "conosci-i-colori-a-olio-diluibili-con-acqua",
  "ktore-su-lepsie-prirodne-stetce-alebo-synteticke": "quali-sono-migliori-pennelli-naturali-o-sintetici",
  "co-viete-o-polynernej-hmote": "cosa-sai-sulla-pasta-polimerica",
  "kolko-viete-o-anatomii-stetcov": "quanto-ne-sai-sullanatomia-dei-pennelli",
  "mozno-neviete-ze-akrylove-farby-maju-tieto-vlastnosti": "forse-non-sai-che-i-colori-acrilici-hanno-queste-proprieta",
  "eaa-2021-rozhovor-s-porotou-bulharsko": "eaa-2021-intervista-con-la-giuria-bulgaria",
  "co-su-a-na-co-sluzia-akrylove-strukturove-pasty": "cosa-sono-e-a-cosa-servono-le-paste-strutturanti-acriliche",
  "ako-spravne-cistit-stetce-po-malovani": "come-pulire-correttamente-i-pennelli-dopo-aver-dipinto",
  "najdrahsie-obrazy-na-svete": "i-quadri-piu-costosi-al-mondo",
  "5-tipov-ako-urobit-tvoj-obraz-bohatsim": "5-consigli-per-rendere-il-tuo-quadro-piu-ricco",
  "co-su-akrylove-strukturalne-pasty-a-na-co-sluzia": "cosa-sono-le-paste-strutturanti-acriliche-e-a-cosa-servono",
  "poznate-vsetky-tajomstva-pouring-techniky": "conosci-tutti-i-segreti-della-tecnica-pouring",
  "tvorba-umenia-z-roztaveneho-skla-a-dreva-unikatne-umenie-slagermana-a-fishmana": "creare-arte-con-vetro-fuso-e-legno-larte-unica-di-slagerman",
  "muzeum-pigmentov-harvard-umenie": "sapevi-che-esiste-un-museo-dei-pigmenti",
  "co-je-pre-teba-lepsie-prirodne-alebo-synteticke-stetce": "cosa-e-meglio-per-te-pennelli-naturali-o-sintetici",
  "milica-bjelanovic-vasen-ktora-ozivuje-grafiku": "milica-bjelanovic-la-passione-che-da-vita-alla-grafica",
  "4-fantasticke-triky-pre-lepsie-kreslenie": "4-fantastici-trucchi-per-disegnare-meglio",
  "vedeli-ste-ze-akrylova-farba-ma-tyto-vlastnosti": "sapevate-che-il-colore-acrilico-ha-queste-proprieta",
  "umelecka-kolonia-vranje-2018-oficialne-otvorena": "colonia-artistica-vranje-2018-ufficialmente-aperta",
  "eaa-2021-rozhovor-s-porotou-severne-macedonsko": "eaa-2021-intervista-alla-giuria-macedonia-del-nord",
  "ako-sa-odhaluje-zahadna-dama-v-cervenej": "come-viene-svelata-la-misteriosa-dama-in-rosso",
  "neda-laketic-soc-socharka-vynimocneho-maliarskeho-nadsenia-a-umenia": "neda-laketic-soc-scultrice-di-eccezionale-entusiasmo-pittori",
  "kurzivne-pismo": "scrittura-corsiva",
  "napady-na-kreslenie": "idee-per-disegnare",
  "ako-malovat-spachtlami": "come-usare-le-spatole-artmie-passo-dopo-passo",
  "artmie-spachtle": "spatole-artmie",
  "dunja-sirmium-mozaikarka-vynimocnej-maliarskej-techniky": "dunja-sirmium-mosaicista-dalla-tecnica-pittorica-eccezionale",
  "vsetko-o-farbach-na-sklo": "tutto-quello-che-ce-da-sapere-sui-colori-per-vetro",
  "kreativne-tipy-na-dekoracie-s-tekvicou-pouzite-drevene-ozdoby-a-temperove-farby": "consigli-creativi-per-decorazioni-con-zucche-usa-decorazioni",
  "je-potrebne-lakovanie-obrazov": "e-necessario-verniciare-i-quadri",
  "par-zaujimavych-faktov-o-dekupazi-o-ktorych-ste-nevedeli": "alcuni-fatti-interessanti-sul-decoupage-che-non-conoscevi",
  "alginate-modelovacia-hmota": "alginato-la-pasta-modellabile-che-tutti-cercano",
  "niekolko-super-zaujimavosti-o-decoupage-technike-ktore-nepoznate": "alcune-super-curiosita-sulla-tecnica-del-decoupage-che-non-c",
  "mytus-alebo-pravda-je-lakovanie-obrazu-povinne": "mito-o-verita-verniciare-un-quadro-e-obbligatorio",
  "vecna-dilema-terpentin-alebo-lanovy-olej": "leterno-dilemma-trementina-o-olio-di-lino",
  "co-hovoria-znacky-na-tubach-farieb-na-malovanie": "cosa-dicono-i-simboli-sui-tubetti-di-colore-per-dipingere",
  "maliarska-dilema-titanova-alebo-zinkova-biela-farba": "dilemma-pittorico-bianco-di-titanio-o-bianco-di-zinco",
  "rozhovor-s-porotou-eaa-2021-bulharsko": "intervista-con-la-giuria-eaa-2021-bulgaria",
  "dubajska-cokolada-iluzia-ktoru-chces-ochutnat-aj-ty": "cioccolato-di-dubai-lillusione-che-vuoi-assaggiare-anche-tu",
  "bei-da-vinci-produkten-sprechen-wir-immer-von-handarbeit-und-hoher-qualitaet-wie-sieht-es-also-in-ihren-werkstaetten-aus-kommen-sie-mit-uns-und-werfen-sie-einen-blick-darauf-de": "quando-parliamo-dei-prodotti-da-vinci-parliamo-sempre-di-art",
  "werfen-sie-mit-uns-einen-blick-in-die-kreul-fabrik-de": "dai-unocchiata-con-noi-alla-fabbrica-kreul",
  "vom-skizzieren-zum-malen-kreul-triton-acrylmarker-halten-mit-dir-schritt-de": "dallo-schizzo-alla-pittura-i-marker-acrilici-kreul-triton-te",
  "wie-vielseitig-ist-die-acrylfarbe-solo-goya-triton-de": "quanto-e-versatile-il-colore-acrilico-solo-goya-triton",
  "warum-sind-amsterdam-marker-die-besten-de": "perche-i-marker-amsterdam-sono-i-migliori",
  "assemblage-vs-collage-was-ist-der-unterschied-und-wie-lassen-sich-diese-techniken-kreativ-verbinden-de": "assemblage-vs-collage-qual-e-la-differenza-e-come-combinare-2",
  "wie-malt-man-mit-acrylfarben-auf-glas-glasobjekte-schritt-fuer-schritt-verwandeln-de": "come-dipingere-su-vetro-con-i-colori-acrilici-trasforma-ogge",
  "grundlagen-der-oelmalerei-wie-man-oelfarben-und-malmittel-fuer-beeindruckende-impasto-effekte-verwendet-de": "fondamenti-della-pittura-a-olio-come-utilizzare-colori-a-oli",
  "schritt-fuer-schritt-mit-martin-horecny-wie-man-geometrische-kunst-mit-textur-erschafft-de": "passo-dopo-passo-con-martin-horecny-come-creare-arte-geometr-2",
  "stillleben-und-perspektive-entdecke-mit-jedem-strich-de": "natura-morta-e-prospettiva-scopri-con-ogni-tratto",
  "schnellanleitung-fuer-folk-ostereier-oder-wenn-die-zeit-vor-ostern-knapp-wird-de": "guida-rapida-per-uova-di-pasqua-folk-o-quando-il-tempo-prima",
  "5-tipps-zur-auswahl-der-richtigen-staffelei-de": "5-consigli-per-scegliere-il-cavalletto-giusto",
  "entdecke-die-neue-artmie-app-dein-kuenstlerischer-begleiter-fuer-die-hosentasche-de": "scopri-la-nuova-app-artmie-il-tuo-compagno-artistico-sempre",
  "wie-man-butter-paste-fuer-atemberaubende-texturen-verwendet-einfache-tipps-und-techniken-de": "come-utilizzare-la-pasta-burro-per-texture-mozzafiato-consig",
  "zaubern-mit-farben-ein-einfacher-weg-strukturpaste-zum-leben-zu-erwecken-de": "magia-con-i-colori-un-modo-semplice-per-dare-vita-alla-pasta-2",
  "wie-man-sanfte-aquarellverlaeufe-malt-ein-einfacher-trick-fuer-traumhafte-hintergruende-de": "come-dipingere-sfumature-acquerello-delicate-un-trucco-sempl",
  "erzeuge-bezaubernde-3d-effekte-mit-glas-schablonenfarbe-de": "crea-incantevoli-effetti-3d-con-il-colore-per-stencil-su-vet",
  "sommermagie-des-aquarells-malen-im-freien-als-neues-hobby-de": "la-magia-estiva-dellacquerello-dipingere-allaperto-come-nuov",
  "wie-man-mit-gouache-eine-satte-deckkraft-erzielt-ein-praktischer-leitfaden-fuer-kreative-seelen-de": "come-ottenere-una-copertura-ricca-con-la-gouache-una-guida-p",
  "crackle-paste-mit-acrylfarbe-mischen-was-passiert-wenn-gold-auf-weiss-trifft-de": "mescolare-la-pasta-screpolante-con-i-colori-acrilici-cosa-su",
  "wie-erstellt-man-impasto-effekte-mit-gouachefarben-de": "come-creare-effetti-impasto-con-i-colori-gouache",
  "entdecke-die-magie-der-textur-mit-strukturpaste-de": "scopri-la-magia-della-texture-con-la-pasta-modellante",
  "glanz-entfesseln-ein-leitfaden-fuer-metallische-akzente-in-deiner-kunst-de": "scatena-la-lucentezza-una-guida-agli-accenti-metallici-nella",
  "neue-moeglichkeiten-mit-der-fluessigen-metallic-paste-artmie-midas-de": "nuove-possibilita-con-la-pasta-metallica-liquida-artmie-mida-2",
  "spiel-mit-acrylfarben-4-tipps-fuer-die-abstrakte-verbindung-von-acryl-und-wasser-de": "gioca-con-i-colori-acrilici-4-consigli-per-la-combinazione-a",
  "11-praktische-tipps-fuer-die-gestaltung-von-plaster-art-mit-strukturpaste-de": "11-consigli-pratici-per-creare-plaster-art-con-la-pasta-mode",
  "wie-man-ein-portraet-mit-dem-pinsel-malt-tipps-fuer-ungewoehnliche-malgruende-de": "come-dipingere-un-ritratto-con-il-pennello-consigli-per-supp",
  "wie-malt-man-mit-gouache-super-tipps-von-artmie-de": "come-si-dipinge-con-la-tempera-ottimi-consigli-da-artmie",
  "gips-kunst-bei-artmie-wir-haben-den-heissen-trend-selbst-ausprobiert-de": "arte-in-gesso-da-artmie-abbiamo-provato-noi-stessi-questo-tr",
  "wie-verwendet-man-acrylfarben-vorteile-tipps-und-ratschlaege-fuer-anfaenger-und-fortgeschrittene-de": "come-si-usano-i-colori-acrilici-vantaggi-consigli-e-suggerim",
  "ihr-leitfaden-fuer-die-pouring-art-technik-de": "la-tua-guida-alla-tecnica-pouring-art-2",
  "wie-vergoldet-oder-patiniert-man-ein-kunstwerk-de": "come-si-dorano-o-si-patinano-le-opere-darte",
  "10-gruende-warum-sie-mit-der-mixed-media-technik-beginnen-sollten-de": "10-motivi-per-cui-dovresti-iniziare-con-la-tecnica-mixed-med-2",
  "wie-man-mit-tinten-malt-de": "come-dipingere-con-gli-inchiostri-2",
  "wie-man-mit-gouachefarben-malt-de": "come-dipingere-con-i-colori-a-guazzo",
  "zaubern-mit-van-gogh-aquarellfarben-zimmerpflanzen-de": "magia-con-gli-acquerelli-van-gogh-piante-da-appartamento",
  "wie-man-malmesser-verwendet-wir-malen-eine-fruehlingswiese-de": "come-usare-le-spatole-dipingiamo-un-prato-primaverile-2",
  "5-wege-eine-katze-zu-malen-de": "5-modi-per-dipingere-un-gatto-2",
  "wie-man-mit-acrylfarben-anfaengt-de": "come-iniziare-con-i-colori-acrilici-2",
  "pleinair-malerei-entdecken-wir-gemeinsam-die-schoenheit-der-natur-de": "pittura-en-plein-air-scopriamo-insieme-la-bellezza-della-nat",
  "entdecken-sie-die-magie-der-oelmalerei-de": "scopri-la-magia-della-pittura-a-olio",
  "finden-sie-sich-mit-uns-in-der-welt-der-oelfarben-zurecht-de": "orientati-nel-mondo-dei-colori-a-olio-insieme-a-noi",
  "landschaftsmalerei-eine-schritt-fuer-schritt-anleitung-de": "pittura-di-paesaggi-una-guida-passo-dopo-passo",
  "wie-malt-man-blumen-mit-aquarellfarben-de": "come-dipingere-fiori-con-gli-acquerelli",
  "wie-malt-man-einfach-eine-rose-de": "come-dipingere-facilmente-una-rosa",
  "wie-mischt-man-acrylfarben-de": "come-miscelare-i-colori-acrilici",
  "textilmalerei-wird-dich-begeistern-de": "la-pittura-su-tessuto-ti-entusiasmera",
  "wie-arbeitet-man-mit-acrylfarben-de": "come-lavorare-con-i-colori-acrilici",
  "wie-man-ein-originelles-weihnachtsbild-gestaltet-de": "come-creare-unimmagine-natalizia-originale",
  "wie-bemalt-man-textilien-de": "come-si-dipingono-i-tessuti",
  "10-tipps-zum-malen-mit-im-dunkeln-leuchtenden-farben-de": "10-consigli-per-dipingere-con-colori-luminescenti",
  "acryl-giessen-harmonie-im-fluss-de": "acrylic-pouring-armonia-nel-flusso",
  "probiere-die-spachteltechnik-aus-de": "prova-la-tecnica-della-spatola",
  "welche-maltechniken-solltest-du-beherrschen-de": "quali-tecniche-pittoriche-dovresti-padroneggiare",
  "welche-leinwand-ist-besser-fuer-sie-baumwolle-oder-leinen-de": "quale-tela-e-migliore-per-te-cotone-o-lino",
  "regenbogen-glasuren-auf-keramik-das-kunstatelier-von-brian-giniewski-de": "smalti-arcobaleno-su-ceramica-latelier-darte-di-brian-giniew",
  "seidenmalerei-bewirkt-wunder-ueberzeuge-dich-selbst-mit-uns-de": "la-pittura-su-seta-fa-miracoli-provalo-tu-stesso-con-noi",
  "wie-viel-wissen-sie-ueber-die-anatomie-von-malpinseln-de": "quanto-ne-sai-sullanatomia-dei-pennelli-2",
  "wussten-sie-schon-von-wasservermalbaren-oelfarben-de": "sapevi-dellesistenza-dei-colori-a-olio-idrosolubili",
  "leinwand-auf-keilrahmen-aufziehen-was-sie-wissen-muessen-de": "montare-una-tela-su-telaio-cosa-devi-sapere",
  "eine-kreative-und-ungewoehnliche-kombination-tusche-und-oelpastellkreiden-de": "una-combinazione-creativa-e-insolita-inchiostro-e-pastelli-a-2",
  "haben-sie-schon-die-express-transfer-loesung-ausprobiert-de": "hai-gia-provato-la-soluzione-per-il-trasferimento-rapido",
  "was-ist-besser-fuer-sie-baumwoll-oder-leinenleinwand-de": "cosa-e-meglio-per-te-tela-di-cotone-o-di-lino-2",
  "was-weisst-du-ueber-die-anatomie-von-malpinseln-de": "cosa-sai-sullanatomia-dei-pennelli-2",
  "kennen-sie-schon-wasservermalbare-oelfarben-de": "conosci-gia-i-colori-a-olio-idrosolubili",
  "welche-sind-besser-naturhaarpinsel-oder-synthetikpinsel-de": "quali-sono-migliori-i-pennelli-in-pelo-naturale-o-quelli-sin",
  "wie-viel-wissen-sie-ueber-die-anatomie-von-pinseln-de": "quanto-ne-sai-sullanatomia-dei-pennelli-3",
  "wussten-sie-schon-dass-acrylfarben-diese-eigenschaften-haben-de": "sapevi-che-i-colori-acrilici-hanno-queste-proprieta",
  "was-sind-acryl-strukturpasten-und-wofuer-werden-sie-verwendet-de": "cosa-sono-le-paste-strutturanti-acriliche-e-a-cosa-servono-2",
  "wie-reinigt-man-pinsel-nach-dem-malen-richtig-de": "come-pulire-correttamente-i-pennelli-dopo-aver-dipinto-2",
  "kennen-sie-alle-geheimnisse-der-pouring-technik-de": "conosci-tutti-i-segreti-della-tecnica-del-pouring",
  "was-ist-besser-fuer-dich-natur-oder-synthetikpinsel-de": "cosa-e-meglio-per-te-pennelli-in-pelo-naturale-o-sintetici",
  "wussten-sie-dass-acrylfahrbe-diese-eigenschaften-hat-de": "sapevate-che-i-colori-acrilici-hanno-queste-proprieta",
  "bleistiftzeichnen-tipps-fuer-anfaenger-und-fortgeschrittene-de": "disegno-a-matita-consigli-per-principianti-ed-esperti-2",
  "wie-man-farben-mit-pinselstiften-blendet-einfache-ombre-effekte-de": "come-sfumare-i-colori-con-i-pennarelli-a-punta-pennello-semp",
  "kalligrafie-und-hand-lettering-warum-es-ausprobieren-de": "calligrafia-e-hand-lettering-perche-provarli",
  "zeichnen-sie-mit-uns-schneegloeckchen-artmie-de": "disegna-con-noi-dei-bucaneve-artmie-2",
  "wie-zeichnet-man-einen-wunderschoenen-schmetterling-de": "come-si-disegna-una-bellissima-farfalla",
  "wie-man-eine-figur-zeichnet-anleitung-de": "come-disegnare-una-figura-guida-2",
  "wie-man-die-kunst-der-kalligrafie-erlernt-oder-seine-handschrift-verbessert-de": "come-imparare-larte-della-calligrafia-o-migliorare-la-propri",
  "linolschnitt-fuer-anfaenger-wie-man-einen-stempel-herstellt-de": "linoleografia-per-principianti-come-realizzare-un-timbro-2",
  "manga-und-comics-zeichnen-mit-copic-markern-de": "disegnare-manga-e-fumetti-con-i-marker-copic",
  "wie-legt-man-ein-skizzenbuch-an-de": "come-iniziare-un-album-da-disegno",
  "urban-sketching-mit-stift-und-pinsel-auf-die-strasse-de": "urban-sketching-in-strada-con-penna-e-pennello-2",
  "bleistiftzeichnen-von-der-theorie-zur-praxis-de": "disegno-a-matita-dalla-teoria-alla-pratica-2",
  "zeichnen-mit-bleistift-lerne-die-zeichentechniken-de": "disegnare-a-matita-impara-le-tecniche-di-disegno",
  "4-fantastische-tricks-fuer-besseres-zeichnen-de": "4-fantastici-trucchi-per-disegnare-meglio-2",
  "kursivschrift-de": "corsivo",
  "zeichenideen-de": "idee-di-disegno-per-principianti-come-iniziare-il-tuo-viaggi",
  "pinsel-gefuehle-folge-deiner-hand-und-deinem-herzen-de": "pennelli-ed-emozioni-segui-la-tua-mano-e-il-tuo-cuore",
  "wie-waehlt-man-die-richtige-malerleinwand-aus-vergleich-von-oeko-baumwoll-und-leinenleinwaenden-de": "come-scegliere-la-tela-da-pittura-giusta-confronto-tra-tele",
  "kuenstlerische-texturen-entdecken-mit-martin-horecny-modellierpaste-vs-reliefpaste-de": "scoprire-le-texture-artistiche-con-martin-horecny-pasta-mode",
  "wie-haelt-man-eine-malpalette-richtig-einfache-anleitung-fuer-bequemes-malen-de": "come-tenere-correttamente-una-tavolozza-guida-semplice-per-d",
  "hahnemuehle-skizzenbuch-das-tagebuch-eines-professionellen-kuenstlers-de": "album-da-schizzi-hahnemuhle-il-diario-di-un-artista-professi",
  "entfessle-die-magie-6-wichtige-dinge-die-jeder-kuenstler-ueber-acrylfarben-wissen-sollte-de": "scatena-la-magia-6-cose-importanti-che-ogni-artista-dovrebbe",
  "verleihe-deinem-kunstwerk-tiefe-mit-der-artmie-butter-paste-de": "dai-profondita-alla-tua-opera-darte-con-la-pasta-modellante",
  "malen-wie-die-alten-meister-mit-der-museal-leinwand-aus-leinen-de": "dipingere-come-gli-antichi-maestri-con-la-tela-museal-in-lin",
  "einfuehrung-in-die-welt-der-oelpastelle-ein-kompletter-leitfaden-fuer-anfaenger-de": "introduzione-al-mondo-dei-pastelli-a-olio-una-guida-completa",
  "wie-man-das-wellen-von-papier-im-rahmen-verhindert-de": "come-evitare-che-la-carta-si-imbarchi-nella-cornice-2",
  "keilrahmen-spannkeile-wie-und-wann-verwendet-man-sie-de": "cunei-per-telaio-come-e-quando-usarli",
  "zaubern-sie-auf-der-leinwand-was-koennen-die-vielseitigen-artmie-malmesser-alles-leisten-de": "crea-magie-sulla-tela-cosa-possono-fare-le-versatili-spatole",
  "oelfarben-eigenschaften-und-grundlegende-pigmente-de": "colori-a-olio-caratteristiche-e-pigmenti-fondamentali",
  "wie-repariert-man-eine-eingedrueckte-malerleinwand-de": "come-riparare-una-tela-da-pittura-ammaccata-2",
  "wie-man-die-richtige-pinselgroesse-auswaehlt-de": "come-scegliere-la-misura-giusta-del-pennello",
  "wie-man-acrylfarben-nach-viskositaet-auswaehlt-de": "come-scegliere-i-colori-acrilici-in-base-alla-viscosita-2",
  "5-gruende-warum-sie-mit-acryl-statt-mit-oelfarben-malen-sollten-de": "5-motivi-per-cui-dovresti-dipingere-con-gli-acrilici-invece",
  "6-tipps-fuer-ein-atelier-voller-harmonie-und-freiheit-de": "6-consigli-per-un-atelier-pieno-di-armonia-e-liberta",
  "wie-man-eine-leinwand-auswaehlt-de": "come-scegliere-una-tela-2",
  "keine-angst-vor-aquarell-erste-eindruecke-von-white-nights-aquarellfarben-de": "niente-paura-per-lacquerello-prime-impressioni-sui-colori-pe",
  "wie-waehlt-man-das-richtige-aquarellpapier-aus-de": "come-scegliere-la-carta-per-acquerello-giusta-2",
  "wie-laesst-sich-die-lichtechtheit-von-gemaelden-verbessern-de": "come-migliorare-la-resistenza-alla-luce-dei-dipinti-2",
  "wissen-sie-wirklich-alles-ueber-polymer-clay-de": "sai-davvero-tutto-sulla-pasta-polimerica-2",
  "was-wissen-sie-ueber-polymerton-de": "cosa-sai-sulla-pasta-polimerica-2",
  "6-dinge-die-ihre-pinsel-langsam-zerstoeren-de": "6-cose-che-distruggono-lentamente-i-tuoi-pennelli",
  "artmie-malmesser-de": "spatole-per-pittura-artmie",
  "wie-verwendet-man-artmie-malmesser-schritt-fuer-schritt-de": "come-si-usano-le-spatole-per-pittura-artmie-passo-dopo-passo",
  "alles-was-sie-ueber-glasfarben-wissen-muessen-de": "tutto-quello-che-devi-sapere-sui-colori-per-vetro",
  "alginat-die-begehrte-abformmasse-de": "alginato-il-ricercato-materiale-per-calchi",
  "ist-das-firnissen-von-gemaelden-notwendig-de": "e-necessario-verniciare-i-dipinti",
  "mythos-oder-wahrheit-ist-das-firnissen-eines-gemaeldes-pflicht-de": "mito-o-verita-verniciare-un-dipinto-e-un-obbligo",
  "das-ewige-dilemma-terpentin-oder-leinoel-de": "leterno-dilemma-trementina-o-olio-di-lino-2",
  "was-bedeuten-die-symbole-auf-farbtuben-de": "cosa-significano-i-simboli-sui-tubetti-di-colore",
  "das-dilemma-beim-malen-titanweiss-oder-zinkweiss-de": "il-dilemma-nella-pittura-bianco-di-titanio-o-bianco-di-zinco",
  "wie-man-zu-hause-eine-batik-tasche-herstellt-eine-einfache-anleitung-fuer-jeden-de": "come-realizzare-una-borsa-batik-a-casa-una-guida-semplice-pe-2",
  "einfache-diy-anleitung-fuer-harz-anhaenger-gestalte-glitzernde-geschenke-zu-hause-de": "semplice-guida-fai-da-te-per-ciondoli-in-resina-crea-regali",
  "wie-man-elegante-reliefkunst-aus-schaumstoffplatten-auf-leinwand-erstellt-eine-schritt-fuer-schritt-anleitung-de": "come-creare-unelegante-arte-in-rilievo-su-tela-con-pannelli-2",
  "5-tipps-fuer-originelle-weihnachtsdekorationen-de": "5-consigli-per-decorazioni-natalizie-originali-2",
  "weihnachtsdekoration-aus-papier-kreativer-und-oekologischer-festtagsschmuck-de": "decorazioni-natalizie-di-carta-addobbi-festivi-creativi-ed-e",
  "dunkelheit-vor-dem-fenster-diese-7-aktivitaeten-verschoenern-ihre-langen-abende-de": "buio-fuori-dalla-finestra-queste-7-attivita-renderanno-piu-b",
  "5-tipps-fuer-herbstliches-basteln-de": "5-consigli-per-il-fai-da-te-autunnale",
  "serviettentechnik-was-ist-decoupage-und-wie-funktioniert-sie-de": "tecnica-del-tovagliolo-cose-il-decoupage-e-come-funziona",
  "bemalte-handtasche-schritt-fuer-schritt-de": "borsa-dipinta-passo-dopo-passo-2",
  "wie-man-moderne-ohrringe-aus-polymer-clay-herstellt-de": "come-realizzare-orecchini-moderni-in-pasta-polimerica",
  "wie-bemalt-man-einen-kuerbis-mit-der-zentangle-technik-de": "come-dipingere-una-zucca-con-la-tecnica-zentangle-2",
  "was-tun-mit-einer-zerrissenen-leinwand-ein-kreatives-memory-spiel-de": "cosa-fare-con-una-tela-strappata-un-gioco-di-memoria-creativ",
  "bastelanleitung-dekorative-kerzen-mit-pflanzen-de": "guida-al-fai-da-te-candele-decorative-con-piante",
  "die-geheimnisse-des-scrapbookings-entdecken-wie-man-aus-einfachen-komponenten-kunstwerke-schafft-de": "scoprire-i-segreti-dello-scrapbooking-come-creare-opere-dart",
  "selbermachen-bienenwachstuecher-fuer-lebensmittel-de": "fai-da-te-pellicole-di-cera-dapi-per-alimenti",
  "8-arten-washi-tapes-zu-verwenden-artmie-de": "8-modi-per-utilizzare-i-washi-tape-artmie",
  "diy-makramee-dekoration-aus-garn-de": "diy-decorazione-in-macrame-con-filato",
  "diy-selbstgemachte-duftende-seife-de": "diy-sapone-profumato-fatto-in-casa",
  "entspannungsmalbuecher-fuer-erwachsene-einfach-ausdrucken-und-losmalen-de": "libri-da-colorare-antistress-per-adulti-basta-stampare-e-ini",
  "nagel-und-fadenbild-gestalte-deine-eigene-originelle-dekoration-de": "string-art-crea-la-tua-decorazione-originale",
  "bastelanleitung-blumen-aus-krepppapier-de": "guida-al-fai-da-te-fiori-di-carta-crespa",
  "wie-man-mit-scrapbooking-beginnt-de": "come-iniziare-con-lo-scrapbooking-2",
  "diy-osterei-mit-gold-verziert-2022-de": "diy-uovo-di-pasqua-decorato-con-oro-2022",
  "diy-oster-eier-mit-glitzer-de": "diy-uova-di-pasqua-con-glitter",
  "diy-mit-trockenblumen-verzierte-ostereier-de": "fai-da-te-uova-di-pasqua-decorate-con-fiori-secchi-2",
  "bastelanleitung-ueberraschungs-osterei-de": "guida-al-fai-da-te-uovo-di-pasqua-a-sorpresa",
  "3-ideen-fuer-osterbasteleien-2022-de": "3-idee-per-lavoretti-pasquali-2022",
  "diy-vogelhaeuschen-selber-bauen-de": "fai-da-te-costruire-una-casetta-per-uccelli",
  "diy-gehaekelte-ostereier-de": "fai-da-te-uova-di-pasqua-alluncinetto-2",
  "diy-handgemachte-tasche-aus-kunstleder-de": "fai-da-te-borsa-fatta-a-mano-in-ecopelle-2",
  "diy-oekologische-einkaufstasche-de": "fai-da-te-borsa-della-spesa-ecologica-2",
  "wie-man-halloween-dekorationen-bastelt-de": "come-creare-decorazioni-di-halloween",
  "wie-man-eine-kerze-mit-staender-herstellt-de": "come-realizzare-una-candela-con-supporto",
  "gestalten-sie-eine-wunderschoene-halloween-dekoration-de": "crea-una-bellissima-decorazione-di-halloween",
  "wie-gestaltet-man-originelles-kuechengeschirr-de": "come-decorare-stoviglie-originali",
  "probieren-sie-den-hit-des-jahres-aus-malen-nach-zahlen-de": "prova-il-successo-dellanno-dipingere-con-i-numeri",
  "glaenzen-sie-auf-der-halloween-party-mit-snazaroo-gesichtsfarben-de": "brilla-alla-festa-di-halloween-con-i-colori-per-il-viso-snaz",
  "wie-gelingen-einfache-aber-effektvolle-osterdekorationen-de": "come-realizzare-decorazioni-pasquali-semplici-ma-efficaci",
  "selber-machen-seidenmalrahmen-aus-keilrahmenleisten-de": "fai-da-te-telai-per-pittura-su-seta-realizzati-con-listelli",
  "was-kann-man-zu-hause-waehrend-der-quarantaene-tun-wir-haben-tipps-fuer-kreative-projekte-de": "cosa-si-puo-fare-a-casa-durante-la-quarantena-abbiamo-sugger",
  "wie-man-eine-glasvase-bemalt-de": "come-dipingere-un-vaso-di-vetro-2",
  "magische-trends-der-glasmalerei-de": "tendenze-magiche-della-pittura-su-vetro",
  "diy-keramiktassen-mit-verlaufender-regenbogen-glasur-de": "fai-da-te-tazze-in-ceramica-con-smalto-arcobaleno-sfumato",
  "diy-fruehlingskranz-im-landhausstil-de": "fai-da-te-ghirlanda-primaverile-in-stile-country",
  "wenn-baeume-sprechen-anleitung-fuer-bemalte-holzdekorationen-de": "quando-gli-alberi-parlano-guida-per-decorazioni-in-legno-dip",
  "wie-das-batiken-meine-schwarz-weisse-welt-veraendert-hat-de": "come-il-batik-ha-cambiato-il-mio-mondo-in-bianco-e-nero-2",
  "scrapbooking-ideen-und-beispiele-de": "scrapbooking-idee-ed-esempi-2",
  "diy-holzdekoration-anleitung-zum-basteln-mit-naegeln-de": "decorazioni-in-legno-fai-da-te-guida-alla-creazione-con-i-ch",
  "kreative-deko-tipps-fuer-kuerbisse-verwenden-sie-holzdekorationen-und-temperafarben-de": "consigli-creativi-per-decorare-le-zucche-usa-decorazioni-in",
  "ein-paar-interessante-fakten-ueber-decoupage-die-sie-noch-nicht-kannten-de": "alcuni-fatti-interessanti-sul-decoupage-che-ancora-non-conos",
  "einige-super-fakten-ueber-die-decoupage-technik-die-sie-noch-nicht-kennen-de": "alcuni-fatti-super-sulla-tecnica-del-decoupage-che-ancora-no",
  "farbakkorde-in-der-kunst-das-spiel-mit-der-harmonie-auf-deiner-palette-de": "accordi-cromatici-nellarte-il-gioco-dellarmonia-sulla-tua-ta",
  "wie-waere-es-wenn-du-ein-tagebuch-beginnen-wuerdest-genau-jetzt-de": "che-ne-dici-di-iniziare-un-diario-proprio-ora",
  "valentins-inspiration-fuer-jeden-kreativen-de": "ispirazione-di-san-valentino-per-ogni-creativo-2",
  "erstelle-eine-kreative-botschaft-fuer-dein-zukuenftiges-ich-de": "crea-un-messaggio-creativo-per-il-tuo-io-futuro-2",
  "interview-mit-der-kuenstlerin-und-aerztin-barbora-sebes-de": "intervista-con-lartista-e-medico-barbora-sebes-2",
  "erlebe-euphorie-bei-der-erschaffung-deines-kunstwerks-de": "prova-euforia-nella-creazione-della-tua-opera-darte",
  "farben-mischen-wir-zeigen-dir-wie-es-geht-de": "mescolare-i-colori-ti-mostriamo-come-fare-2",
  "8-geschenkideen-fuer-kuenstler-de": "8-idee-regalo-per-artisti",
  "die-geheime-sprache-der-malerei-wie-man-ein-kunstwerk-liest-de": "il-linguaggio-segreto-della-pittura-come-leggere-unopera-dar-2",
  "entdecke-die-besten-farbkombinationen-beim-malen-de": "scopri-le-migliori-combinazioni-di-colori-nella-pittura-2",
  "farbe-des-monats-mai-hellrosa-de": "colore-del-mese-di-maggio-rosa-chiaro-2",
  "aquarellfarben-quiz-de": "quiz-sugli-acquerelli-2",
  "farbe-des-monats-april-wachsgelb-2022-de": "colore-del-mese-di-aprile-giallo-cera-2022-2",
  "farbe-des-monats-maerz-orange-de": "colore-del-mese-di-marzo-arancione-2",
  "farbe-des-monats-februar-eisminz-de": "colore-del-mese-di-febbraio-menta-ghiacciata",
  "was-zum-valentinstag-5-filme-mit-kuenstlerischem-touch-die-du-gesehen-haben-musst-de": "cosa-regalare-a-san-valentino-5-film-con-un-tocco-artistico",
  "wir-kennen-die-farbe-des-jahres-2022-de": "conosciamo-il-colore-dellanno-2022-2",
  "farbe-des-monats-januar-indigo-de": "colore-del-mese-di-gennaio-indaco-2",
  "begriffe-aus-der-kunstwelt-die-deinen-horizont-erweitern-de": "termini-del-mondo-dellarte-che-amplieranno-i-tuoi-orizzonti-2",
  "ein-punkt-hinter-dem-sommer-ozeanblau-de": "un-punto-dopo-lestate-blu-oceano",
  "farbe-des-monats-juli-gold-de": "colore-del-mese-di-luglio-oro-2",
  "10-filme-ueber-kuenstler-die-man-gesehen-haben-muss-de": "10-film-sugli-artisti-che-devi-assolutamente-vedere-2",
  "farben-fuer-das-jahr-2021-de": "colori-per-lanno-2021-2",
  "im-einklang-mit-der-natur-oekologisch-und-kreativ-gestalten-de": "in-armonia-con-la-natura-creare-in-modo-ecologico-e-creativo",
  "du-weisst-nicht-was-du-malen-sollst-diese-staedte-wecken-deine-kreativitaet-de": "non-sai-cosa-dipingere-queste-citta-risvegliano-la-tua-creat",
  "kreativitaet-baut-stress-ab-bringen-sie-sich-und-ihre-familie-auch-in-der-haeuslichen-quarantaene-ins-gleichgewicht-wir-zeigen-ihnen-wie-es-geht-de": "la-creativita-riduce-lo-stress-ritrova-lequilibrio-con-la-tu",
  "wie-koennen-sie-ihre-kuenstlerischen-faehigkeiten-verbessern-10-tipps-de": "come-puoi-migliorare-le-tue-abilita-artistiche-10-consigli",
  "oelfarben-und-das-erfolgsgeheimnis-von-gerhard-richter-de": "i-colori-a-olio-e-il-segreto-del-successo-di-gerhard-richter-2",
  "woher-kommt-malen-nach-zahlen-de": "da-dove-viene-la-pittura-con-i-numeri",
  "was-schenkt-man-einer-frau-zum-internationalen-frauentag-de": "cosa-regalare-a-una-donna-per-la-giornata-internazionale-del",
  "farbe-des-jahres-2019-auf-leinwand-und-sneakern-de": "colore-dellanno-2019-su-tela-e-sneaker",
  "6-gruende-warum-man-mit-einem-kuenstler-ausgehen-sollte-de": "6-motivi-per-cui-dovresti-uscire-con-un-artista",
  "was-ist-ein-fresko-de": "cose-un-affresco",
  "weihnachten-steht-vor-der-tuer-was-schenkt-man-einem-kuenstler-de": "il-natale-e-alle-porte-cosa-regalare-a-un-artista",
  "orange-eine-farbe-die-man-nicht-unterschaetzen-sollte-de": "arancione-un-colore-da-non-sottovalutare-2",
  "wir-sind-fasziniert-pop-art-nach-30-jahren-wiederentdeckt-de": "siamo-affascinati-la-pop-art-riscoperta-dopo-30-anni",
  "die-geheimnisse-von-andy-warhols-schaffen-de": "i-segreti-del-lavoro-di-andy-warhol",
  "rasto-ekkert-anfaenge-sind-schwer-aber-es-ist-wichtig-seinen-eigenen-weg-zu-finden-de": "rasto-ekkert-gli-inizi-sono-difficili-ma-e-importante-trovar",
  "was-ist-grafik-de": "cose-la-grafica",
  "die-kunstkarte-europas-weisst-du-welcher-kuenstler-die-slowakei-repraesentiert-de": "la-mappa-artistica-delleuropa-sai-quale-artista-rappresenta",
  "wunderschoene-glasskulpturen-in-baumstaemmen-de": "splendide-sculture-in-vetro-allinterno-di-tronchi-dalbero",
  "der-zauber-der-restaurierung-de": "la-magia-del-restauro",
  "rate-mal-womit-ich-zeichne-de": "indovina-con-cosa-sto-disegnando-2",
  "wissenschaftler-haben-einen-neuen-blauton-entdeckt-weisst-du-wie-er-heisst-de": "gli-scienziati-hanno-scoperto-una-nuova-tonalita-di-blu-sai",
  "einzigartige-aufnahme-eines-oelgemaeldes-aus-dem-film-loving-vincent-de": "ripresa-unica-di-un-dipinto-a-olio-dal-film-loving-vincent",
  "m-rost-effekt-einst-unerwuenscht-heute-ein-willkommenes-element-in-der-kreativen-gestaltung-de": "m-effetto-ruggine-un-tempo-indesiderato-oggi-un-elemento-gra",
  "was-ist-die-operation-nachtwache-und-warum-ist-sie-so-wichtig-de": "cose-loperazione-night-watch-e-perche-e-cosi-importante",
  "die-beruehmtesten-werke-von-pablo-picasso-de": "le-opere-piu-famose-di-pablo-picasso-2",
  "rost-effekt-einst-unerwuenscht-heute-ein-willkommener-effekt-de": "effetto-ruggine-un-tempo-indesiderato-oggi-un-effetto-ricerc",
  "die-teuersten-gemaelde-der-welt-de": "i-dipinti-piu-costosi-al-mondo",
  "5-tipps-wie-du-dein-gemaelde-ausdrucksstaerker-machst-de": "5-consigli-per-rendere-i-tuoi-dipinti-piu-espressivi",
  "eaa-2021-interview-mit-der-jury-bulgarien-de": "intervista-alla-giuria-delleaa-2021-bulgaria",
  "kunst-aus-geschmolzenem-glas-und-holz-die-einzigartige-kunst-von-slagerman-und-fishman-de": "arte-in-vetro-fuso-e-legno-larte-unica-di-slagerman-e-fishma",
  "wussten-sie-dass-es-ein-pigmentmuseum-gibt-de": "sapevi-che-esiste-un-museo-dei-pigmenti-2",
  "milica-bjelanovic-eine-leidenschaft-die-grafik-zum-leben-erweckt-de": "milica-bjelanovic-una-passione-che-da-vita-alla-grafica",
  "kunstkolonie-vranje-2018-offiziell-eroeffnet-de": "colonia-artistica-vranje-2018-inaugurazione-ufficiale",
  "eaa-2021-interview-mit-der-jury-nordmazedonien-de": "intervista-alla-giuria-eaa-2021-macedonia-del-nord",
  "wie-die-geheimnisvolle-dame-in-rot-enthuellt-wird-de": "come-viene-svelata-la-misteriosa-dama-in-rosso-2",
  "neda-laketic-soc-eine-bildhauerin-mit-aussergewoehnlicher-malerischer-leidenschaft-und-kunstfertigkeit-de": "neda-laketic-soc-una-scultrice-con-una-straordinaria-passion",
  "dunja-sirmium-mosaikkuenstlerin-mit-aussergewoehnlicher-maltechnik-de": "dunja-sirmium-artista-del-mosaico-con-una-tecnica-pittorica",
  "interview-mit-der-eaa-jury-2021-bulgarien-de": "intervista-alla-giuria-eaa-2021-bulgaria",
  "dubai-schokolade-die-illusion-die-auch-du-probieren-willst-de": "cioccolato-di-dubai-lillusione-che-anche-tu-vorrai-provare",
  "entdecke-sensory-art-mit-den-okto-sets-de": "scopri-la-sensory-art-con-i-set-okto-2",
  "sicher-bunt-und-unterhaltsam-warum-ungiftige-mucki-fingerfarben-ideal-fuer-kinder-sind-de": "sicuri-colorati-e-divertenti-perche-i-colori-a-dita-mucki-at",
  "das-traum-kinderzimmer-wie-schafft-man-einen-ort-zum-spielen-und-kreativen-entfalten-de": "la-cameretta-dei-sogni-come-creare-un-luogo-per-giocare-e-da",
  "malen-mit-kindern-froehliche-und-bunte-steine-de": "dipingere-con-i-bambini-sassi-allegri-e-colorati",
  "tipps-fuer-kreative-geschenke-fuer-kinder-de": "consigli-per-regali-creativi-per-bambini-2",
  "malen-mit-kindern-steine-als-ostereier-de": "dipingere-con-i-bambini-sassi-come-uova-di-pasqua-2",
  "geniessen-sie-den-sommer-mit-kindern-und-strassenmalkreide-de": "goditi-lestate-con-i-bambini-e-i-gessetti-da-marciapiede",
  "5-tipps-wie-sie-die-haeusliche-quarantaene-mit-kindern-meistern-de": "5-consigli-su-come-gestire-la-quarantena-in-casa-con-i-bambi",
  "kinder-wegen-quarantaene-zu-hause-wir-wissen-wie-man-sie-kreativ-beschaeftigt-de": "bambini-a-casa-per-la-quarantena-sappiamo-come-tenerli-occup",
  "hurra-die-schule-geht-los-kuenstlerbedarf-fuer-gross-und-klein-de": "evviva-la-scuola-sta-per-iniziare-articoli-per-belle-arti-pe",
  "malen-mit-kindern-kreative-weihnachten-de": "dipingere-con-i-bambini-natale-creativo",
  "wir-haben-den-shoproku-2024-gewonnen-und-das-ist-auch-ihr-verdienst-de": "abbiamo-vinto-il-premio-shoproku-2024-e-questo-e-anche-merit",
  "auswertung-des-artmie-contest-2024-eine-explosion-an-kreativitaet-und-talent-in-der-ganzen-slowakei-de": "valutazione-dellartmie-contest-2024-unesplosione-di-creativi-2",
  "das-jahr-2024-ist-voller-artmie-neuheiten-welche-begruessen-wir-als-erste-de": "lanno-2024-e-pieno-di-novita-artmie-quali-accoglieremo-per-p",
  "artmie-wettbewerb-kunstwettbewerb-fuer-schueler-von-kunstschulen-de": "concorso-artmie-concorso-darte-per-studenti-delle-scuole-dar",
  "der-undercover-boss-vali-hat-es-uebertrieben-buchstaeblich-wie-hat-er-sich-bei-der-arbeit-bei-artmie-geschlagen-de": "il-capo-sotto-copertura-vali-ha-esagerato-letteralmente-come-2",
  "der-shoproku-wettbewerb-ist-da-haben-wir-es-auch-dieses-mal-verdient-zu-gewinnen-de": "il-concorso-shoproku-e-arrivato-ci-meritiamo-di-vincere-anch",
  "mach-mit-beim-inktober-mit-artmie-de": "partecipa-allinktober-con-artmie-2",
  "wie-ist-der-artmie-inktober-2021-ausgegangen-de": "come-andato-lartmie-inktober-2021-2",
  "die-letzte-woche-des-artmie-inktober-steht-vor-der-tuer-de": "lultima-settimana-dellartmie-inktober-e-alle-porte",
  "artmie-inktober-themen-der-vierten-woche-de": "artmie-inktober-temi-della-quarta-settimana-2",
  "artmie-inktober-wir-inspirieren-sie-und-uns-de": "artmie-inktober-ispiriamo-te-e-noi-stessi",
  "artmie-inktober-was-die-dritte-woche-bringt-de": "artmie-inktober-cosa-porta-la-terza-settimana",
  "artmie-inktober-themen-in-der-zweiten-woche-de": "artmie-inktober-temi-della-seconda-settimana-2",
  "der-eaa-kuenstlerwettbewerb-ist-dieses-jahr-voller-positiver-energie-de": "il-concorso-artistico-eaa-di-questanno-e-pieno-di-energia-po",
  "inktober-die-herausforderung-die-kuenstler-weltweit-verbindet-de": "inktober-la-sfida-che-unisce-gli-artisti-di-tutto-il-mondo-2",
  "der-internationale-eaa-wettbewerb-hat-begonnen-reiche-auch-du-dein-werk-ein-de": "il-concorso-internazionale-eaa-e-iniziato-invia-anche-tu-la",
  "wir-haben-den-shoproku-2019-gewonnen-de": "abbiamo-vinto-il-premio-shoproku-2019-2",
  "wir-erfuellen-bunte-kuenstlertraeume-de": "realizziamo-i-sogni-colorati-degli-artisti",
  "aquarell-malen-lernen-dein-schritt-fuer-schritt-guide-de": "imparare-a-dipingere-ad-acquerello-la-tua-guida-passo-dopo-p",
  "mixed-media-guide-so-kombinierst-du-farben-und-materialien-de": "guida-al-mixed-media-come-combinare-colori-e-materiali",
  "tiffany-glasmalerei-anleitung-fuer-dein-erstes-kunstwerk-de": "pittura-su-vetro-tiffany-guida-per-la-tua-prima-opera-darte",
  "textilfarbe-richtig-anwenden-dein-guide-fuer-stoffmalerei-de": "applicare-correttamente-i-colori-per-tessuti-la-tua-guida-pe",
  "welche-maltechnik-ist-die-richtige-fuer-mich-de": "qual-e-la-tecnica-pittorica-giusta-per-me-la-tua-guida",
  "encaustic-fuer-einsteiger-wachsmalerei-schritt-fuer-schritt-erklaert-de": "encausto-per-principianti-la-pittura-a-cera-spiegata-passo-d",
  "acrylbild-versiegeln-so-schuetzt-du-deine-kunstwerke-richtig-de": "sigillare-un-dipinto-acrilico-ecco-come-proteggere-correttam",
  "himmel-und-wolken-realistisch-malen-tipps-de": "dipingere-cieli-e-nuvole-in-modo-realistico-consigli-profess",
  "die-besten-pinsel-fuer-acrylmalerei-dein-guide-fuer-den-start-de": "i-migliori-pennelli-per-la-pittura-acrilica-la-tua-guida-per",
  "welche-staffelei-kaufen-dein-guide-fuer-den-perfekten-halt-de": "quale-cavalletto-acquistare-la-tua-guida-per-un-supporto-per",
  "studio-vs-kuenstlerqualitaet-was-steckt-in-der-farbtube-de": "qualita-studio-vs-qualita-artista-cosa-ce-dentro-il-tubetto",
  "royal-talens-vs-schmincke-aquarellfarben-vergleich-de": "royal-talens-vs-schmincke-quali-acquerelli-scegliere",
  "acrylmalerei-fuer-anfaenger-grundausstattung-de": "pittura-acrilica-per-principianti-il-tuo-kit-di-base-definit",
  "ordnung-im-atelier-perfekte-aufbewahrung-kuenstlermaterial-de": "ordine-in-atelier-la-conservazione-perfetta-per-i-tuoi-mater",
  "kuenstlerbedarf-online-kaufen-sparen-de": "acquistare-materiale-artistico-online-ecco-come-risparmiare",
  "welches-pouring-medium-ist-das-beste-guide-de": "qual-e-il-miglior-medium-per-pouring-la-guida-definitiva",
  "welche-marker-und-stifte-fuer-kuenstler-de": "la-guida-definitiva-quali-pennarelli-e-matite-per-artisti",
  "welche-acrylpinsel-sind-ihr-geld-wert-ein-ehrlicher-vergleich-de": "quali-pennelli-per-acrilici-valgono-il-loro-prezzo-un-confro",
  "tusche-und-feder-dein-guide-fuer-ausdrucksstarke-zeichnungen-de": "inchiostro-e-pennino-la-tua-guida-per-disegni-espressivi",
  "wie-zeichne-ich-mit-kohle-guide-de": "come-disegnare-a-carboncino-la-tua-guida-per-unarte-espressi",
  "wie-zeichne-ich-ein-portrait-guide-zu-perfekten-proportionen-de": "come-disegnare-un-ritratto-la-tua-guida-per-proporzioni-perf",
  "skizzieren-lernen-schnell-und-locker-de": "imparare-a-fare-schizzi-come-disegnare-in-modo-rapido-e-scio",
  "aquarellstifte-kaufen-guide-de": "acquistare-matite-acquerellabili-la-tua-guida-per-risultati",
  "haende-und-fuesse-zeichnen-anatomie-meistern-wie-ein-profi-de": "disegnare-mani-e-piedi-padroneggiare-lanatomia-come-un-profe",
  "tiere-realistisch-zeichnen-guide-de": "disegnare-animali-in-modo-realistico-la-tua-guida-per-pelo-o",
  "wie-waehle-ich-das-richtige-zeichenpapier-de": "come-scegliere-la-carta-da-disegno-giusta-la-tua-guida",
  "buntstifte-wie-ein-profi-nutzen-guide-de": "usare-le-matite-colorate-come-un-professionista-la-tua-guida",
  "augen-realistisch-zeichnen-anleitung-de": "disegnare-occhi-in-modo-realistico-la-guida-definitiva-per-a",
  "radierer-und-hilfsmittel-fuer-perfekte-zeichnungen-de": "gomme-e-strumenti-di-supporto-la-tua-guida-per-disegni-perfe",
  "schmincke-aquarell-vergleich-horadam-vs-akademie-de": "confronto-acquerelli-schmincke-horadam-vs-akademie",
  "welche-aquarellfarbe-fuer-anfaenger-de": "quale-acquerello-per-principianti-la-tua-guida-per-iniziare",
  "faber-castell-polychromos-erfahrungen-guide-de": "faber-castell-polychromos-la-guida-definitiva-per-artisti",
  "winsor-newton-cotman-vs-professional-aquarell-vergleich-de": "winsor-newton-cotman-vs-professional-il-confronto-tra-acquer",
  "lukas-cryl-studio-vs-pastos-vergleich-de": "lukas-cryl-studio-vs-pastos-quale-acrilico-fa-per-te",
  "sennelier-oelpastelle-erfahrung-test-de": "esperienza-con-i-pastelli-a-olio-sennelier-il-test-dello-sta",
  "da-vinci-vs-raphael-pinsel-vergleich-de": "da-vinci-vs-raphael-il-confronto-definitivo-tra-pennelli",
  "artmie-butter-paste-guide-de": "artmie-butter-paste-la-tua-guida-per-strutture-morbide",
  "artmie-strukturpaste-guide-leinwand-de": "artmie-pasta-modellabile-la-tua-guida-per-rilievi-su-tela",
  "artmie-acrylfarbe-test-erfahrung-de": "test-dei-colori-acrilici-artmie-la-nostra-esperienza-con-la",
  "artmie-pouring-medium-anleitung-acryl-giessen-kinderleicht-de": "guida-al-pouring-medium-artmie-colata-acrilica-facile",
  "artmie-keilrahmen-qualitaet-test-de": "telai-artmie-qualita-e-consigli-professionali-testati",
  "das-perfekte-artmie-pinsel-set-finden-dein-guide-de": "trovare-il-set-di-pennelli-artmie-perfetto-la-tua-guida",
  "der-ultimative-guide-aquarellpapier-wahl-de": "la-guida-definitiva-quale-carta-per-acquerelli-ti-serve-davv",
  "das-perfekte-artmie-skizzenbuch-dein-guide-zur-wahl-de": "il-quaderno-per-schizzi-artmie-perfetto-la-tua-guida-alla-sc",
  "handlettering-lernen-anfaenger-guide-de": "imparare-lhandlettering-la-tua-guida-per-un-inizio-perfetto",
  "wer-war-vincent-van-gogh-das-leben-eines-genies-de": "chi-era-vincent-van-gogh-la-vita-di-un-genio",
  "beruehmte-kuenstlerinnen-wegbereiterinnen-der-kunstgeschichte-de": "artiste-famose-pioniere-della-storia-dellarte",
  "bauhaus-design-geschichte-und-einfluss-der-moderne-de": "bauhaus-design-storia-e-influenza-del-moderno",
  "kuenstlerbedarf-trends-2026-neuheiten-de": "tendenze-articoli-per-belle-arti-2026-cosa-ti-aspetta-nel-nu",
  "kunst-messen-2026-deutschland-guide-de": "fiere-darte-2026-in-germania-la-tua-guida-per-lanno-artistic",
  "kuenstlerbedarf-sale-rabatte-bei-artmie-de": "saldi-articoli-per-belle-arti-sfrutta-al-meglio-i-tuoi-scont",
  "wir-haben-den-shoproku-2024-gewonnen-und-das-ist-auch-ihr-verdienst-at": "abbiamo-vinto-il-shoproku-2024-e-questo-e-anche-merito-vostr",
  "auswertung-des-artmie-contest-2024-eine-explosion-an-kreativitaet-und-talent-in-der-ganzen-slowakei-at": "valutazione-dellartmie-contest-2024-unesplosione-di-creativi-3",
  "das-jahr-2024-ist-voller-artmie-neuheiten-welche-begruessen-wir-als-erste-at": "il-2024-e-pieno-di-novita-artmie-quali-accoglieremo-per-prim-2",
  "artmie-wettbewerb-kunstwettbewerb-fuer-schueler-von-kunstschulen-at": "concorso-artmie-concorso-artistico-per-studenti-delle-scuole",
  "der-undercover-boss-vali-hat-es-uebertrieben-buchstaeblich-wie-hat-er-sich-bei-der-arbeit-bei-artmie-geschlagen-at": "il-capo-sotto-copertura-vali-ha-esagerato-letteralmente-come-3",
  "der-shoproku-wettbewerb-ist-da-haben-wir-es-auch-dieses-mal-verdient-zu-gewinnen-at": "il-concorso-shoproku-e-arrivato-ci-siamo-meritati-la-vittori",
  "mach-mit-beim-inktober-mit-artmie-at": "partecipa-allinktober-con-artmie-3",
  "wie-ist-der-artmie-inktober-2021-ausgegangen-at": "come-andato-linktober-artmie-2021",
  "die-letzte-woche-des-artmie-inktober-steht-vor-der-tuer-at": "lultima-settimana-dellinktober-artmie-e-alle-porte",
  "artmie-inktober-themen-der-vierten-woche-at": "inktober-artmie-temi-della-quarta-settimana",
  "artmie-inktober-wir-inspirieren-sie-und-uns-at": "inktober-artmie-ispiriamo-voi-e-noi-stessi",
  "artmie-inktober-was-die-dritte-woche-bringt-at": "artmie-inktober-cosa-porta-la-terza-settimana-2",
  "artmie-inktober-themen-in-der-zweiten-woche-at": "artmie-inktober-temi-della-seconda-settimana-3",
  "der-eaa-kuenstlerwettbewerb-ist-dieses-jahr-voller-positiver-energie-at": "il-concorso-artistico-eaa-e-pieno-di-energia-positiva-questa",
  "inktober-die-herausforderung-die-kuenstler-weltweit-verbindet-at": "inktober-la-sfida-che-unisce-gli-artisti-di-tutto-il-mondo-3",
  "der-internationale-eaa-wettbewerb-hat-begonnen-reiche-auch-du-dein-werk-ein-at": "il-concorso-internazionale-eaa-e-iniziato-invia-anche-tu-la-2",
  "wir-haben-den-shoproku-2019-gewonnen-at": "abbiamo-vinto-il-premio-shoproku-2019-3",
  "wir-erfuellen-bunte-kuenstlertraeume-at": "realizziamo-i-sogni-colorati-degli-artisti-2",
  "kuenstlerbedarf-trends-2026-neuheiten-at": "tendenze-forniture-artistiche-2026-cosa-ti-aspetta-nel-nuovo",
  "kunst-messen-2026-deutschland-guide-at": "fiere-darte-2026-in-germania-la-tua-guida-per-lanno-artistic-2",
  "kuenstlerbedarf-sale-rabatte-bei-artmie-at": "saldi-forniture-artistiche-usa-in-modo-intelligente-i-tuoi-s",
  "bei-da-vinci-produkten-sprechen-wir-immer-von-handarbeit-und-hoher-qualitaet-wie-sieht-es-also-in-ihren-werkstaetten-aus-kommen-sie-mit-uns-und-werfen-sie-einen-blick-darauf-at": "quando-parliamo-dei-prodotti-da-vinci-parliamo-sempre-di-art-2",
  "werfen-sie-mit-uns-einen-blick-in-die-kreul-fabrik-at": "dai-unocchiata-con-noi-alla-fabbrica-kreul-2",
  "vom-skizzieren-zum-malen-kreul-triton-acrylmarker-halten-mit-dir-schritt-at": "dallo-schizzo-alla-pittura-i-pennarelli-acrilici-kreul-trito-2",
  "wie-vielseitig-ist-die-acrylfarbe-solo-goya-triton-at": "quanto-e-versatile-il-colore-acrilico-solo-goya-triton-2",
  "warum-sind-amsterdam-marker-die-besten-at": "perche-i-pennarelli-amsterdam-sono-i-migliori-2",
  "schmincke-aquarell-vergleich-horadam-vs-akademie-at": "confronto-acquerelli-schmincke-horadam-vs-akademie-2",
  "welche-aquarellfarbe-fuer-anfaenger-at": "quale-acquerello-per-principianti-la-tua-guida-per-iniziare-2",
  "faber-castell-polychromos-erfahrungen-guide-at": "faber-castell-polychromos-la-guida-definitiva-per-artisti-2",
  "winsor-newton-cotman-vs-professional-aquarell-vergleich-at": "winsor-newton-cotman-vs-professional-il-confronto-degli-acqu",
  "lukas-cryl-studio-vs-pastos-vergleich-at": "lukas-cryl-studio-vs-pastos-quale-acrilico-fa-per-te-2",
  "sennelier-oelpastelle-erfahrung-test-at": "esperienza-pastelli-a-olio-sennelier-il-gold-standard-in-tes",
  "da-vinci-vs-raphael-pinsel-vergleich-at": "da-vinci-vs-raphael-il-confronto-definitivo-dei-pennelli",
  "assemblage-vs-collage-was-ist-der-unterschied-und-wie-lassen-sich-diese-techniken-kreativ-verbinden-at": "assemblage-vs-collage-qual-e-la-differenza-e-come-si-possono",
  "wie-malt-man-mit-acrylfarben-auf-glas-glasobjekte-schritt-fuer-schritt-verwandeln-at": "come-dipingere-su-vetro-con-i-colori-acrilici-trasforma-ogge-2",
  "grundlagen-der-oelmalerei-wie-man-oelfarben-und-malmittel-fuer-beeindruckende-impasto-effekte-verwendet-at": "fondamenti-della-pittura-a-olio-come-utilizzare-i-colori-a-o",
  "schritt-fuer-schritt-mit-martin-horecny-wie-man-geometrische-kunst-mit-textur-erschafft-at": "passo-dopo-passo-con-martin-horecny-come-creare-arte-geometr-3",
  "stillleben-und-perspektive-entdecke-mit-jedem-strich-at": "natura-morta-e-prospettiva-scoprila-con-ogni-tratto",
  "schnellanleitung-fuer-folk-ostereier-oder-wenn-die-zeit-vor-ostern-knapp-wird-at": "guida-rapida-per-uova-di-pasqua-folk-o-quando-il-tempo-prima-2",
  "5-tipps-zur-auswahl-der-richtigen-staffelei-at": "5-consigli-per-scegliere-il-cavalletto-giusto-2",
  "entdecke-die-neue-artmie-app-dein-kuenstlerischer-begleiter-fuer-die-hosentasche-at": "scopri-la-nuova-app-artmie-il-tuo-compagno-artistico-in-tasc",
  "artmie-butter-paste-guide-at": "pasta-modellante-artmie-butter-paste-la-tua-guida-per-strutt",
  "artmie-strukturpaste-guide-leinwand-at": "pasta-strutturante-artmie-la-tua-guida-per-rilievi-su-tela",
  "artmie-acrylfarbe-test-erfahrung-at": "test-dei-colori-acrilici-artmie-la-nostra-esperienza-con-la-2",
  "artmie-pouring-medium-anleitung-acryl-giessen-kinderleicht-at": "guida-al-medium-per-pouring-artmie-larte-del-pouring-acrilic",
  "artmie-keilrahmen-qualitaet-test-at": "telai-artmie-qualita-e-consigli-professionali-nel-test",
  "das-perfekte-artmie-pinsel-set-finden-dein-guide-at": "trovare-il-set-di-pennelli-artmie-perfetto-la-tua-guida-2",
  "der-ultimative-guide-aquarellpapier-wahl-at": "la-guida-definitiva-di-quale-carta-per-acquerelli-hai-davver",
  "das-perfekte-artmie-skizzenbuch-dein-guide-zur-wahl-at": "il-quaderno-per-schizzi-artmie-perfetto-la-tua-guida-alla-sc-2",
  "wie-man-butter-paste-fuer-atemberaubende-texturen-verwendet-einfache-tipps-und-techniken-at": "come-usare-la-pasta-modellabile-per-texture-mozzafiato-consi",
  "zaubern-mit-farben-ein-einfacher-weg-strukturpaste-zum-leben-zu-erwecken-at": "magia-con-i-colori-un-modo-semplice-per-dare-vita-alla-pasta-3",
  "wie-man-sanfte-aquarellverlaeufe-malt-ein-einfacher-trick-fuer-traumhafte-hintergruende-at": "come-dipingere-sfumature-delicate-ad-acquerello-un-trucco-se",
  "erzeuge-bezaubernde-3d-effekte-mit-glas-schablonenfarbe-at": "crea-incantevoli-effetti-3d-con-il-colore-per-stencil-su-vet-2",
  "sommermagie-des-aquarells-malen-im-freien-als-neues-hobby-at": "magia-estiva-dellacquerello-dipingere-allaperto-come-nuovo-h-2",
  "wie-man-mit-gouache-eine-satte-deckkraft-erzielt-ein-praktischer-leitfaden-fuer-kreative-seelen-at": "come-ottenere-una-copertura-ricca-con-la-gouache-una-guida-p-2",
  "crackle-paste-mit-acrylfarbe-mischen-was-passiert-wenn-gold-auf-weiss-trifft-at": "mescolare-la-pasta-screpolante-con-i-colori-acrilici-cosa-su-2",
  "wie-erstellt-man-impasto-effekte-mit-gouachefarben-at": "come-creare-effetti-impasto-con-i-colori-a-guazzo-2",
  "entdecke-die-magie-der-textur-mit-strukturpaste-at": "scopri-la-magia-della-texture-con-la-pasta-modellante-2",
  "glanz-entfesseln-ein-leitfaden-fuer-metallische-akzente-in-deiner-kunst-at": "scatena-la-lucentezza-una-guida-per-accenti-metallizzati-nel",
  "neue-moeglichkeiten-mit-der-fluessigen-metallic-paste-artmie-midas-at": "nuove-possibilita-con-la-pasta-metallizzata-liquida-artmie-m",
  "spiel-mit-acrylfarben-4-tipps-fuer-die-abstrakte-verbindung-von-acryl-und-wasser-at": "gioco-con-i-colori-acrilici-4-consigli-per-la-combinazione-a",
  "11-praktische-tipps-fuer-die-gestaltung-von-plaster-art-mit-strukturpaste-at": "11-consigli-pratici-per-la-creazione-di-plaster-art-con-past",
  "wie-man-ein-portraet-mit-dem-pinsel-malt-tipps-fuer-ungewoehnliche-malgruende-at": "come-dipingere-un-ritratto-con-il-pennello-consigli-per-supp-2",
  "wie-malt-man-mit-gouache-super-tipps-von-artmie-at": "come-si-dipinge-con-la-tempera-ottimi-consigli-da-artmie-2",
  "gips-kunst-bei-artmie-wir-haben-den-heissen-trend-selbst-ausprobiert-at": "arte-in-gesso-da-artmie-abbiamo-provato-noi-stessi-questo-tr-2",
  "wie-verwendet-man-acrylfarben-vorteile-tipps-und-ratschlaege-fuer-anfaenger-und-fortgeschrittene-at": "come-si-usano-i-colori-acrilici-vantaggi-consigli-e-suggerim-2",
  "ihr-leitfaden-fuer-die-pouring-art-technik-at": "la-tua-guida-alla-tecnica-della-pouring-art",
  "wie-vergoldet-oder-patiniert-man-ein-kunstwerk-at": "come-si-dorano-o-si-patinano-le-opere-darte-2",
  "10-gruende-warum-sie-mit-der-mixed-media-technik-beginnen-sollten-at": "10-motivi-per-cui-dovresti-iniziare-con-la-tecnica-mixed-med-3",
  "wie-man-mit-tinten-malt-at": "come-dipingere-con-gli-inchiostri-3",
  "wie-man-mit-gouachefarben-malt-at": "come-dipingere-con-i-colori-a-tempera-2",
  "zaubern-mit-van-gogh-aquarellfarben-zimmerpflanzen-at": "magie-con-gli-acquerelli-van-gogh-piante-da-appartamento-2",
  "wie-man-malmesser-verwendet-wir-malen-eine-fruehlingswiese-at": "come-usare-le-spatole-dipingiamo-un-prato-primaverile-3",
  "5-wege-eine-katze-zu-malen-at": "5-modi-per-dipingere-un-gatto-3",
  "wie-man-mit-acrylfarben-anfaengt-at": "come-iniziare-con-i-colori-acrilici-3",
  "pleinair-malerei-entdecken-wir-gemeinsam-die-schoenheit-der-natur-at": "pittura-en-plein-air-scopriamo-insieme-la-bellezza-della-nat-2",
  "entdecken-sie-die-magie-der-oelmalerei-at": "scopri-la-magia-della-pittura-a-olio-2",
  "finden-sie-sich-mit-uns-in-der-welt-der-oelfarben-zurecht-at": "orientati-con-noi-nel-mondo-dei-colori-a-olio",
  "landschaftsmalerei-eine-schritt-fuer-schritt-anleitung-at": "pittura-di-paesaggi-una-guida-passo-dopo-passo-2",
  "wie-malt-man-blumen-mit-aquarellfarben-at": "come-dipingere-fiori-con-gli-acquerelli-2",
  "wie-malt-man-einfach-eine-rose-at": "come-dipingere-facilmente-una-rosa-2",
  "wie-mischt-man-acrylfarben-at": "come-miscelare-i-colori-acrilici-2",
  "textilmalerei-wird-dich-begeistern-at": "la-pittura-su-tessuto-ti-entusiasmera-2",
  "wie-arbeitet-man-mit-acrylfarben-at": "come-lavorare-con-i-colori-acrilici-2",
  "wie-man-ein-originelles-weihnachtsbild-gestaltet-at": "come-creare-unimmagine-natalizia-originale-2",
  "wie-bemalt-man-textilien-at": "come-dipingere-i-tessuti",
  "10-tipps-zum-malen-mit-im-dunkeln-leuchtenden-farben-at": "10-consigli-per-dipingere-con-colori-luminescenti-2",
  "acryl-giessen-harmonie-im-fluss-at": "acrylic-pouring-armonia-nel-flusso-2",
  "probiere-die-spachteltechnik-aus-at": "prova-la-tecnica-della-spatola-2",
  "welche-maltechniken-solltest-du-beherrschen-at": "quali-tecniche-pittoriche-dovresti-padroneggiare-2",
  "welche-leinwand-ist-besser-fuer-sie-baumwolle-oder-leinen-at": "quale-tela-e-migliore-per-te-cotone-o-lino-2",
  "regenbogen-glasuren-auf-keramik-das-kunstatelier-von-brian-giniewski-at": "smalti-arcobaleno-su-ceramica-latelier-darte-di-brian-giniew-2",
  "seidenmalerei-bewirkt-wunder-ueberzeuge-dich-selbst-mit-uns-at": "la-pittura-su-seta-fa-miracoli-provalo-tu-stesso-con-noi-2",
  "wie-viel-wissen-sie-ueber-die-anatomie-von-malpinseln-at": "quanto-ne-sai-sullanatomia-dei-pennelli-4",
  "wussten-sie-schon-von-wasservermalbaren-oelfarben-at": "sapevi-dellesistenza-dei-colori-a-olio-idrosolubili-2",
  "leinwand-auf-keilrahmen-aufziehen-was-sie-wissen-muessen-at": "montare-una-tela-su-telaio-cosa-devi-sapere-2",
  "eine-kreative-und-ungewoehnliche-kombination-tusche-und-oelpastellkreiden-at": "una-combinazione-creativa-e-insolita-inchiostro-e-pastelli-a-3",
  "haben-sie-schon-die-express-transfer-loesung-ausprobiert-at": "hai-gia-provato-la-soluzione-per-il-trasferimento-rapido-2",
  "was-ist-besser-fuer-sie-baumwoll-oder-leinenleinwand-at": "cosa-e-meglio-per-te-tela-di-cotone-o-di-lino-3",
  "was-weisst-du-ueber-die-anatomie-von-malpinseln-at": "cosa-sai-sullanatomia-dei-pennelli-3",
  "kennen-sie-schon-wasservermalbare-oelfarben-at": "conosci-gia-i-colori-a-olio-idrosolubili-2",
  "welche-sind-besser-naturhaarpinsel-oder-synthetikpinsel-at": "quali-sono-migliori-pennelli-in-pelo-naturale-o-sintetici",
  "wie-viel-wissen-sie-ueber-die-anatomie-von-pinseln-at": "quanto-ne-sai-sullanatomia-dei-pennelli-5",
  "wussten-sie-schon-dass-acrylfarben-diese-eigenschaften-haben-at": "sapevi-che-i-colori-acrilici-hanno-queste-proprieta-2",
  "was-sind-acryl-strukturpasten-und-wofuer-werden-sie-verwendet-at": "cosa-sono-le-paste-strutturanti-acriliche-e-a-cosa-servono-3",
  "wie-reinigt-man-pinsel-nach-dem-malen-richtig-at": "come-pulire-correttamente-i-pennelli-dopo-aver-dipinto-3",
  "kennen-sie-alle-geheimnisse-der-pouring-technik-at": "conosci-tutti-i-segreti-della-tecnica-del-pouring-2",
  "was-ist-besser-fuer-dich-natur-oder-synthetikpinsel-at": "cosa-e-meglio-per-te-pennelli-in-pelo-naturale-o-sintetici-2",
  "wussten-sie-dass-acrylfahrbe-diese-eigenschaften-hat-at": "sapevate-che-i-colori-acrilici-hanno-queste-proprieta-2",
  "aquarell-malen-lernen-dein-schritt-fuer-schritt-guide-at": "imparare-a-dipingere-con-gli-acquerelli-la-tua-guida-passo-d",
  "mixed-media-guide-so-kombinierst-du-farben-und-materialien-at": "guida-al-mixed-media-come-combinare-colori-e-materiali-2",
  "tiffany-glasmalerei-anleitung-fuer-dein-erstes-kunstwerk-at": "pittura-su-vetro-tiffany-guida-per-la-tua-prima-opera-darte-2",
  "textilfarbe-richtig-anwenden-dein-guide-fuer-stoffmalerei-at": "applicare-correttamente-i-colori-per-tessuti-la-tua-guida-pe-2",
  "welche-maltechnik-ist-die-richtige-fuer-mich-at": "quale-tecnica-pittorica-e-quella-giusta-per-me-la-tua-guida",
  "encaustic-fuer-einsteiger-wachsmalerei-schritt-fuer-schritt-erklaert-at": "encausto-per-principianti-la-pittura-a-cera-spiegata-passo-d-2",
  "acrylbild-versiegeln-so-schuetzt-du-deine-kunstwerke-richtig-at": "sigillare-un-dipinto-acrilico-ecco-come-proteggere-correttam-2",
  "himmel-und-wolken-realistisch-malen-tipps-at": "dipingere-cielo-e-nuvole-in-modo-realistico-consigli-profess",
  "bleistiftzeichnen-tipps-fuer-anfaenger-und-fortgeschrittene-at": "disegno-a-matita-consigli-per-principianti-ed-esperti-3",
  "wie-man-farben-mit-pinselstiften-blendet-einfache-ombre-effekte-at": "come-sfumare-i-colori-con-i-pennarelli-a-punta-a-pennello-se",
  "kalligrafie-und-hand-lettering-warum-es-ausprobieren-at": "calligrafia-e-hand-lettering-perche-provarli-2",
  "zeichnen-sie-mit-uns-schneegloeckchen-artmie-at": "disegna-con-noi-dei-bucaneve-artmie-3",
  "wie-zeichnet-man-einen-wunderschoenen-schmetterling-at": "come-si-disegna-una-bellissima-farfalla-2",
  "wie-man-eine-figur-zeichnet-anleitung-at": "come-disegnare-una-figura-umana-guida",
  "wie-man-die-kunst-der-kalligrafie-erlernt-oder-seine-handschrift-verbessert-at": "come-imparare-larte-della-calligrafia-o-migliorare-la-propri-2",
  "linolschnitt-fuer-anfaenger-wie-man-einen-stempel-herstellt-at": "linoleografia-per-principianti-come-realizzare-un-timbro-3",
  "manga-und-comics-zeichnen-mit-copic-markern-at": "disegnare-manga-e-fumetti-con-i-marker-copic-2",
  "wie-legt-man-ein-skizzenbuch-an-at": "come-iniziare-un-album-da-disegno-2",
  "urban-sketching-mit-stift-und-pinsel-auf-die-strasse-at": "urban-sketching-in-strada-con-penna-e-pennello-3",
  "bleistiftzeichnen-von-der-theorie-zur-praxis-at": "disegno-a-matita-dalla-teoria-alla-pratica-3",
  "zeichnen-mit-bleistift-lerne-die-zeichentechniken-at": "disegnare-a-matita-impara-le-tecniche-di-disegno-2",
  "4-fantastische-tricks-fuer-besseres-zeichnen-at": "4-fantastici-trucchi-per-disegnare-meglio-3",
  "kursivschrift-at": "corsivo-2",
  "zeichenideen-at": "idee-di-disegno-per-principianti-come-iniziare-il-tuo-viaggi-2",
  "tusche-und-feder-dein-guide-fuer-ausdrucksstarke-zeichnungen-at": "inchiostro-e-pennino-la-tua-guida-per-disegni-espressivi-2",
  "wie-zeichne-ich-mit-kohle-guide-at": "come-disegnare-a-carboncino-la-tua-guida-per-unarte-espressi-2",
  "wie-zeichne-ich-ein-portrait-guide-zu-perfekten-proportionen-at": "come-disegnare-un-ritratto-la-tua-guida-alle-proporzioni-per",
  "skizzieren-lernen-schnell-und-locker-at": "imparare-a-fare-schizzi-come-disegnare-in-modo-rapido-e-scio-2",
  "aquarellstifte-kaufen-guide-at": "acquistare-matite-acquerellabili-la-tua-guida-per-risultati-2",
  "haende-und-fuesse-zeichnen-anatomie-meistern-wie-ein-profi-at": "disegnare-mani-e-piedi-padroneggiare-lanatomia-come-un-profe-2",
  "tiere-realistisch-zeichnen-guide-at": "disegnare-animali-in-modo-realistico-la-tua-guida-per-pelo-o-2",
  "wie-waehle-ich-das-richtige-zeichenpapier-at": "come-scelgo-la-carta-da-disegno-giusta-la-tua-guida",
  "buntstifte-wie-ein-profi-nutzen-guide-at": "usare-le-matite-colorate-come-un-professionista-la-tua-guida-2",
  "augen-realistisch-zeichnen-anleitung-at": "disegnare-occhi-in-modo-realistico-la-guida-definitiva-per-a-2",
  "radierer-und-hilfsmittel-fuer-perfekte-zeichnungen-at": "gomme-e-strumenti-ausiliari-la-tua-guida-per-disegni-perfett",
  "pinsel-gefuehle-folge-deiner-hand-und-deinem-herzen-at": "pennelli-ed-emozioni-segui-la-tua-mano-e-il-tuo-cuore-2",
  "wie-waehlt-man-die-richtige-malerleinwand-aus-vergleich-von-oeko-baumwoll-und-leinenleinwaenden-at": "come-scegliere-la-tela-da-pittura-giusta-confronto-tra-tele-2",
  "kuenstlerische-texturen-entdecken-mit-martin-horecny-modellierpaste-vs-reliefpaste-at": "scoprire-le-texture-artistiche-con-martin-horecny-pasta-mode-2",
  "wie-haelt-man-eine-malpalette-richtig-einfache-anleitung-fuer-bequemes-malen-at": "come-tenere-correttamente-una-tavolozza-guida-semplice-per-d-2",
  "hahnemuehle-skizzenbuch-das-tagebuch-eines-professionellen-kuenstlers-at": "album-da-disegno-hahnemuhle-il-diario-di-un-artista-professi-2",
  "entfessle-die-magie-6-wichtige-dinge-die-jeder-kuenstler-ueber-acrylfarben-wissen-sollte-at": "scatena-la-magia-6-cose-importanti-che-ogni-artista-dovrebbe-2",
  "verleihe-deinem-kunstwerk-tiefe-mit-der-artmie-butter-paste-at": "dai-profondita-alla-tua-opera-darte-con-la-butter-paste-artm",
  "malen-wie-die-alten-meister-mit-der-museal-leinwand-aus-leinen-at": "dipingere-come-gli-antichi-maestri-con-la-tela-museal-in-lin-2",
  "einfuehrung-in-die-welt-der-oelpastelle-ein-kompletter-leitfaden-fuer-anfaenger-at": "introduzione-al-mondo-dei-pastelli-a-olio-una-guida-completa-2",
  "wie-man-das-wellen-von-papier-im-rahmen-verhindert-at": "come-evitare-che-la-carta-si-onduli-nella-cornice",
  "keilrahmen-spannkeile-wie-und-wann-verwendet-man-sie-at": "cunei-per-tela-come-e-quando-usarli",
  "zaubern-sie-auf-der-leinwand-was-koennen-die-vielseitigen-artmie-malmesser-alles-leisten-at": "crea-magie-sulla-tela-cosa-possono-fare-le-versatili-spatole-2",
  "oelfarben-eigenschaften-und-grundlegende-pigmente-at": "colori-a-olio-proprieta-e-pigmenti-fondamentali",
  "wie-repariert-man-eine-eingedrueckte-malerleinwand-at": "come-riparare-una-tela-ammaccata",
  "wie-man-die-richtige-pinselgroesse-auswaehlt-at": "come-scegliere-la-dimensione-corretta-del-pennello",
  "wie-man-acrylfarben-nach-viskositaet-auswaehlt-at": "come-scegliere-i-colori-acrilici-in-base-alla-viscosita-3",
  "5-gruende-warum-sie-mit-acryl-statt-mit-oelfarben-malen-sollten-at": "5-motivi-per-cui-dovresti-dipingere-con-gli-acrilici-invece-2",
  "6-tipps-fuer-ein-atelier-voller-harmonie-und-freiheit-at": "6-consigli-per-un-atelier-pieno-di-armonia-e-liberta-2",
  "wie-man-eine-leinwand-auswaehlt-at": "come-scegliere-una-tela-3",
  "keine-angst-vor-aquarell-erste-eindruecke-von-white-nights-aquarellfarben-at": "nessuna-paura-dellacquerello-prime-impressioni-sui-colori-ac",
  "wie-waehlt-man-das-richtige-aquarellpapier-aus-at": "come-scegliere-la-carta-per-acquerello-giusta-3",
  "wie-laesst-sich-die-lichtechtheit-von-gemaelden-verbessern-at": "come-si-puo-migliorare-la-resistenza-alla-luce-dei-dipinti",
  "wissen-sie-wirklich-alles-ueber-polymer-clay-at": "sai-davvero-tutto-sul-polymer-clay",
  "was-wissen-sie-ueber-polymerton-at": "cosa-sai-sulla-pasta-polimerica-3",
  "6-dinge-die-ihre-pinsel-langsam-zerstoeren-at": "6-cose-che-distruggono-lentamente-i-tuoi-pennelli-2",
  "artmie-malmesser-at": "spatole-per-pittura-artmie-2",
  "wie-verwendet-man-artmie-malmesser-schritt-fuer-schritt-at": "come-si-usano-le-spatole-per-pittura-artmie-passo-dopo-passo-2",
  "alles-was-sie-ueber-glasfarben-wissen-muessen-at": "tutto-quello-che-devi-sapere-sui-colori-per-vetro-2",
  "alginat-die-begehrte-abformmasse-at": "alginato-la-ricercata-massa-per-calchi",
  "ist-das-firnissen-von-gemaelden-notwendig-at": "e-necessario-verniciare-i-dipinti-2",
  "mythos-oder-wahrheit-ist-das-firnissen-eines-gemaeldes-pflicht-at": "mito-o-verita-verniciare-un-dipinto-e-un-obbligo-2",
  "das-ewige-dilemma-terpentin-oder-leinoel-at": "leterno-dilemma-trementina-o-olio-di-lino-3",
  "was-bedeuten-die-symbole-auf-farbtuben-at": "cosa-significano-i-simboli-sui-tubetti-di-colore-2",
  "das-dilemma-beim-malen-titanweiss-oder-zinkweiss-at": "il-dilemma-del-pittore-bianco-di-titanio-o-bianco-di-zinco",
  "die-besten-pinsel-fuer-acrylmalerei-dein-guide-fuer-den-start-at": "i-migliori-pennelli-per-la-pittura-acrilica-la-tua-guida-per-2",
  "welche-staffelei-kaufen-dein-guide-fuer-den-perfekten-halt-at": "quale-cavalletto-acquistare-la-tua-guida-per-il-supporto-per",
  "studio-vs-kuenstlerqualitaet-was-steckt-in-der-farbtube-at": "qualita-studio-vs-qualita-artista-cosa-ce-nel-tubetto-di-col",
  "royal-talens-vs-schmincke-aquarellfarben-vergleich-at": "royal-talens-vs-schmincke-quali-acquerelli-scegliere-2",
  "acrylmalerei-fuer-anfaenger-grundausstattung-at": "pittura-acrilica-per-principianti-la-tua-dotazione-di-base-d",
  "ordnung-im-atelier-perfekte-aufbewahrung-kuenstlermaterial-at": "ordine-in-atelier-la-soluzione-perfetta-per-conservare-i-tuo",
  "kuenstlerbedarf-online-kaufen-sparen-at": "acquistare-materiale-artistico-online-ecco-come-risparmiare-2",
  "welches-pouring-medium-ist-das-beste-guide-at": "qual-e-il-miglior-medium-per-pouring-la-guida-definitiva-2",
  "welche-marker-und-stifte-fuer-kuenstler-at": "la-guida-definitiva-quali-pennarelli-e-matite-scegliere-per",
  "welche-acrylpinsel-sind-ihr-geld-wert-ein-ehrlicher-vergleich-at": "quali-pennelli-per-acrilico-valgono-il-loro-prezzo-un-confro",
  "wie-man-zu-hause-eine-batik-tasche-herstellt-eine-einfache-anleitung-fuer-jeden-at": "come-realizzare-una-borsa-batik-a-casa-una-guida-semplice-pe-3",
  "einfache-diy-anleitung-fuer-harz-anhaenger-gestalte-glitzernde-geschenke-zu-hause-at": "semplice-guida-fai-da-te-per-ciondoli-in-resina-crea-regali-2",
  "wie-man-elegante-reliefkunst-aus-schaumstoffplatten-auf-leinwand-erstellt-eine-schritt-fuer-schritt-anleitung-at": "come-creare-unelegante-arte-in-rilievo-su-tela-utilizzando-p",
  "5-tipps-fuer-originelle-weihnachtsdekorationen-at": "5-consigli-per-decorazioni-natalizie-originali-3",
  "weihnachtsdekoration-aus-papier-kreativer-und-oekologischer-festtagsschmuck-at": "decorazioni-natalizie-di-carta-addobbi-creativi-ed-ecologici",
  "dunkelheit-vor-dem-fenster-diese-7-aktivitaeten-verschoenern-ihre-langen-abende-at": "buio-fuori-dalla-finestra-queste-7-attivita-renderanno-piu-b-2",
  "5-tipps-fuer-herbstliches-basteln-at": "5-consigli-per-il-fai-da-te-autunnale-2",
  "serviettentechnik-was-ist-decoupage-und-wie-funktioniert-sie-at": "tecnica-del-tovagliolo-cose-il-decoupage-e-come-funziona-2",
  "bemalte-handtasche-schritt-fuer-schritt-at": "borsa-dipinta-a-mano-passo-dopo-passo",
  "wie-man-moderne-ohrringe-aus-polymer-clay-herstellt-at": "come-realizzare-orecchini-moderni-in-pasta-polimerica-2",
  "wie-bemalt-man-einen-kuerbis-mit-der-zentangle-technik-at": "come-dipingere-una-zucca-con-la-tecnica-zentangle-3",
  "was-tun-mit-einer-zerrissenen-leinwand-ein-kreatives-memory-spiel-at": "cosa-fare-con-una-tela-strappata-un-gioco-di-memoria-creativ-2",
  "bastelanleitung-dekorative-kerzen-mit-pflanzen-at": "guida-al-fai-da-te-candele-decorative-con-piante-2",
  "die-geheimnisse-des-scrapbookings-entdecken-wie-man-aus-einfachen-komponenten-kunstwerke-schafft-at": "scoprire-i-segreti-dello-scrapbooking-come-creare-opere-dart-2",
  "selbermachen-bienenwachstuecher-fuer-lebensmittel-at": "fai-da-te-pellicole-di-cera-dapi-per-alimenti-2",
  "8-arten-washi-tapes-zu-verwenden-artmie-at": "8-modi-per-utilizzare-i-washi-tape-artmie-2",
  "diy-makramee-dekoration-aus-garn-at": "fai-da-te-decorazione-in-macrame-con-filo",
  "diy-selbstgemachte-duftende-seife-at": "fai-da-te-sapone-profumato-fatto-in-casa-2",
  "entspannungsmalbuecher-fuer-erwachsene-einfach-ausdrucken-und-losmalen-at": "libri-da-colorare-antistress-per-adulti-basta-stampare-e-ini-2",
  "nagel-und-fadenbild-gestalte-deine-eigene-originelle-dekoration-at": "string-art-crea-la-tua-decorazione-originale-2",
  "bastelanleitung-blumen-aus-krepppapier-at": "guida-al-fai-da-te-fiori-di-carta-crespa-2",
  "wie-man-mit-scrapbooking-beginnt-at": "come-iniziare-con-lo-scrapbooking-3",
  "diy-osterei-mit-gold-verziert-2022-at": "diy-uovo-di-pasqua-decorato-con-loro-2022",
  "diy-oster-eier-mit-glitzer-at": "diy-uova-di-pasqua-con-glitter-2",
  "diy-mit-trockenblumen-verzierte-ostereier-at": "diy-uova-di-pasqua-decorate-con-fiori-secchi",
  "bastelanleitung-ueberraschungs-osterei-at": "guida-al-fai-da-te-uovo-di-pasqua-a-sorpresa-2",
  "3-ideen-fuer-osterbasteleien-2022-at": "3-idee-per-lavoretti-di-pasqua-2022",
  "diy-vogelhaeuschen-selber-bauen-at": "fai-da-te-costruire-una-casetta-per-uccelli-2",
  "diy-gehaekelte-ostereier-at": "fai-da-te-uova-di-pasqua-alluncinetto-3",
  "diy-handgemachte-tasche-aus-kunstleder-at": "fai-da-te-borsa-fatta-a-mano-in-ecopelle-3",
  "diy-oekologische-einkaufstasche-at": "fai-da-te-borsa-della-spesa-ecologica-3",
  "wie-man-halloween-dekorationen-bastelt-at": "come-creare-decorazioni-di-halloween-2",
  "wie-man-eine-kerze-mit-staender-herstellt-at": "come-realizzare-una-candela-con-supporto-2",
  "gestalten-sie-eine-wunderschoene-halloween-dekoration-at": "crea-una-bellissima-decorazione-di-halloween-2",
  "wie-gestaltet-man-originelles-kuechengeschirr-at": "come-decorare-stoviglie-originali-2",
  "probieren-sie-den-hit-des-jahres-aus-malen-nach-zahlen-at": "prova-il-successo-dellanno-dipingere-con-i-numeri-2",
  "glaenzen-sie-auf-der-halloween-party-mit-snazaroo-gesichtsfarben-at": "brilla-alla-festa-di-halloween-con-i-colori-per-il-viso-snaz-2",
  "wie-gelingen-einfache-aber-effektvolle-osterdekorationen-at": "come-realizzare-decorazioni-pasquali-semplici-ma-deffetto-2",
  "selber-machen-seidenmalrahmen-aus-keilrahmenleisten-at": "fai-da-te-telaio-per-pittura-su-seta-con-listelli-per-tela",
  "was-kann-man-zu-hause-waehrend-der-quarantaene-tun-wir-haben-tipps-fuer-kreative-projekte-at": "cosa-fare-a-casa-durante-la-quarantena-abbiamo-consigli-per-2",
  "wie-man-eine-glasvase-bemalt-at": "come-dipingere-un-vaso-di-vetro-3",
  "magische-trends-der-glasmalerei-at": "tendenze-magiche-della-pittura-su-vetro-2",
  "diy-keramiktassen-mit-verlaufender-regenbogen-glasur-at": "fai-da-te-tazze-in-ceramica-con-smalto-arcobaleno-sfumato-2",
  "diy-fruehlingskranz-im-landhausstil-at": "fai-da-te-ghirlanda-primaverile-in-stile-country-2",
  "wenn-baeume-sprechen-anleitung-fuer-bemalte-holzdekorationen-at": "quando-gli-alberi-parlano-guida-per-decorazioni-in-legno-dip-2",
  "wie-das-batiken-meine-schwarz-weisse-welt-veraendert-hat-at": "come-il-batik-ha-cambiato-il-mio-mondo-in-bianco-e-nero-3",
  "scrapbooking-ideen-und-beispiele-at": "scrapbooking-idee-ed-esempi-3",
  "diy-holzdekoration-anleitung-zum-basteln-mit-naegeln-at": "fai-da-te-decorazione-in-legno-guida-per-creare-con-i-chiodi",
  "kreative-deko-tipps-fuer-kuerbisse-verwenden-sie-holzdekorationen-und-temperafarben-at": "consigli-creativi-per-decorare-le-zucche-usa-decorazioni-in-2",
  "ein-paar-interessante-fakten-ueber-decoupage-die-sie-noch-nicht-kannten-at": "alcuni-fatti-interessanti-sul-decoupage-che-ancora-non-conos-2",
  "einige-super-fakten-ueber-die-decoupage-technik-die-sie-noch-nicht-kennen-at": "alcuni-fatti-super-sulla-tecnica-del-decoupage-che-ancora-no-2",
  "handlettering-lernen-anfaenger-guide-at": "imparare-lhandlettering-la-tua-guida-per-un-inizio-perfetto-2",
  "farbakkorde-in-der-kunst-das-spiel-mit-der-harmonie-auf-deiner-palette-at": "accordi-cromatici-nellarte-il-gioco-dellarmonia-sulla-tua-ta-2",
  "wie-waere-es-wenn-du-ein-tagebuch-beginnen-wuerdest-genau-jetzt-at": "che-ne-dici-di-iniziare-un-diario-proprio-ora-2",
  "valentins-inspiration-fuer-jeden-kreativen-at": "ispirazione-di-san-valentino-per-ogni-creativo-3",
  "erstelle-eine-kreative-botschaft-fuer-dein-zukuenftiges-ich-at": "crea-un-messaggio-creativo-per-il-tuo-io-futuro-3",
  "interview-mit-der-kuenstlerin-und-aerztin-barbora-sebes-at": "intervista-con-lartista-e-medico-barbora-sebes-3",
  "erlebe-euphorie-bei-der-erschaffung-deines-kunstwerks-at": "prova-euforia-creando-la-tua-opera-darte",
  "farben-mischen-wir-zeigen-dir-wie-es-geht-at": "mescolare-i-colori-ti-mostriamo-come-fare-3",
  "8-geschenkideen-fuer-kuenstler-at": "8-idee-regalo-per-artisti-2",
  "die-geheime-sprache-der-malerei-wie-man-ein-kunstwerk-liest-at": "il-linguaggio-segreto-della-pittura-come-leggere-unopera-dar-3",
  "entdecke-die-besten-farbkombinationen-beim-malen-at": "scopri-le-migliori-combinazioni-di-colori-nella-pittura-3",
  "farbe-des-monats-mai-hellrosa-at": "colore-del-mese-di-maggio-rosa-chiaro-3",
  "aquarellfarben-quiz-at": "quiz-sugli-acquerelli-3",
  "farbe-des-monats-april-wachsgelb-2022-at": "colore-del-mese-di-aprile-giallo-cera-2022-3",
  "farbe-des-monats-maerz-orange-at": "colore-del-mese-di-marzo-arancione-3",
  "farbe-des-monats-februar-eisminz-at": "colore-del-mese-di-febbraio-menta-ghiacciata-2",
  "was-zum-valentinstag-5-filme-mit-kuenstlerischem-touch-die-du-gesehen-haben-musst-at": "cosa-regalare-a-san-valentino-5-film-con-un-tocco-artistico-2",
  "wir-kennen-die-farbe-des-jahres-2022-at": "conosciamo-il-colore-dellanno-2022-3",
  "farbe-des-monats-januar-indigo-at": "colore-del-mese-di-gennaio-indaco-3",
  "begriffe-aus-der-kunstwelt-die-deinen-horizont-erweitern-at": "termini-del-mondo-dellarte-che-amplieranno-i-tuoi-orizzonti-3",
  "ein-punkt-hinter-dem-sommer-ozeanblau-at": "un-punto-dopo-lestate-blu-oceano-2",
  "farbe-des-monats-juli-gold-at": "colore-del-mese-di-luglio-oro-3",
  "10-filme-ueber-kuenstler-die-man-gesehen-haben-muss-at": "10-film-sugli-artisti-che-devi-assolutamente-vedere-3",
  "farben-fuer-das-jahr-2021-at": "colori-per-lanno-2021-3",
  "im-einklang-mit-der-natur-oekologisch-und-kreativ-gestalten-at": "in-armonia-con-la-natura-creare-in-modo-ecologico-e-creativo-2",
  "du-weisst-nicht-was-du-malen-sollst-diese-staedte-wecken-deine-kreativitaet-at": "non-sai-cosa-dipingere-queste-citta-risvegliano-la-tua-creat-2",
  "kreativitaet-baut-stress-ab-bringen-sie-sich-und-ihre-familie-auch-in-der-haeuslichen-quarantaene-ins-gleichgewicht-wir-zeigen-ihnen-wie-es-geht-at": "la-creativita-riduce-lo-stress-ritrova-lequilibrio-per-te-e",
  "wie-koennen-sie-ihre-kuenstlerischen-faehigkeiten-verbessern-10-tipps-at": "come-puoi-migliorare-le-tue-abilita-artistiche-10-consigli-2",
  "oelfarben-und-das-erfolgsgeheimnis-von-gerhard-richter-at": "i-colori-a-olio-e-il-segreto-del-successo-di-gerhard-richter-3",
  "woher-kommt-malen-nach-zahlen-at": "da-dove-viene-la-pittura-con-i-numeri-2",
  "was-schenkt-man-einer-frau-zum-internationalen-frauentag-at": "cosa-regalare-a-una-donna-per-la-giornata-internazionale-del-2",
  "farbe-des-jahres-2019-auf-leinwand-und-sneakern-at": "colore-dellanno-2019-su-tela-e-sneaker-2",
  "6-gruende-warum-man-mit-einem-kuenstler-ausgehen-sollte-at": "6-motivi-per-cui-dovresti-uscire-con-un-artista-2",
  "was-ist-ein-fresko-at": "cose-un-affresco-2",
  "weihnachten-steht-vor-der-tuer-was-schenkt-man-einem-kuenstler-at": "il-natale-e-alle-porte-cosa-regalare-a-un-artista-2",
  "orange-eine-farbe-die-man-nicht-unterschaetzen-sollte-at": "arancione-un-colore-da-non-sottovalutare-3",
  "wir-sind-fasziniert-pop-art-nach-30-jahren-wiederentdeckt-at": "siamo-affascinati-la-pop-art-riscoperta-dopo-30-anni-2",
  "die-geheimnisse-von-andy-warhols-schaffen-at": "i-segreti-del-lavoro-di-andy-warhol-2",
  "rasto-ekkert-anfaenge-sind-schwer-aber-es-ist-wichtig-seinen-eigenen-weg-zu-finden-at": "rasto-ekkert-gli-inizi-sono-difficili-ma-e-importante-trovar-2",
  "was-ist-grafik-at": "cose-la-grafica-2",
  "die-kunstkarte-europas-weisst-du-welcher-kuenstler-die-slowakei-repraesentiert-at": "la-mappa-artistica-delleuropa-sai-quale-artista-rappresenta-2",
  "wunderschoene-glasskulpturen-in-baumstaemmen-at": "splendide-sculture-in-vetro-allinterno-di-tronchi-dalbero-2",
  "der-zauber-der-restaurierung-at": "la-magia-del-restauro-2",
  "rate-mal-womit-ich-zeichne-at": "indovina-con-cosa-sto-disegnando-3",
  "wissenschaftler-haben-einen-neuen-blauton-entdeckt-weisst-du-wie-er-heisst-at": "gli-scienziati-hanno-scoperto-una-nuova-tonalita-di-blu-sai-2",
  "einzigartige-aufnahme-eines-oelgemaeldes-aus-dem-film-loving-vincent-at": "ripresa-unica-di-un-dipinto-a-olio-dal-film-loving-vincent-2",
  "m-rost-effekt-einst-unerwuenscht-heute-ein-willkommenes-element-in-der-kreativen-gestaltung-at": "effetto-ruggine-un-tempo-indesiderato-oggi-un-elemento-benve",
  "was-ist-die-operation-nachtwache-und-warum-ist-sie-so-wichtig-at": "cose-loperazione-ronda-di-notte-e-perche-e-cosi-importante",
  "die-beruehmtesten-werke-von-pablo-picasso-at": "le-opere-piu-famose-di-pablo-picasso-3",
  "rost-effekt-einst-unerwuenscht-heute-ein-willkommener-effekt-at": "effetto-ruggine-un-tempo-indesiderato-oggi-un-effetto-ricerc-2",
  "die-teuersten-gemaelde-der-welt-at": "i-dipinti-piu-costosi-al-mondo-2",
  "5-tipps-wie-du-dein-gemaelde-ausdrucksstaerker-machst-at": "5-consigli-per-rendere-i-tuoi-dipinti-piu-espressivi-2",
  "eaa-2021-interview-mit-der-jury-bulgarien-at": "intervista-alla-giuria-delleaa-2021-bulgaria-2",
  "kunst-aus-geschmolzenem-glas-und-holz-die-einzigartige-kunst-von-slagerman-und-fishman-at": "arte-in-vetro-fuso-e-legno-larte-unica-di-slagerman-e-fishma-2",
  "wussten-sie-dass-es-ein-pigmentmuseum-gibt-at": "sapevi-che-esiste-un-museo-dei-pigmenti-3",
  "milica-bjelanovic-eine-leidenschaft-die-grafik-zum-leben-erweckt-at": "milica-bjelanovic-una-passione-che-da-vita-alla-grafica-2",
  "kunstkolonie-vranje-2018-offiziell-eroeffnet-at": "colonia-artistica-vranje-2018-inaugurazione-ufficiale-2",
  "eaa-2021-interview-mit-der-jury-nordmazedonien-at": "intervista-alla-giuria-delleaa-2021-macedonia-del-nord",
  "wie-die-geheimnisvolle-dame-in-rot-enthuellt-wird-at": "come-viene-svelata-la-misteriosa-dama-in-rosso-3",
  "neda-laketic-soc-eine-bildhauerin-mit-aussergewoehnlicher-malerischer-leidenschaft-und-kunstfertigkeit-at": "neda-laketic-soc-una-scultrice-con-una-straordinaria-passion-2",
  "dunja-sirmium-mosaikkuenstlerin-mit-aussergewoehnlicher-maltechnik-at": "dunja-sirmium-artista-del-mosaico-con-una-tecnica-pittorica-2",
  "interview-mit-der-eaa-jury-2021-bulgarien-at": "intervista-alla-giuria-delleaa-2021-bulgaria-3",
  "dubai-schokolade-die-illusion-die-auch-du-probieren-willst-at": "dubai-chocolate-lillusione-che-anche-tu-vorrai-provare",
  "wer-war-vincent-van-gogh-das-leben-eines-genies-at": "chi-era-vincent-van-gogh-la-vita-di-un-genio-2",
  "beruehmte-kuenstlerinnen-wegbereiterinnen-der-kunstgeschichte-at": "artiste-famose-pioniere-della-storia-dellarte-2",
  "bauhaus-design-geschichte-und-einfluss-der-moderne-at": "bauhaus-design-storia-e-influenza-del-modernismo",
  "entdecke-sensory-art-mit-den-okto-sets-at": "scopri-la-sensory-art-con-i-set-okto-3",
  "sicher-bunt-und-unterhaltsam-warum-ungiftige-mucki-fingerfarben-ideal-fuer-kinder-sind-at": "sicuri-colorati-e-divertenti-perche-i-colori-a-dita-mucki-so",
  "das-traum-kinderzimmer-wie-schafft-man-einen-ort-zum-spielen-und-kreativen-entfalten-at": "la-cameretta-dei-sogni-come-creare-un-luogo-per-giocare-e-da-2",
  "malen-mit-kindern-froehliche-und-bunte-steine-at": "dipingere-con-i-bambini-sassi-allegri-e-colorati-2",
  "tipps-fuer-kreative-geschenke-fuer-kinder-at": "consigli-per-regali-creativi-per-bambini-3",
  "malen-mit-kindern-steine-als-ostereier-at": "dipingere-con-i-bambini-sassi-come-uova-di-pasqua-3",
  "geniessen-sie-den-sommer-mit-kindern-und-strassenmalkreide-at": "goditi-lestate-con-i-bambini-e-i-gessetti-da-marciapiede-2",
  "5-tipps-wie-sie-die-haeusliche-quarantaene-mit-kindern-meistern-at": "5-consigli-per-gestire-la-quarantena-domestica-con-i-bambini",
  "kinder-wegen-quarantaene-zu-hause-wir-wissen-wie-man-sie-kreativ-beschaeftigt-at": "bambini-a-casa-per-la-quarantena-sappiamo-come-tenerli-occup-2",
  "hurra-die-schule-geht-los-kuenstlerbedarf-fuer-gross-und-klein-at": "evviva-la-scuola-ricomincia-materiale-artistico-per-grandi-e",
  "malen-mit-kindern-kreative-weihnachten-at": "dipingere-con-i-bambini-natale-creativo-2"
};
  var COLLECTION_HANDLES_IT = {
  "frontpage": "pagina-iniziale",
  "novinky": "notizia",
  "400-tipov-na-darcek": "400-idee-regalo",
  "specialna-ponuka": "offerta-speciale",
  "bestsellery": "i-piu-venduti",
  "svadba": "nozze",
  "vianoce": "natale",
  "valentin": "san-valentino",
  "velka-noc": "pasqua",
  "darcekove-poukazy": "buoni-regalo",
  "malovanie-podla-cisel": "dipingere-con-i-numeri",
  "pre-deti": "per-bambini",
  "pre-zaciatocnikov": "per-principianti",
  "pre-stredne-pokrocilych": "per-studenti-di-livello-intermedio",
  "pre-pokrocilych": "per-avanzati",
  "malovanie-podla-cisel-z-fotky": "dipingere-con-i-numeri-da-una-foto",
  "umelecke-potreby": "materiali-artistici",
  "maliarske-platna": "dipingere-tele",
  "maliarske-platno-na-rame": "tela-su-telaio",
  "maliarske-platno-eco": "tela-ecologica",
  "specialne-maliarske-platno": "tela-speciale-per-pittura",
  "platno-na-lepenke": "tela-su-cartone",
  "platno-na-rolke-metraz": "tela-su-rotolo-al-metro",
  "listy-ramy-prislusenstvo": "modanature-cornici-accessori",
  "vyroba-reprodukcii": "produzione-di-riproduzione",
  "maliarske-stojany": "cavalletti-per-dipingere",
  "maliarske-stojany-stolove": "supporti-da-tavolo",
  "maliarske-stojany-atelierove": "supporti-da-studio",
  "polne-stojany-exterierove": "spalti-da-campo-allaperto",
  "dosky-na-stojan": "piatti-di-supporto",
  "stetce": "spazzole",
  "sady-stetcov": "set-di-pennelli",
  "gulate-stetce": "spazzole-rotonde",
  "ploche-stetce": "pennelli-piatti",
  "stetce-na-podklad-a-sepsovanie": "pennelli-per-fondotinta-e-contouring",
  "spachtle-a-maliarske-noze": "spatole-e-coltelli-per-pittura",
  "stetce-na-nechty-a-make-up": "pennelli-per-unghie-e-trucco-2",
  "palety-a-pomocky": "tavolozze-e-materiali-artistici",
  "maliarske-palety": "tavolozze-di-colori",
  "nadobky-na-miesanie-farieb": "contenitori-per-miscelare-la-vernice",
  "dalsie-pomocky": "altri-strumenti",
  "papiere-a-vykresy": "documenti-e-disegni",
  "bloky-papierov-vykresy": "blocchi-di-carta-disegni",
  "ramy-pasparty": "cornici-supporti",
  "baliaci-material-pre-umelcov": "materiale-di-imballaggio-per-artisti",
  "zapisniky-diare": "quaderni-diari",
  "farby-a-pripravky": "vernici-e-preparati",
  "akrylove-farby": "colori-acrilici",
  "akryl-pre-umelcov": "acrilico-per-artisti",
  "sady-akrylovych-farieb": "set-di-colori-acrilici",
  "hobby-akryl": "acrilico-per-hobby",
  "pripravky-pre-akryl": "preparazioni-per-acrilico",
  "akrylove-fixy": "pennarelli-acrilici",
  "olejove-farby": "colori-a-olio",
  "olejove-farby-pre-umelcov": "colori-a-olio-per-artisti",
  "sady-olejovych-farieb": "set-di-colori-a-olio",
  "pripravky-pre-olejomalbu": "preparazioni-per-la-pittura-a-olio",
  "akvarelove-farby": "colori-ad-acquerello",
  "gvasove-a-temperove-farby": "colori-a-guazzo-e-tempera",
  "airbrush": "aerografo",
  "hobby-farby": "vernici-per-hobby",
  "exterierove-farby": "colori-esterni",
  "farby-na-textil": "vernici-tessili",
  "farby-na-sklo": "vernici-per-vetro",
  "farby-na-keramiku": "vernici-ceramiche",
  "farby-na-hodvab": "tinture-per-seta",
  "farby-na-tvar": "pitture-per-il-viso",
  "farba-graficka": "colore-grafico",
  "farby-v-spreji-a-fixky": "vernici-spray-e-pennarelli",
  "atrament-a-tuse": "inchiostro-e-inchiostro",
  "pripravky-pre-malbu": "preparazioni-per-la-pittura",
  "finalne-zaverecne-pripravky": "ultimi-preparativi",
  "pripravky-pre-podklad": "preparazioni-del-substrato",
  "pripravky-pre-olejomalbu-1": "preparazioni-per-la-pittura-a-olio-2",
  "media-pre-akryl": "supporti-acrilici",
  "efektove-pasty-a-gely": "paste-e-gel-ad-effetto",
  "kreativne-potreby": "bisogni-creativi",
  "hobby-potreby": "forniture-per-hobby",
  "dekupaz-servitkovanie": "decoupage-realizzazione-di-tovaglioli",
  "malovanie-na-textil": "pittura-tessile",
  "malovanie-na-sklo": "pittura-su-vetro-e-porcellana",
  "malovanie-na-keramiku": "pittura-su-ceramica",
  "malovanie-na-hodvab": "pittura-su-seta",
  "pletenie-hackovanie-vysivanie": "maglia-uncinetto-ricamo",
  "modelovanie": "modellazione",
  "kaligrafia": "calligrafia",
  "linoryt-graficka-technika": "linoleografia-tecnica-grafica",
  "pozlacovanie-a-patinovanie": "doratura-e-patinatura",
  "vyroba-mydla-a-sviecok": "fabbricazione-di-saponi-e-candele",
  "zivica-odlievanie": "resina-colata",
  "vyroba-sperkov": "creazione-di-gioielli",
  "mramorovanie": "marmorizzazione",
  "svadobne-dekoracie": "decorazioni-per-matrimoni",
  "malovanie-na-tvar": "pittura-del-viso",
  "filcovanie-plstenie": "infeltrimento-infeltrimento",
  "malovanie-podla-cisel-1": "dipingere-con-i-numeri-1",
  "skrabacie-obrazky": "immagini-da-grattare",
  "kreativne-komponenty": "componenti-creativi",
  "drevo": "legna",
  "polystyren": "polistirolo",
  "textil-a-hodvab": "tessili-e-seta",
  "stuhy-girlandy-organzy": "nastri-ghirlande-organza",
  "filtre-glitre-pierka": "paillettes-glitter-piume",
  "dekoracny-material": "materiale-decorativo",
  "sablony-na-malovanie": "stencil-per-pittura",
  "polymerove-hmoty": "materiali-polimerici",
  "kontury": "contorni",
  "peciatky": "francobolli",
  "hobby-lepidla": "colle-per-hobby",
  "prutie-a-supolie": "vimini-e-lavori-in-vimini",
  "nastroje": "utensili",
  "rozne-pomocky": "vari-strumenti",
  "kreativne-potreby-pre-deti": "materiali-creativi-per-bambini",
  "hracky-pre-deti": "giocattoli-per-bambini",
  "handmade-byvanie": "alloggiamento-fatto-a-mano",
  "kreslenie": "disegno",
  "ceruzky-a-uhliky": "matite-e-carboncini",
  "farbicky": "pastelli",
  "markery-fixy": "marcatori-marcatori",
  "pastely": "pastelli-1",
  "olejove-pastely": "pastelli-a-olio",
  "suche-pastely": "pastelli-secchi",
  "voskove-pastely": "pastelli-a-cera",
  "kaligrafia-a-hand-lettering": "calligrafia-e-lettering-a-mano",
  "skicovacie-bloky": "blocchi-da-disegno",
  "technicke-kreslenie": "disegno-tecnico",
  "technicke-pera-a-ceruzky": "penne-e-matite-tecniche",
  "technicke-pravitka-a-sablony": "righelli-e-modelli-tecnici",
  "papier-pauzovaci-a-milimetrovy": "carta-da-lucido-e-carta-millimetrata",
  "dosky-na-rysovanie": "tavoli-da-disegno",
  "tubusy-a-tasky-na-vykresy": "tubi-e-sacchetti-da-disegno",
  "nase-znacky": "i-nostri-marchi",
  "rosa": "rugiada",
  "jovi": "giovi",
  "airplac": "aereoporto",
  "kompozit": "composito",
  "posca": "inviare",
  "daniel-smith": "daniele-smith",
  "papas-clay": "largilla-di-papa",
  "st-petersburg-nevskaya-palitra": "san-pietroburgo-nevskaya-palitra",
  "chameleon": "camaleonte",
  "winsor-newton": "winsor-e-amp-newton",
  "lukas": "luca",
  "dp-craft": "artigianato-dp",
  "ghiant": "gigante",
  "kreul": "corona",
  "profil": "profilo",
  "lefranc-bourgeois": "lefranc-e-amp-bourgeois",
  "royal-langnickel": "royal-e-amp-langnickel",
  "nerchau": "nercau",
  "royal-talens": "talenti-reali",
  "knihy-a-inspiracie": "libri-e-ispirazioni",
  "knihy-kreslenie-a-malovanie": "libri-disegno-e-pittura",
  "skolske-potreby": "materiale-scolastico",
  "kreativne-sety": "set-creativi",
  "servitky-papiere-na-decoupage": "tovaglioli-carte-per-decoupage",
  "laky-a-lepidla-na-decoupage": "vernici-e-colle-per-decoupage",
  "komponenty-pre-decoupage": "componenti-per-decoupage",
  "dalsie-pomocky-pre-decoupage": "altri-strumenti-per-il-decoupage",
  "okruhle-platno": "tela-rotonda",
  "leonardo-collection": "collezione-leonardo",
  "golden": "doro",
  "zlava": "sconto-2",
  "maliarske-platno-profi": "tela-pittorica-profi",
  "artmie-r": "artmie-1",
  "modelovanie-a-odlievanie": "modellazione-e-colata",
  "malovanie-na-povrchy": "pittura-su-superfici",
  "textil-a-rucne-prace": "tessili-e-artigianato",
  "papier-scrapbook-dekupaz": "carta-scrapbooking-e-decoupage",
  "dekoracny-material-skupina": "materiale-decorativo-1",
  "kreativne-pre-deti-skupina": "creativita-per-bambini",
  "sezonne-tvorenie": "creazioni-stagionali",
  "nastroje-a-lepidla": "strumenti-e-colle",
  "kreativne-sady-a-sety": "set-creativi-1",
  "umelecke-farby": "colori-artistici",
  "farby-na-povrchy": "colori-per-superfici",
  "pripravky-a-laky": "ausiliari-e-vernici",
  "maliarske-platna-skupina": "tele-per-dipingere",
  "papiere-a-bloky": "carta-e-blocchi",
  "ramy-a-prislusenstvo": "cornici-e-accessori",
  "ceruzky-a-grafika": "matite-e-grafica",
  "pastely-a-fixy": "pastelli-e-pennarelli",
  "papiere-a-pomocky-kreslenie": "carta-e-strumenti-per-il-disegno",
  "black-friday": "black-friday-percento",
  "maliarske-stojany-vsetky-typy": "cavalletti-da-pittore-tutti-i-tipi",
  "umelecke-stetce-a-pomocky": "pennelli-artistici-e-accessori",
  "papas-clay-kolekcia": "papas-clay-collezione",
  "knihy-pre-tvorcov": "libri-per-creativi",
  "media-pre-olejomalbu": "medium-per-pittura-a-olio",
  "400-geschenkideen-de": "400-idee-regalo-1",
  "acryl-fuer-kuenstler-de": "acrilici-per-artisti",
  "acrylfarben-de": "colori-acrilici-1",
  "aquarellfarben-fuer-kuenstler-de": "acquerelli-per-artisti",
  "artmie-de": "artmie-5",
  "atelierstaffeleien-de": "cavalletti-da-studio",
  "tinte-und-tusche-de": "inchiostri-e-chine",
  "verpackungsmaterial-fuer-kuenstler-de": "materiale-da-imballaggio-per-artisti",
  "bestseller-de": "bestseller-1",
  "bob-ross-de": "bob-ross-3",
  "bruynzeel-de": "bruynzeel-3",
  "cernit-de": "cernit-3",
  "bleistifte-und-grafik-de": "matite-e-grafica-1",
  "bleistifte-und-zeichenkohle-de": "matite-e-carboncini-1",
  "colorino-de": "colorino-3",
  "copic-de": "copic-3",
  "da-vinci-de": "da-vinci-3",
  "daler-rowney-de": "daler-rowney-3",
  "weiteres-zubehoer-fuer-decoupage-de": "altri-accessori-per-decoupage",
  "geschenkgutscheine-de": "buoni-regalo-1",
  "dekorationsmaterial-de": "materiale-decorativo-2",
  "staffeleibretter-de": "tavolette-per-cavalletto",
  "holz-de": "legno",
  "edding-de": "edding-3",
  "outdoor-farben-de": "colori-per-esterni",
  "faber-castell-de": "faber-castell-4",
  "fabriano-de": "fabriano-3",
  "farben-und-hilfsmittel-de": "colori-e-ausiliari",
  "seidenmalfarben-de": "colori-per-seta",
  "keramikfarben-de": "colori-per-ceramica",
  "glasfarben-de": "colori-per-vetro",
  "textilfarben-de": "colori-per-tessuti",
  "schminkfarben-de": "colori-per-il-trucco",
  "spruehfarben-und-marker-de": "vernici-spray-e-marker",
  "buntstifte-de": "matite-colorate",
  "filzen-de": "infeltrire",
  "filter-glitter-federn-de": "filtri-glitter-piume",
  "finale-abschlussprodukte-de": "finale-prodotti-in-esaurimento",
  "giotto-de": "giotto-3",
  "rundpinsel-de": "pennelli-tondi",
  "gouache-und-temperafarben-de": "colori-a-guazzo-e-a-tempera",
  "hahnemuehle-de": "hahnemuhle-3",
  "handmade-wohnen-de": "decorazioni-fatte-a-mano",
  "hobbyfarben-de": "colori-per-hobby",
  "hobbyleime-de": "colle-per-hobby-1",
  "hobbybedarf-de": "articoli-per-hobby",
  "holbein-de": "holbein-3",
  "startseite-de": "pagina-iniziale-1",
  "jesmonite-de": "jesmonite-3",
  "kalligraphie-de": "calligrafia-1",
  "kalligraphie-und-hand-lettering-de": "calligrafia-e-hand-lettering",
  "kamenskaya-de": "kamenskaya-3",
  "koh-i-noor-de": "koh-i-noor-3",
  "decoupage-komponenten-de": "componenti-per-decoupage-1",
  "komposit-de": "komposit-1",
  "konturen-de": "contorni-1",
  "kreativspielzeug-de": "giocattoli-creativi",
  "kreativkomponenten-de": "componenti-creativi-1",
  "kreativbedarf-de": "articoli-per-il-fai-da-te",
  "kreativbedarf-fuer-kinder-de": "articoli-per-belle-arti-per-bambini",
  "kreativ-sets-de": "set-creativi-2",
  "kuenstler-zeichenbedarf-de": "materiale-per-disegno-artistico",
  "decoupage-lacke-und-leime-de": "vernici-e-colle-per-decoupage-1",
  "linolschnitt-grafische-technik-de": "linoleografia-tecnica-grafica-1",
  "liquitex-de": "liquitex-4",
  "leisten-rahmen-zubehoer-de": "listelli-cornici-accessori",
  "malerpaletten-de": "tavolozze",
  "leinwaende-de": "tele",
  "leinwand-eco-de": "tela-eco",
  "leinwand-auf-keilrahmen-de": "tela-su-telaio-1",
  "leinwand-profi-de": "tela-profi",
  "staffeleien-de": "cavalletti",
  "seidenmalerei-de": "pittura-su-seta-1",
  "malen-auf-keramik-de": "pittura-su-ceramica-1",
  "malen-auf-oberflaechen-de": "pittura-su-superfici-1",
  "malen-auf-glas-und-porzellan-de": "dipingere-su-vetro-e-porcellana",
  "malen-auf-textil-de": "dipingere-su-tessuti",
  "kinderschminken-de": "truccabimbi",
  "malen-nach-zahlen-vom-foto-de": "dipingere-con-i-numeri-da-foto",
  "marker-filzstifte-de": "marker-pennarelli",
  "medien-fuer-acryl-de": "medium-per-acrilici",
  "modellieren-de": "modellazione-1",
  "modellieren-und-giessen-de": "modellazione-e-colata-1",
  "molotow-de": "molotow-3",
  "marmorieren-de": "marmorizzazione-1",
  "unsere-marken-de": "i-nostri-marchi-1",
  "werkzeuge-de": "strumenti",
  "werkzeuge-und-klebstoffe-de": "strumenti-e-adesivi",
  "neuheiten-de": "novita",
  "rundes-leinwand-de": "tela-rotonda-1",
  "okto-de": "okto-4",
  "oelfarben-de": "colori-a-olio-1",
  "oelpastelle-de": "pastelli-a-olio-1",
  "paletten-und-hilfsmittel-de": "tavolozze-e-ausiliari",
  "panart-de": "panart-4",
  "papier-de": "carta",
  "papiere-und-bloecke-de": "carte-e-blocchi",
  "papilora-art-de": "papilora-art-4",
  "pastelle-und-filzstifte-de": "pastelli-e-pennarelli-1",
  "pebeo-de": "pebeo-4",
  "stempel-de": "timbri",
  "pentart-de": "pentart-4",
  "leinwand-auf-karton-de": "tela-su-cartone-1",
  "leinwand-auf-rolle-meterware-de": "tela-in-rotolo-al-metro",
  "stricken-haekeln-sticken-de": "lavoro-a-maglia-uncinetto-ricamo",
  "flachpinsel-de": "pennelli-piatti-1",
  "feldstaffeleien-fuer-den-aussenbereich-de": "cavalletti-da-campagna-per-esterni",
  "polymere-modelliermassen-de": "paste-modellabili-polimeriche",
  "styropor-de": "polistirolo-1",
  "airbrush-zubehoer-de": "accessori-per-aerografo",
  "vergolden-und-patinieren-de": "doratura-e-patinatura-1",
  "fuer-kinder-de": "per-bambini-1",
  "fuer-fortgeschrittene-de": "per-esperti",
  "fuer-anfaenger-de": "per-principianti-1",
  "praeparate-und-lacke-de": "preparati-e-vernici",
  "praeparate-fuer-acryl-de": "preparati-per-acrilici",
  "praeparate-fuer-oelmalerei-de": "preparati-per-pittura-a-olio",
  "praeparate-fuer-den-untergrund-de": "preparati-per-supporti",
  "weide-und-maisblaetter-de": "salice-e-foglie-di-mais",
  "rahmen-passepartouts-de": "cornici-passepartout",
  "roubloff-de": "roubloff-3",
  "verschiedene-hilfsmittel-de": "vari-ausili",
  "schablonen-zum-malen-de": "stencil-per-dipingere",
  "acrylfarben-sets-de": "set-di-colori-acrilici-1",
  "malen-nach-zahlen-sets-de": "set-dipingere-con-i-numeri",
  "oelfarben-sets-de": "set-di-colori-a-olio-1",
  "pinsel-sets-de": "set-di-pennelli-1",
  "sakura-de": "sakura-3",
  "schmincke-de": "schmincke-3",
  "scrapbooking-de": "scrapbooking-4",
  "saisonales-basteln-de": "artigianato-stagionale",
  "skizzenbuch-de": "album-da-disegno",
  "schulbedarf-de": "articoli-scolastici",
  "kratzbilder-de": "quadri-da-grattare",
  "spachteln-und-malmesser-de": "spatole-e-coltelli-da-pittura",
  "sonderangebot-de": "promozione",
  "nagel-und-make-up-pinsel-de": "pennelli-per-unghie-e-make-up",
  "tischstaffeleien-de": "cavalletti-da-tavolo",
  "baender-girlanden-organzas-de": "nastri-ghirlande-organza-1",
  "trockenpastelle-de": "pastelli-secchi-1",
  "hochzeit-de": "matrimonio",
  "hochzeitsdekorationen-de": "decorazioni-per-matrimoni-1",
  "technisches-zeichnen-de": "disegno-tecnico-1",
  "technische-stifte-und-bleistifte-de": "penne-tecniche-e-matite",
  "technische-lineale-und-schablonen-de": "righelli-tecnici-e-dime",
  "textil-und-seide-de": "tessuti-e-seta",
  "textil-und-handarbeiten-de": "tessili-e-lavori-manuali",
  "zeichnungsrollen-und-taschen-de": "tubi-e-borse-per-disegni",
  "kuenstlerfarben-de": "colori-artistici-1",
  "kuenstlerpastelle-zum-zeichnen-de": "pastelli-artistici-per-disegnare",
  "kuenstlerbedarf-de": "materiale-artistico",
  "umton-de": "umton-3",
  "valentinstag-de": "san-valentino-1",
  "ostern-de": "pasqua-1",
  "weihnachten-de": "natale-1",
  "wachspastelle-de": "pastelli-a-cera-1",
  "seifen-und-kerzenherstellung-de": "produzione-di-saponi-e-candele",
  "reproduktionsherstellung-de": "riproduzione-artistica",
  "schmuckherstellung-de": "creazione-di-gioielli-1",
  "notizbuecher-kalender-de": "quaderni-calendari",
  "harz-giessen-de": "resina-colata-1",
  "medien-fuer-oelmalerei-de": "medium-per-pittura-a-olio-1",
  "kreslarske-potreby": "articoli-per-il-disegno",
  "fuer-fortgeschrittene-1-de": "per-esperti-2",
  "spezielle-malgruende-de": "supporti-speciali-per-pittura",
  "leisten-rahmen-zubehoer-1-de": "listelli-cornici-accessori-2",
  "rundpinsel-1-de": "pennelli-tondi-2",
  "grundier-und-streichpinsel-de": "pennelli-per-fondi-e-stesura",
  "mischpaletten-und-naepfchen-de": "tavolozze-e-vaschette",
  "weiteres-zubehoer-de": "altri-accessori",
  "bloecke-und-zeichenpapier-de": "blocchi-e-carta-da-disegno",
  "hobby-acrylfarben-de": "colori-acrilici-hobby",
  "acrylmarker-1-de": "marker-acrilici",
  "kuenstler-oelfarben-de": "colori-a-olio-professionali",
  "druckfarben-de": "colori-per-stampa",
  "malmittel-de": "ausiliari-per-pittura",
  "medien-und-firnisse-fuer-oelmalerei-de": "medium-e-vernici-per-pittura-a-olio",
  "effektpasten-und-gele-1-de": "paste-e-gel-effetto",
  "decoupage-serviettentechnik-de": "decoupage-tecnica-del-tovagliolo",
  "malen-nach-zahlen-1-de": "dipingere-con-i-numeri-2",
  "zeichenbedarf-de": "articoli-per-il-disegno-1",
  "transparent-und-millimeterpapier-de": "carta-da-lucido-e-carta-millimetrata-1",
  "zeichenplatten-de": "tavoli-da-disegno-1",
  "buecher-und-inspiration-de": "libri-e-ispirazione",
  "kreativsets-de": "set-creativi-3",
  "servietten-und-decoupage-papiere-de": "tovaglioli-e-carte-per-decoupage",
  "papier-scrapbooking-und-decoupage-1-de": "carta-scrapbooking-e-decoupage-1",
  "dekorationsmaterial-1-de": "materiale-decorativo-3",
  "kreatives-fuer-kinder-1-de": "creativita-per-bambini-1",
  "oberflaechenfarben-1-de": "colori-per-superfici-1",
  "malleinwaende-de": "tele-per-dipingere-1",
  "papier-zeichenbedarf-de": "carta-e-materiale-da-disegno",
  "staffeleien-alle-typen-de": "cavalletti-tutti-i-tipi",
  "kuenstlerpinsel-zubehoer-de": "pennelli-artistici-e-accessori-1",
  "papas-clay-kollektion-de": "papas-clay-collezione-1",
  "buecher-fuer-kreative-1-de": "libri-per-creativi-1",
  "zeichenbedarf-1-de": "materiale-da-disegno",
  "linoldruck-druckfarben-de": "stampa-linoleografica-inchiostri",
  "lacke-fixative-de": "vernici-fissativi",
  "nevskaya-palitra-de": "nevskaya-palitra-1",
  "homepage-curated": "consigliati-top-picks",
  "buecher-zeichnen-und-malen-de": "libri-disegno-e-pittura-1",
  "startseite-kuratiert-de": "home-page-curata",
  "sale-de": "promozione-2",
  "400-geschenkideen-at": "400-idee-regalo-2",
  "airplac-at": "airplac-3",
  "acryl-fuer-kuenstler-at": "acrilici-per-artisti-2",
  "acrylfarben-at": "colori-acrilici-2",
  "aquarellfarben-fuer-kuenstler-at": "acquerelli-per-artisti-2",
  "artmie-at": "artmie-6",
  "atelierstaffeleien-at": "cavalletti-da-studio-2",
  "tinte-und-tusche-at": "inchiostri-e-chine-2",
  "verpackungsmaterial-fuer-kuenstler-at": "materiale-da-imballaggio-per-artisti-2",
  "bestseller-at": "bestseller-2",
  "black-friday-at": "black-friday-3",
  "bob-ross-at": "bob-ross-4",
  "bruynzeel-at": "bruynzeel-4",
  "cernit-at": "cernit-4",
  "bleistifte-und-grafik-at": "matite-e-grafica-2",
  "bleistifte-und-zeichenkohle-at": "matite-e-carboncini-2",
  "chameleon-at": "chameleon-3",
  "colorino-at": "colorino-4",
  "copic-at": "copic-4",
  "da-vinci-at": "da-vinci-4",
  "daler-rowney-at": "daler-rowney-4",
  "weiteres-zubehoer-fuer-decoupage-at": "altri-accessori-per-decoupage-2",
  "daniel-smith-at": "daniel-smith-3",
  "geschenkgutscheine-at": "buoni-regalo-2",
  "dekorationsmaterial-at": "materiale-decorativo-4",
  "staffeleibretter-at": "tavolette-per-cavalletto-2",
  "dp-craft-at": "dp-craft-3",
  "holz-at": "legno-2",
  "edding-at": "edding-4",
  "outdoor-farben-at": "colori-per-esterni-2",
  "faber-castell-at": "faber-castell-5",
  "fabriano-at": "fabriano-4",
  "farben-und-hilfsmittel-at": "colori-e-ausiliari-2",
  "seidenmalfarben-at": "colori-per-seta-2",
  "keramikfarben-at": "colori-per-ceramica-2",
  "glasfarben-at": "colori-per-vetro-2",
  "textilfarben-at": "colori-per-tessuti-2",
  "schminkfarben-at": "colori-per-trucco",
  "spruehfarben-und-marker-at": "vernici-spray-e-marker-2",
  "buntstifte-at": "matite-colorate-2",
  "filzen-at": "infeltrire-2",
  "filter-glitter-federn-at": "feltri-glitter-piume",
  "finale-abschlussprodukte-at": "finale-prodotti-in-esaurimento-2",
  "ghiant-at": "ghiant-3",
  "giotto-at": "giotto-4",
  "golden-at": "golden-3",
  "rundpinsel-at": "pennelli-tondi-3",
  "gouache-und-temperafarben-at": "colori-a-guazzo-e-a-tempera-2",
  "hahnemuehle-at": "hahnemuhle-4",
  "handmade-wohnen-at": "decorazioni-fatte-a-mano-2",
  "hobbyfarben-at": "colori-per-hobby-2",
  "hobbyleime-at": "colle-per-hobby-2",
  "hobbybedarf-at": "articoli-per-hobby-2",
  "holbein-at": "holbein-4",
  "startseite-at": "pagina-iniziale-2",
  "jesmonite-at": "jesmonite-4",
  "jovi-at": "jovi-3",
  "kalligraphie-at": "calligrafia-2",
  "kalligraphie-und-hand-lettering-at": "calligrafia-e-hand-lettering-2",
  "kamenskaya-at": "kamenskaya-4",
  "koh-i-noor-at": "koh-i-noor-4",
  "decoupage-komponenten-at": "componenti-per-decoupage-2",
  "komposit-at": "komposit-3",
  "konturen-at": "contorni-2",
  "kreativspielzeug-at": "giocattoli-creativi-2",
  "kreativkomponenten-at": "componenti-creativi-2",
  "kreativbedarf-at": "materiale-creativo",
  "kreativbedarf-fuer-kinder-at": "materiale-creativo-per-bambini",
  "kreativ-sets-at": "set-creativi-4",
  "kuenstler-zeichenbedarf-at": "materiale-per-disegno-artistico-2",
  "kreul-at": "kreul-3",
  "decoupage-lacke-und-leime-at": "vernici-e-colle-per-decoupage-2",
  "lefranc-bourgeois-at": "lefranc-bourgeois-3",
  "leonardo-collection-at": "leonardo-collection-3",
  "linolschnitt-grafische-technik-at": "linoleografia-tecnica-grafica-2",
  "liquitex-at": "liquitex-5",
  "leisten-rahmen-zubehoer-at": "listelli-cornici-accessori-3",
  "lukas-at": "lukas-3",
  "malerpaletten-at": "tavolozze-2",
  "leinwaende-at": "tele-2",
  "leinwand-eco-at": "tela-eco-2",
  "leinwand-auf-keilrahmen-at": "tela-su-telaio-2",
  "leinwand-profi-at": "tela-profi-2",
  "staffeleien-at": "cavalletti-2",
  "seidenmalerei-at": "pittura-su-seta-2",
  "malen-auf-keramik-at": "pittura-su-ceramica-2",
  "malen-auf-oberflaechen-at": "pittura-su-superfici-2",
  "malen-auf-glas-und-porzellan-at": "pittura-su-vetro-e-porcellana-1",
  "malen-auf-textil-at": "pittura-su-tessuto",
  "kinderschminken-at": "truccabimbi-2",
  "malen-nach-zahlen-vom-foto-at": "dipingere-con-i-numeri-da-foto-2",
  "marker-filzstifte-at": "marker-pennarelli-2",
  "medien-fuer-acryl-at": "medium-per-acrilici-2",
  "modellieren-at": "modellazione-2",
  "modellieren-und-giessen-at": "modellazione-e-colata-2",
  "molotow-at": "molotow-4",
  "marmorieren-at": "marmorizzazione-2",
  "unsere-marken-at": "i-nostri-marchi-2",
  "werkzeuge-at": "strumenti-2",
  "werkzeuge-und-klebstoffe-at": "strumenti-e-adesivi-2",
  "nerchau-at": "nerchau-3",
  "neuheiten-at": "novita-2",
  "rundes-leinwand-at": "tela-rotonda-2",
  "okto-at": "okto-5",
  "oelfarben-at": "colori-a-olio-2",
  "oelpastelle-at": "pastelli-a-olio-2",
  "paletten-und-hilfsmittel-at": "tavolozze-e-accessori",
  "panart-at": "panart-5",
  "papa-s-clay-at": "papas-clay-3",
  "papier-at": "carta-2",
  "papiere-und-bloecke-at": "carte-e-blocchi-2",
  "papilora-art-at": "papilora-art-5",
  "pastelle-und-filzstifte-at": "pastelli-e-pennarelli-2",
  "pebeo-at": "pebeo-5",
  "stempel-at": "timbri-2",
  "pentart-at": "pentart-5",
  "leinwand-auf-karton-at": "tela-su-cartone-2",
  "leinwand-auf-rolle-meterware-at": "tela-in-rotolo-al-metro-2",
  "stricken-haekeln-sticken-at": "lavori-a-maglia-uncinetto-ricamo",
  "flachpinsel-at": "pennelli-piatti-2",
  "feldstaffeleien-fuer-den-aussenbereich-at": "cavalletti-da-campagna-per-esterni-2",
  "polymere-modelliermassen-at": "paste-modellabili-polimeriche-2",
  "styropor-at": "polistirolo-2",
  "posca-at": "posca-3",
  "airbrush-zubehoer-at": "accessori-per-aerografo-2",
  "vergolden-und-patinieren-at": "doratura-e-patinatura-2",
  "fuer-kinder-at": "per-bambini-2",
  "fuer-fortgeschrittene-at": "per-esperti-3",
  "fuer-anfaenger-at": "per-principianti-2",
  "praeparate-und-lacke-at": "preparati-e-vernici-2",
  "praeparate-fuer-acryl-at": "preparati-per-acrilici-2",
  "praeparate-fuer-oelmalerei-at": "preparati-per-pittura-a-olio-2",
  "praeparate-fuer-den-untergrund-at": "preparati-per-il-fondo",
  "profil-at": "profil-4",
  "weide-und-maisblaetter-at": "foglie-di-salice-e-mais",
  "rahmen-passepartouts-at": "cornici-passepartout-2",
  "rosa-at": "rosa-3",
  "roubloff-at": "roubloff-4",
  "royal-langnickel-at": "royal-langnickel-3",
  "royal-talens-at": "royal-talens-3",
  "verschiedene-hilfsmittel-at": "vari-accessori",
  "schablonen-zum-malen-at": "stencil-per-dipingere-2",
  "acrylfarben-sets-at": "set-di-colori-acrilici-2",
  "malen-nach-zahlen-sets-at": "set-dipingere-con-i-numeri-2",
  "oelfarben-sets-at": "set-di-colori-a-olio-2",
  "pinsel-sets-at": "set-di-pennelli-2",
  "sakura-at": "sakura-4",
  "schmincke-at": "schmincke-4",
  "scrapbooking-at": "scrapbooking-5",
  "saisonales-basteln-at": "articoli-stagionali",
  "skizzenbuch-at": "album-da-disegno-2",
  "schulbedarf-at": "articoli-scolastici-2",
  "kratzbilder-at": "quadri-da-grattare-2",
  "spachteln-und-malmesser-at": "spatole-e-coltelli-da-pittura-2",
  "sonderangebot-at": "offerta-speciale-1",
  "st-petersburg-nevskaya-palitra-at": "st-petersburg-nevskaya-palitra-2",
  "nagel-und-make-up-pinsel-at": "pennelli-per-unghie-e-make-up-2",
  "tischstaffeleien-at": "cavalletti-da-tavolo-2",
  "baender-girlanden-organzas-at": "nastri-ghirlande-organza-2",
  "trockenpastelle-at": "pastelli-secchi-2",
  "hochzeit-at": "matrimonio-2",
  "hochzeitsdekorationen-at": "decorazioni-per-matrimoni-2",
  "technisches-zeichnen-at": "disegno-tecnico-2",
  "technische-stifte-und-bleistifte-at": "penne-tecniche-e-matite-2",
  "technische-lineale-und-schablonen-at": "righelli-tecnici-e-dime-2",
  "textil-und-seide-at": "tessuti-e-seta-2",
  "textil-und-handarbeiten-at": "tessili-e-artigianato-1",
  "zeichnungsrollen-und-taschen-at": "portadisegni-e-cartelle",
  "kuenstlerfarben-at": "colori-artistici-2",
  "kuenstlerpastelle-zum-zeichnen-at": "pastelli-artistici-per-disegno",
  "kuenstlerbedarf-at": "materiale-artistico-2",
  "umton-at": "umton-4",
  "valentinstag-at": "san-valentino-2",
  "ostern-at": "pasqua-2",
  "weihnachten-at": "natale-2",
  "wachspastelle-at": "pastelli-a-cera-2",
  "seifen-und-kerzenherstellung-at": "produzione-di-saponi-e-candele-2",
  "reproduktionsherstellung-at": "riproduzione-artistica-2",
  "schmuckherstellung-at": "creazione-di-gioielli-2",
  "winsor-newton-at": "winsor-newton-3",
  "notizbuecher-kalender-at": "quaderni-calendari-2",
  "harz-giessen-at": "resina-colata-2",
  "medien-fuer-oelmalerei-at": "medium-per-pittura-a-olio-2",
  "fuer-fortgeschrittene-1-at": "per-esperti-4",
  "spezielle-malgruende-at": "supporti-speciali-per-dipingere",
  "leisten-rahmen-zubehoer-1-at": "listelli-cornici-accessori-4",
  "rundpinsel-1-at": "pennelli-tondi-4",
  "grundier-und-streichpinsel-at": "pennelli-per-primer-e-stesura",
  "mischpaletten-und-naepfchen-at": "tavolozze-e-godet",
  "weiteres-zubehoer-at": "altri-accessori-2",
  "bloecke-und-zeichenpapier-at": "blocchi-e-carta-da-disegno-2",
  "hobby-acrylfarben-at": "colori-acrilici-hobby-2",
  "acrylmarker-1-at": "pennarelli-acrilici-1",
  "kuenstler-oelfarben-at": "colori-a-olio-professionali-2",
  "druckfarben-at": "colori-per-stampa-2",
  "malmittel-at": "medium-per-pittura",
  "medien-und-firnisse-fuer-oelmalerei-at": "medium-e-vernici-per-pittura-a-olio-2",
  "effektpasten-und-gele-1-at": "paste-e-gel-effetto-2",
  "decoupage-serviettentechnik-at": "decoupage",
  "malen-nach-zahlen-1-at": "dipingere-con-i-numeri-3",
  "zeichenbedarf-at": "materiale-per-disegno",
  "transparent-und-millimeterpapier-at": "carta-da-lucido-e-carta-millimetrata-2",
  "zeichenplatten-at": "tavoli-da-disegno-2",
  "buecher-und-inspiration-at": "libri-e-ispirazione-2",
  "kreativsets-at": "set-creativi-5",
  "servietten-und-decoupage-papiere-at": "tovaglioli-e-carta-per-decoupage",
  "papier-scrapbooking-und-decoupage-1-at": "carta-scrapbooking-e-decoupage-2",
  "dekorationsmaterial-1-at": "materiale-decorativo-5",
  "kreatives-fuer-kinder-1-at": "creativita-per-bambini-2",
  "oberflaechenfarben-1-at": "colori-per-superfici-2",
  "malleinwaende-at": "tele-per-dipingere-2",
  "papier-zeichenbedarf-at": "carta-e-materiale-da-disegno-2",
  "staffeleien-alle-typen-at": "cavalletti-tutti-i-tipi-2",
  "kuenstlerpinsel-zubehoer-at": "pennelli-artistici-e-accessori-2",
  "papas-clay-kollektion-at": "papas-clay-collezione-2",
  "buecher-fuer-kreative-1-at": "libri-per-creativi-2",
  "zeichenbedarf-1-at": "articoli-per-il-disegno-2",
  "linoldruck-druckfarben-at": "stampa-linoleografica-inchiostri-2",
  "lacke-fixative-at": "vernici-fissativi-2",
  "nevskaya-palitra-at": "nevskaya-palitra-3",
  "buecher-zeichnen-und-malen-at": "libri-disegno-e-pittura-2",
  "startseite-kuratiert-at": "home-page-curata-2",
  "sale-at": "promozione-3"
};
  function rewriteLocalizedHandles() {
    try {
      var anchors = document.querySelectorAll('a[href]');
      for (var i = 0; i < anchors.length; i++) {
        var a = anchors[i];
        var h = a.getAttribute('href');
        if (!h || h.charAt(0) === '#') continue;
        /* Normalize: strip origin if same-host, retain path */
        var p = h;
        if (/^https?:/i.test(h)) {
          try { var u = new URL(h, window.location.origin); if (u.host !== window.location.host) continue; p = u.pathname + u.search + u.hash; } catch (e) { continue; }
        }
        if (p.charAt(0) !== '/') continue;
        /* Match /<locale-prefix>?/(pages|collections|blogs)/<slug>(/<article>)? */
        var m = p.match(/^(\/(?:el-gr|sk-gr|sl-si|sk-si|de-de|de-at|it-it|sk-it)\/)?(pages|collections|blogs)\/([^\/?#]+)(\/([^\/?#]+))?(.*)$/);
        if (!m) continue;
        var prefix = m[1] || '/';
        var type = m[2];
        var slug = m[3];
        var subSlug = m[5];
        var rest = m[6] || '';
        var newSlug = slug, newSub = subSlug;
        if (type === 'pages') {
          if (PAGE_HANDLES_IT[slug]) newSlug = PAGE_HANDLES_IT[slug];
        } else if (type === 'collections') {
          if (COLLECTION_HANDLES_IT[slug]) newSlug = COLLECTION_HANDLES_IT[slug];
        } else if (type === 'blogs') {
          if (BLOG_HANDLES_IT[slug]) newSlug = BLOG_HANDLES_IT[slug];
          if (subSlug && ARTICLE_HANDLES_IT[subSlug]) newSub = ARTICLE_HANDLES_IT[subSlug];
        }
        if (newSlug === slug && newSub === subSlug) continue;
        var newP = prefix + type + '/' + newSlug + (newSub ? '/' + newSub : '') + rest;
        a.setAttribute('href', newP);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteLocalizedHandles);
  else rewriteLocalizedHandles();
  setTimeout(rewriteLocalizedHandles, 500);
  setTimeout(rewriteLocalizedHandles, 1500);
  setTimeout(rewriteLocalizedHandles, 3000);
  /* MutationObserver for lazy-loaded content */
  try { if (window.MutationObserver) { new MutationObserver(function () { rewriteLocalizedHandles(); }).observe(document.documentElement, { childList: true, subtree: true }); } } catch (e) {}
  /* === phase-67-end === */

})();

